/**
 * Spanish (Chile) translations
 */
export const esClTranslations = {
  'whatsappTemplates.title': 'Enviar plantilla de WhatsApp',
  'whatsappTemplates.subtitle':
    'Elige un mensaje aprobado y personalízalo antes de enviarlo.',
  'whatsappTemplates.subtitleCompact': 'Personaliza y envía tu mensaje.',
  'whatsappTemplates.choose': 'Elige una plantilla',
  'whatsappTemplates.chooseHelp':
    'Busca por nombre o por el mensaje que quieres enviar.',
  'whatsappTemplates.chooseHelpCompact': 'Busca por nombre o contenido.',
  'whatsappTemplates.search': 'Buscar plantillas…',
  'whatsappTemplates.language': 'Idioma',
  'whatsappTemplates.category': 'Categoría',
  'whatsappTemplates.allLanguages': 'Todos los idiomas',
  'whatsappTemplates.allCategories': 'Todas las categorías',
  'whatsappTemplates.category.utility': 'Servicio',
  'whatsappTemplates.category.marketing': 'Marketing',
  'whatsappTemplates.category.authentication': 'Autenticación',
  'whatsappTemplates.results': '{count} plantillas',
  'whatsappTemplates.showUnavailable': 'Mostrar no disponibles ({count})',
  'whatsappTemplates.noTextPreview':
    'Esta plantilla no tiene una vista previa de texto.',
  'whatsappTemplates.noResults': 'No hay plantillas que coincidan',
  'whatsappTemplates.noResultsHelp':
    'Prueba otra búsqueda o muestra las plantillas no disponibles.',
  'whatsappTemplates.empty': 'Esta cuenta no tiene plantillas',
  'whatsappTemplates.emptyHelp':
    'Crea y aprueba una plantilla en WhatsApp Manager. Luego actualiza esta lista.',
  'whatsappTemplates.unavailable.notApproved':
    'Meta aún no permite enviar esta plantilla. Revisa su estado.',
  'whatsappTemplates.unavailable.namedParameters':
    'Comos todavía no admite el envío de parámetros con nombre.',
  'whatsappTemplates.unavailable.mediaHeader':
    'Comos todavía no admite archivos o ubicaciones en el encabezado de una plantilla.',
  'whatsappTemplates.unavailable.unsupportedFormat':
    'Esta plantilla contiene un formato o una acción que Comos todavía no puede enviar.',
  'whatsappTemplates.unavailable.authentication':
    'Las plantillas de autenticación requieren un flujo que aún no está disponible aquí.',
  'whatsappTemplates.unavailable.invalidDefinition':
    'No pudimos interpretar todos los datos de esta plantilla. Actualiza la lista o elige otra.',
  'whatsappTemplates.personalize': 'Personalizar',
  'whatsappTemplates.personalizeHelp':
    'Completa los datos. El texto aprobado se mantiene tal como está.',
  'whatsappTemplates.noFields':
    'Esta plantilla está lista para revisar. No requiere datos adicionales.',
  'whatsappTemplates.linkField': 'Enlace de «{label}»',
  'whatsappTemplates.field.header': 'Dato {number} del encabezado',
  'whatsappTemplates.field.body': 'Dato {number} del mensaje',
  'whatsappTemplates.urlPrefix': 'Parte fija: {prefix}',
  'whatsappTemplates.suffixPlaceholder': 'Parte final del enlace',
  'whatsappTemplates.valuePlaceholder': 'Escribe el valor…',
  'whatsappTemplates.invalidSuffix':
    'Escribe solo la parte final del enlace, sin espacios ni una URL completa.',
  'whatsappTemplates.invalidField':
    'Escribe un valor sin saltos de línea, tabulaciones ni más de cuatro espacios seguidos.',
  'whatsappTemplates.required': 'Obligatorio',
  'whatsappTemplates.suffixHelp':
    'Se añadirá a la parte fija del enlace aprobado.',
  'whatsappTemplates.preview': 'Vista previa',
  'whatsappTemplates.previewHelp': 'Así se verá el contenido del mensaje.',
  'whatsappTemplates.previewDisclaimer':
    'La apariencia puede variar según el dispositivo. Los botones de esta vista previa no son interactivos.',
  'whatsappTemplates.details': 'Detalles de la plantilla',
  'whatsappTemplates.technicalName': 'Nombre en Meta',
  'whatsappTemplates.status': 'Estado en Meta',
  'whatsappTemplates.approved': 'Aprobada',
  'whatsappTemplates.from': 'Desde',
  'whatsappTemplates.to': 'Para',
  'whatsappTemplates.context': 'Cuenta y destinatario',
  'whatsappTemplates.invalidNumber':
    'Introduce un número válido con código de país, por ejemplo +56912345678.',
  'whatsappTemplates.missingSender':
    'Elige una cuenta de WhatsApp para ver sus plantillas.',
  'whatsappTemplates.refresh': 'Actualizar',
  'whatsappTemplates.loadError':
    'No pudimos cargar las plantillas. Intenta nuevamente.',
  'whatsappTemplates.cancel': 'Cerrar',
  'whatsappTemplates.send': 'Enviar plantilla',
  'whatsappTemplates.review': 'Revisar mensaje',
  'whatsappTemplates.remaining': 'Faltan {count} datos obligatorios',
  'whatsappTemplates.ready': 'Listo para enviar',
  'whatsappTemplates.checkRequirements':
    'Revisa arriba el remitente, destinatario y disponibilidad de la plantilla.',
  'whatsappTemplates.selectionRequired': 'Elige una plantilla para continuar',
  'whatsappTemplates.sent': 'Plantilla enviada.',
  'whatsappTemplates.replyRequired':
    'Podrás escribir libremente cuando el contacto responda.',
  'whatsappTemplates.noticeTitle': 'La conversación necesita una plantilla',
  'whatsappTemplates.noticeExpired':
    'Envía una plantilla para retomar la conversación.',
  'whatsappTemplates.noticeNew':
    'Envía una plantilla para iniciar la conversación.',
  'whatsappTemplates.noticeWaitingTitle':
    'Plantilla enviada · Esperando respuesta',
  'whatsappTemplates.noticeWaiting': 'Plantilla enviada. Esperando respuesta.',
  'whatsappTemplates.chooseAction': 'Elegir plantilla',
  'whatsappTemplates.anotherAction': 'Otra plantilla',
  'whatsappTemplates.windowHelpTitle':
    'Cómo funcionan las ventanas de WhatsApp',
  'whatsappTemplates.windowHelpExpiredTitle': 'Retomar la conversación',
  'whatsappTemplates.windowHelpNewTitle': 'Iniciar la conversación',
  'whatsappTemplates.windowHelpWaitingTitle': 'Esperando respuesta',
  'whatsappTemplates.windowHelpExpired':
    'Pasaron más de 24 h desde su último mensaje.',
  'whatsappTemplates.windowHelpNew': 'No hay una ventana de respuesta abierta.',
  'whatsappTemplates.windowHelpTemplate': 'Envías una plantilla',
  'whatsappTemplates.windowHelpTemplateDetail':
    'Un mensaje aprobado por WhatsApp.',
  'whatsappTemplates.windowHelpSent': 'Plantilla enviada',
  'whatsappTemplates.windowHelpSentDetail': 'Enviar otra no abre la ventana.',
  'whatsappTemplates.windowHelpReply': 'El contacto responde',
  'whatsappTemplates.windowHelpWindow': '24 h para escribir libremente',
  'whatsappTemplates.windowHelpRule':
    'Cada nuevo mensaje del contacto reinicia las 24 h.',
  'whatsappTemplates.windowHelpClose': 'Cerrar ayuda',
  'propertyLinks.selectedText': 'Parte del enlace',
  'propertyLinks.useWholeText': 'Usar texto completo',
  'propertyLinks.keepExample': 'Conservar enlace actual',
  'propertyLinks.viewExternal': 'Ver configuración',
  'propertyLinks.configureComos': 'Configurar sitio web',
  'propertyLinks.editExternal': 'Editar configuración',
  'propertyLinks.back': 'Atrás',
  'propertyLinks.reviewLink': 'Revisar enlace',
  'propertyLinks.setupProgress': 'Pasos de configuración',
  'propertyLinks.saving': 'Guardando…',
  'propertyLinks.autosaveHelp': 'El orden se guarda automáticamente.',
  'propertyLinks.autoSaveError':
    'No se pudo confirmar el cambio. Intenta nuevamente.',
  'propertyLinks.resetConfirmation':
    'Se restablecerá el orden predeterminado y se quitará la configuración del sitio externo. El cambio se guardará de inmediato.',
  'propertyLinks.incompleteMappings':
    'Completa ambas columnas. Cada valor de Comos puede tener una sola equivalencia.',
  'propertyLinks.sourceHelp.id': 'Identificador asignado por Comos',
  'propertyLinks.sourceHelp.sourceId':
    'Identificador original del sistema de importación',
  'propertyLinks.sourceHelp.sourceCode': 'Código comercial recibido del origen',
  'propertyLinks.sourceHelp.sourceSystem':
    'Sistema del que se importó la propiedad',
  'propertyLinks.sourceHelp.mercadoLibreCode':
    'Código de la publicación en Mercado Libre',
  'propertyLinks.sourceHelp.name': 'Nombre guardado de la propiedad',
  'propertyLinks.sourceHelp.locality': 'Nombre de la comuna',
  'propertyLinks.sourceHelp.localityCode': 'Código guardado de la comuna',
  'propertyLinks.sourceHelp.region': 'Nombre de la región',
  'propertyLinks.sourceHelp.regionCode': 'Código guardado de la región',
  'propertyLinks.sourceHelp.countryCode': 'Código del país',
  'propertyLinks.sourceHelp.neighborhood': 'Nombre del barrio',
  'propertyLinks.sourceHelp.operation': 'Tipo de operación de la propiedad',
  'propertyLinks.sourceHelp.propertyType': 'Categoría de la propiedad',
  'propertyLinks.sourceHelp.identifier':
    'Identificador importado de este sistema',
  'propertyLinks.exampleStep': 'Enlace de ejemplo',
  'propertyLinks.pasteExample': 'Pega el enlace de una propiedad',
  'propertyLinks.pasteExampleHelp':
    'Usa un enlace de tu sitio. Después indicarás qué partes cambian para cada propiedad.',
  'propertyLinks.useExample': 'Usar enlace',
  'propertyLinks.invalidExample':
    'Introduce un enlace completo http:// o https://, sin credenciales, espacios ni fragmentos (#).',
  'propertyLinks.markVariables': '¿Qué partes cambian?',
  'propertyLinks.markVariablesHelp':
    'Haz clic en una parte del enlace para configurarla. Las partes con un dato de Comos cambian en cada propiedad.',
  'propertyLinks.editPortion': 'Elegir dato para',
  'propertyLinks.needsVariable':
    'Marca al menos un dato que cambie para cada propiedad.',
  'propertyLinks.chooseSource': '¿Qué dato representa?',
  'propertyLinks.selectSubstring': 'Usar solo una parte',
  'propertyLinks.selectSubstringHelp':
    'Selecciona solo los caracteres que cambian. Por ejemplo, 4512 dentro de casa-4512.',
  'propertyLinks.identifierOptions': 'Opciones del identificador',
  'propertyLinks.editPart': 'Configura esta parte del enlace',
  'propertyLinks.partBehavior': '¿Cómo se completa esta parte?',
  'propertyLinks.variableMode': 'Dato de Comos',
  'propertyLinks.variableModeHelp': 'Cambia según la propiedad.',
  'propertyLinks.fixedMode': 'El mismo texto siempre',
  'propertyLinks.fixedModeHelp': 'Se repite igual en todos los enlaces.',
  'propertyLinks.applyPart': 'Aplicar cambio',
  'propertyLinks.fixedText': 'Texto que aparecerá en el enlace',
  'propertyLinks.fixedTextPlaceholder': 'Por ejemplo, propiedad',
  'propertyLinks.fixedTextHelp':
    'Escribe texto normal. Los espacios y caracteres especiales se adaptan automáticamente al formato de un enlace.',
  'propertyLinks.customizeValues': 'Personalizar valores',
  'propertyLinks.mappingHelp':
    'Cuando Comos entregue el valor de la izquierda, el enlace usará el texto de la derecha. Los demás valores no cambian. Se aplica donde se use este dato.',
  'propertyLinks.mappingFrom': 'Dato recibido de Comos',
  'propertyLinks.mappingTo': 'Texto que usa tu sitio',
  'propertyLinks.mappingToPlaceholder': 'Escribe su equivalente en tu sitio',
  'propertyLinks.chooseValue': 'Elegir valor',
  'propertyLinks.addMapping': 'Agregar equivalencia',
  'propertyLinks.removeMapping': 'Quitar',
  'propertyLinks.examplePreview': 'Así se verá el enlace',
  'propertyLinks.examplePreviewHelp':
    'Vista previa con datos ficticios. No comprueba que el enlace exista en tu sitio.',
  'propertyLinks.exampleValues': 'Datos de ejemplo',
  'propertyLinks.exampleValue': 'Ejemplo de',
  'propertyLinks.replaceExample': 'Reemplazar enlace de ejemplo',
  'propertyLinks.replaceExampleHelp':
    'Se quitarán las variables y equivalencias de este borrador. La configuración guardada seguirá activa hasta que guardes los cambios.',

  'common.saveFeedback.saving': 'Guardando…',
  'common.saveFeedback.saved': 'Guardado',
  'common.saveFeedback.retry': 'Reintentar',
  'settings.employees.responseWait.unit': 'segundos',
  'settings.tenant.title': 'Configuración general',
  'settings.tenant.domains': 'Secciones de configuración',
  'settings.tenant.unsaved': 'Cambios sin guardar',
  'settings.tenant.saved': 'Sin cambios pendientes',
  'settings.tenant.reset': 'Restablecer',
  'settings.tenant.description':
    'Administra la configuración que se aplica a todos en tu empresa.',
  'settings.tenant.properties.title': 'Propiedades',
  'settings.tenant.properties.description':
    'Configura cómo se comparte y muestra la información de las propiedades.',
  // Company property links
  'propertyLinks.nativeIdentifier': 'Identificador de propiedad',
  'propertyLinks.customIdentifier': 'Identificador personalizado',
  'propertyLinks.openSource': 'Abrir origen',
  'propertyLinks.title': 'Enlaces de propiedades',
  'propertyLinks.description':
    'Elige los enlaces de propiedades que comparte tu empresa en Comos, incluidos los Agentes IA.',
  'propertyLinks.priority': 'Prioridad de destinos',
  'propertyLinks.priorityHelp':
    'Se usa el primer enlace disponible. Los destinos sin configurar conservan su posición y se omiten.',
  'propertyLinks.destination.comos': 'Sitio web de Comos',
  'propertyLinks.destination.external': 'Sitio web externo',
  'propertyLinks.destination.source': 'Enlace de origen',
  'propertyLinks.moveUp': 'Subir',
  'propertyLinks.moveDown': 'Bajar',
  'propertyLinks.path': 'Ruta de la propiedad',
  'propertyLinks.identifierValue': 'Valor del identificador',
  'propertyLinks.rawValue': 'Valor original',
  'propertyLinks.normalizedValue': 'Valor normalizado',
  'propertyLinks.namespace': 'Ámbito del identificador',
  'propertyLinks.anyNamespace': 'Cualquier ámbito',
  'propertyLinks.exactNamespace': 'Un ámbito específico',
  'propertyLinks.nullNamespace': 'Sin ámbito asignado',
  'propertyLinks.unlabelled': 'Identificador sin etiqueta',
  'propertyLinks.configureExternal': 'Configurar sitio web externo',
  'propertyLinks.removeExternal': 'Quitar sitio',
  'propertyLinks.removeExternalHelp':
    'Se quitará la configuración del sitio externo de inmediato. Los enlaces usarán los demás destinos disponibles según su prioridad.',
  'propertyLinks.queryValue': 'Valor del parámetro de consulta',
  'propertyLinks.moreParameters': 'Cargar más tipos de identificadores',
  'propertyLinks.parameterError':
    'No se pudieron cargar los tipos de identificadores.',
  'propertyLinks.invalidQuery':
    'Revisa el texto fijo en Parámetros adicionales. Usa %26 para &, %23 para # y %20 para espacios. Cada % debe ir seguido de dos dígitos hexadecimales (0–9, A–F). Puedes corregirlo haciendo clic en esa parte del enlace.',
  'propertyLinks.invalidTemplate':
    'Revisa el enlace, las variables y las equivalencias antes de guardar.',
  'propertyLinks.noLink':
    'Esta propiedad no tiene un enlace disponible para compartir.',
  'propertyLinks.previewError':
    'No se pudo completar la vista previa. Intenta nuevamente.',
  'propertyLinks.reason.website_unavailable':
    'Sin sitio web de Comos publicado y compatible',
  'propertyLinks.reason.external_unconfigured':
    'Sitio web externo sin configurar',
  'propertyLinks.reason.missing_parameter':
    'Falta un valor necesario de la propiedad',
  'propertyLinks.reason.ambiguous_identifier':
    'Coincide más de un identificador',
  'propertyLinks.reason.invalid_url':
    'Estos valores no permiten formar un enlace válido',
  'propertyLinks.reason.source_unavailable': 'Sin enlace de origen válido',
  'propertyLinks.noPermission':
    'No tienes permiso para ver esta configuración.',
  'propertyLinks.loading': 'Cargando…',
  'propertyLinks.invalidSavedPolicy':
    'La configuración guardada no es válida. Comos usa los valores predeterminados hasta que guardes una configuración válida o restablezcas los valores.',
  'propertyLinks.resetDefault': 'Restablecer',
  'propertyLinks.resetDefaultHelp':
    'Restablecer la configuración predeterminada de enlaces',
  'propertyLinks.loadError': 'No se pudo cargar la configuración de enlaces.',
  'propertyLinks.saveError':
    'No se pudo confirmar el guardado. Tu borrador se conserva; intenta nuevamente.',
  'propertyLinks.retry': 'Reintentar',
  'propertyLinks.save': 'Guardar cambios',
  'propertyLinks.cancel': 'Cancelar',
  'propertyLinks.unavailable':
    'La configuración de enlaces todavía no está disponible.',
  'propertyLinks.copy': 'Copiar enlace',
  'propertyLinks.shareAction': 'Compartir',
  'propertyLinks.copied': 'Enlace copiado',
  'propertyLinks.copyError': 'No se pudo copiar el enlace. Intenta nuevamente.',
  'propertyLinks.resolutionError':
    'No se pudo preparar el enlace. Actualiza la propiedad antes de compartir.',
  'propertyLinks.unconfigured': 'sin configurar',
  'propertyLinks.shareTitle': '¿Qué propiedad quieres compartir?',
  'composer.attachments.title': 'Agregar al mensaje',
  'emojiPicker.title': 'Emojis',
  'emojiPicker.open': 'Agregar emoji',
  'emojiPicker.close': 'Cerrar emojis',
  'emojiPicker.keyboard': 'Volver al teclado',
  'emojiPicker.search': 'Buscar emojis…',
  'emojiPicker.clearSearch': 'Limpiar búsqueda',
  'emojiPicker.categories': 'Categorías de emojis',
  'emojiPicker.select': 'Selecciona un emoji',
  'emojiPicker.noResults': 'No se encontraron emojis',
  'emojiPicker.oneResult': 'Se encontró 1 emoji',
  'emojiPicker.manyResults': 'Se encontraron %n emojis',
  'emojiPicker.loading': 'Cargando emojis…',
  'emojiPicker.loadError': 'No se pudieron cargar los emojis',
  'emojiPicker.retry': 'Intentar de nuevo',
  'emojiPicker.tones.neutral': 'Tono de piel predeterminado',
  'emojiPicker.tones.light': 'Tono de piel claro',
  'emojiPicker.tones.mediumLight': 'Tono de piel medio claro',
  'emojiPicker.tones.medium': 'Tono de piel medio',
  'emojiPicker.tones.mediumDark': 'Tono de piel medio oscuro',
  'emojiPicker.tones.dark': 'Tono de piel oscuro',
  'composer.attachments.file': 'Archivo',
  'composer.attachments.quickTemplate': 'Usar plantilla rápida',
  'composer.attachments.whatsappTemplate': 'Usar plantilla de WhatsApp',
  'composer.attachments.manageQuickTemplates': 'Administrar plantillas rápidas',
  'composer.attachments.manageWhatsAppTemplates':
    'Administrar plantillas de WhatsApp',
  'propertyLinks.share': 'Compartir propiedad',
  'propertyLinks.insert': 'Agregar',
  'propertyLinks.insertHelp':
    'Selecciona una propiedad para insertar su enlace en tu borrador.',
  'propertyLinks.field.id': 'ID de la propiedad en Comos',
  'propertyLinks.field.sourceId': 'ID de origen',
  'propertyLinks.field.sourceCode': 'Código de origen',
  'propertyLinks.field.sourceSystem': 'Sistema de origen',
  'propertyLinks.field.mercadoLibreCode': 'Código de Mercado Libre',
  'propertyLinks.field.name': 'Nombre de la propiedad',
  'propertyLinks.field.locality': 'Comuna',
  'propertyLinks.field.localityCode': 'Código de comuna',
  'propertyLinks.field.region': 'Región',
  'propertyLinks.field.regionCode': 'Código de región',
  'propertyLinks.field.countryCode': 'Código de país',
  'propertyLinks.field.neighborhood': 'Barrio',
  'propertyLinks.field.operation': 'Operación',
  'propertyLinks.field.propertyType': 'Tipo de propiedad',

  // Shared notices and frontend updates
  'shared.notices.dismiss': 'Cerrar aviso',
  'appUpdates.title': 'Hay una nueva versión de Comos',
  'appUpdates.mobileTitle': 'Hay una nueva versión',
  'appUpdates.message': 'La pantalla se recargará y volverás a donde estás.',
  'appUpdates.mobileMessage': 'La pantalla se recargará.',
  'appUpdates.action': 'Actualizar ahora',
  'appUpdates.confirmTitle': '¿Actualizar Comos?',
  'appUpdates.confirmMessage':
    'La página se recargará para usar la nueva versión.',
  'appUpdates.confirm': 'Actualizar',
  'appUpdates.cancel': 'Cancelar',

  // Funnel terminal outcomes
  'crm.funnelStatus.terminalPositive': 'Estado de cierre con éxito',
  'crm.funnelStatus.terminalNegative': 'Estado de cierre sin éxito',
  'crm.funnelStatus.archiveExplanation':
    'Las conversaciones se archivan al entrar a este estado y se restauran al volver a un estado en curso.',
  'crm.funnelStatus.outcomeLabel': 'Estado terminal',
  'crm.funnelStatus.inProgress': 'No',
  'crm.funnelStatus.closedPositive': 'Positivo',
  'crm.funnelStatus.closedNegative': 'Negativo',
  'crm.funnelStatus.system': 'Sistema',
  'reports.dashboard.outcomes.label': 'Entradas a estados durante el período',
  'reports.dashboard.outcomes.positive': 'Ganados',
  'reports.dashboard.outcomes.negative': 'Perdidos',
  'communications.timeline.emptyTitle': 'No hay interacciones',
  'communications.timeline.emptyDescription':
    'Inicia la conversación enviando un mensaje o realizando una llamada',
  'communications.timeline.historyLabel': 'Historial de la conversación',
  'common.undo': 'Deshacer',
  'communications.conversation.archivePending':
    'La conversación #{id} se archivará en 5 segundos…',
  'communications.conversation.bulkArchivePending':
    'Se archivarán {count} conversaciones en 5 segundos…',
  'communications.conversation.autoArchived':
    'La conversación se ha archivado.',
  'communications.conversation.autoRestored':
    'La conversación se ha restaurado.',
  'communications.conversation.activeDuplicate':
    'Ya existe una conversación activa para este contacto en este embudo. La conversación no se movió ni se restauró.',
  'communications.conversation.moveToOpenBeforeRestore':
    'Mueve la conversación a un estado en curso para restaurarla automáticamente.',
  'communications.conversationCard.tags': 'Etiquetas de conversación',
  'communications.conversationCard.tags.other': 'Otras etiquetas',
  'communications.conversationCard.tags.more.one': 'Mostrar 1 etiqueta más',
  'communications.conversationCard.tags.more.many':
    'Mostrar {count} etiquetas más',
  'communications.conversationCard.property.code': 'Código {id}',
  'communications.conversationCard.property.imageAlt': 'Foto de {name}',
  'communications.conversationCard.property.imageUnavailable':
    'Foto no disponible',
  'communications.conversationCard.property.loading': 'Cargando propiedad…',
  'communications.conversationCard.property.unavailable':
    'Propiedad no disponible',
  'communications.conversationCard.property.error':
    'Propiedad temporalmente no disponible',
  'communications.conversationCard.property.fallbackType': 'Propiedad',
  'communications.conversationCard.property.temporaryRentShort': 'Temporal',
  'communications.conversationCard.property.priceUnavailable':
    'Precio no informado',
  'communications.conversationCard.property.operationUnavailable':
    'Operación no informada',

  // Shared - Actions
  'shared.actions.back': 'Volver',
  'shared.actions.cancel': 'Cancelar',
  'shared.actions.apply': 'Aplicar',
  'shared.actions.close': 'Cerrar',
  'shared.actions.save': 'Guardar',
  'shared.actions.delete': 'Eliminar',
  'shared.actions.send': 'Enviar',
  'shared.date.today': 'Hoy',
  'shared.pagination.previous': 'Página anterior',
  'shared.pagination.next': 'Página siguiente',
  'shared.pagination.page': 'Página {current} de {total}',
  'shared.pagination.compactPage': 'Pág. {current}/{total}',
  'shared.modal.dialogLabel': 'Diálogo',
  'shared.advancedFilters.button': 'Filtros',
  'shared.advancedFilters.title': 'Filtros avanzados',
  'shared.advancedFilters.description':
    'Ajusta los criterios para encontrar las conversaciones correctas.',
  'shared.advancedSorts.button': 'Ordenar',
  'shared.advancedSorts.title': 'Ordenar conversaciones',
  'shared.advancedSorts.description':
    'Define el orden en que quieres revisar los resultados.',

  // Shared - Auth bootstrap
  'shared.auth.bootstrap.error.title': 'No pudimos completar tu acceso',
  'shared.auth.bootstrap.error.retryAction': 'Intentar nuevamente',
  'shared.auth.bootstrap.error.reauthAction': 'Volver a iniciar sesión',
  'shared.auth.bootstrap.error.manualRecoveryAction': 'Ingresar de otra forma',
  'shared.auth.bootstrap.error.timeout':
    'La autenticación está tardando más de lo esperado. Intenta nuevamente.',
  'shared.auth.bootstrap.error.temporaryUnavailable':
    'La autenticación no está disponible temporalmente. Intenta nuevamente.',
  'shared.auth.bootstrap.error.backendUnavailable':
    'No pudimos terminar de cargar tu usuario local. Intenta nuevamente.',
  'shared.auth.bootstrap.error.sessionInvalid':
    'Tu sesión ya no es válida. Vuelve a iniciar sesión para continuar.',
  'shared.auth.bootstrap.error.localUserLinkFailed':
    'No pudimos vincular tu acceso con un usuario local. Contacta a tu administrador.',
  'shared.auth.bootstrap.error.manualRecovery':
    'Por tu seguridad, no pudimos asociar este método de acceso con tu cuenta de Comos. Usa tu método habitual o contacta a soporte.',
  'shared.auth.bootstrap.error.accessDenied':
    'Tu cuenta no tiene acceso a esta aplicación.',
  'shared.auth.bootstrap.error.permissionsUnavailable':
    'No pudimos obtener tus permisos todavía. Intenta nuevamente.',
  'shared.api.retry.unauthorized':
    'Tu sesión ha finalizado, inicia sesión nuevamente. Si no tienes invitación contacta al administrador de tu equipo.',
  'shared.api.retry.forbidden':
    'No puedes hacer esto. Asegúrate que tu cuenta tenga los permisos necesarios e intenta nuevamente.',

  // Shared - Searchable Select
  'shared.searchableSelect.placeholder': 'Selecciona o busca...',
  'shared.searchableSelect.searchPlaceholder': 'Buscar...',
  'shared.searchableSelect.emptyLabel': 'No hay resultados',
  'shared.searchableSelect.emptyDescription': 'Intenta con otra búsqueda',
  'shared.dropdown.mobileTitle': 'Opciones',
  'shared.multiSelect.placeholder': 'Selecciona opciones',
  'shared.multiSelect.searchPlaceholder': 'Buscar...',
  'shared.multiSelect.selectAll': 'Seleccionar todos',
  'shared.multiSelect.clear': 'Limpiar',
  'shared.multiSelect.emptyLabel': 'No hay resultados',
  'shared.multiSelect.emptyDescription': 'Prueba con otro término de búsqueda.',
  'shared.multiSelect.selectedSummary': '{count} seleccionados',

  // Shared - Expandable Section
  'shared.expandableSection.show': 'Mostrar',
  'shared.expandableSection.hide': 'Ocultar',
  'shared.expandableSection.viewMore': 'Ver más',
  'shared.expandableSection.viewLess': 'Ver menos',
  'shared.expandableSection.moreContent': 'Más contenido',

  // Shared - Property Selector
  'shared.propertySelector.none': 'Sin propiedad',
  'shared.propertySelector.open': 'Ver propiedad',
  'shared.propertySelector.tooltip':
    'Asigna una propiedad de interés a esta conversación',
  'shared.property.label': 'Propiedad',
  'shared.property.ofInterest': 'Propiedad de interés',
  'shared.property.noneAssigned': 'Sin propiedad asignada',
  'shared.property.searchTitle': 'Búsqueda de propiedades',
  'shared.property.idLabel': 'Propiedad ID {id}',
  'shared.property.ofInterestRemoved': 'Se eliminó la propiedad de interés',
  'shared.property.ofInterestCleared': 'Propiedad de interés limpia',
  'shared.property.ofInterestUpdated': 'Propiedad de interés actualizada',
  'shared.property.ofInterestWithId': 'Propiedad de interés {id}',
  'shared.inline.copy': 'Copiar',
  'shared.inline.copied': '¡Copiado!',
  'shared.inline.openLink': 'Abrir enlace',
  'shared.copyableValue.copy': 'Copiar: {label}',
  'shared.copyableValue.copied': 'Copiado: {label}',
  'shared.colorInput.picker': 'Selector de color: {label}',
  'shared.colorInput.hex': 'Código hexadecimal: {label}',
  'shared.fileInput.upload': 'Subir',
  'shared.fileInput.replace': 'Reemplazar',
  'shared.fileInput.uploadHint': 'Sube un archivo',
  'shared.fileInput.replaceHint': 'Reemplaza el archivo',
  'shared.fileInput.errors.type':
    'Tipo de archivo no permitido. Por favor, selecciona un archivo válido.',
  'shared.fileInput.errors.size':
    'El archivo es demasiado grande. El tamaño máximo permitido es {size} MB.',
  'shared.fileInput.errors.generic': 'Error al validar el archivo',
  'shared.inline.actions': 'Más acciones',
  'shared.inline.pressToEdit': 'Presiona para editar',
  'shared.inline.select': 'Selecciona',

  // Communications - Contact sidepanel
  'communications.conversation.operationConflict':
    'Otra operación está actualizando esta conversación. Inténtalo nuevamente.',
  'communications.contactPanel.title': 'Detalles',
  'communications.contactPanel.error.title': 'Error cargando los datos',
  'communications.contactPanel.error.description':
    'No se pudo cargar la información del contacto. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.error.close': 'Cerrar',
  'communications.contactPanel.conversations.title': 'Conversación',
  'communications.contactPanel.conversations.empty':
    'Este contacto no tiene conversaciones',
  'communications.contactPanel.conversations.error.title':
    'Error cargando conversaciones',
  'communications.contactPanel.conversations.error.description':
    'No se pudieron cargar las conversaciones.',
  'communications.contactPanel.conversations.customFields.create':
    'Crea un campo personalizado de conversación',
  'communications.contactPanel.conversations.fields.error.title':
    'Error cargando los datos',
  'communications.contactPanel.conversations.fields.error.description':
    'No se pudo cargar la conversación. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.conversations.fields.emptySelect':
    'Selecciona una conversación para ver sus detalles',
  'communications.contactPanel.conversations.fields.status': 'Estado',
  'communications.contactPanel.conversations.fields.assignee': 'Asignado',
  'communications.contactPanel.conversations.fields.tasks': 'Tareas',
  'communications.contactPanel.conversations.fields.noneStatus': 'Sin estado',
  'communications.contactPanel.conversations.fields.unassigned': 'Sin asignar',
  'communications.contactPanel.conversations.fields.noTasks': 'Sin tareas',
  'communications.contactPanel.conversations.fields.viewTasks': 'Ver tareas',
  'communications.contactPanel.conversations.fields.taskCountSingular':
    '{count} tarea',
  'communications.contactPanel.conversations.fields.taskCountPlural':
    '{count} tareas',
  'communications.contactPanel.conversations.fields.taskModalTitle':
    'Tareas de la conversación',
  'communications.contactPanel.conversations.fields.newTask': 'Nueva',
  'communications.testConversation.badge': 'Prueba',
  'communications.interactions.actions.newCall': 'Nueva llamada',
  'communications.interactions.actions.newMessage': 'Nuevo mensaje',
  'communications.interactions.actions.importConversations':
    'Importar conversaciones',
  'communications.testConversations.actions.create':
    'Nueva conversación de prueba',
  'communications.testConversations.actions.confirmCreate':
    'Crear conversación',
  'communications.testConversations.actions.replyAsContact':
    'Responder como contacto',
  'communications.testConversations.form.fromPhoneRequired':
    'Debes seleccionar un número de origen',
  'communications.testConversations.form.initialMessageRequired':
    'Debes ingresar un mensaje inicial',
  'communications.testConversations.form.replyRequired':
    'Debes ingresar un mensaje',
  'communications.testConversations.form.lineLabel': 'Línea de WhatsApp',
  'communications.testConversations.form.contactNameLabel':
    'Nombre del contacto',
  'communications.testConversations.form.contactNamePlaceholder':
    'Comprador de prueba',
  'communications.testConversations.form.initialMessageLabel':
    'Mensaje inicial',
  'communications.testConversations.form.initialMessagePlaceholder':
    'Hola, me interesa una propiedad y quiero más información.',
  'communications.testConversations.form.messageLabel': 'Mensaje',
  'communications.testConversations.form.replyPlaceholder':
    'Quisiera agendar una visita, ¿cómo seguimos?',
  'communications.testConversations.contactAddress.readOnlyTooltip':
    'Esta identidad de prueba se administra automáticamente.',
  'communications.contactPanel.section.viewMoreCount': 'Ver {count} más',
  'communications.contactPanel.contact.info.title': 'Información',
  'communications.contactPanel.contact.info.updateError':
    'No se pudo actualizar el campo. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.info.error.title':
    'Error al cargar la información',
  'communications.contactPanel.contact.info.error.description':
    'No se pudo cargar la información del contacto. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.info.firstName': 'Nombre',
  'communications.contactPanel.contact.info.firstNamePlaceholder':
    'Ingresa el nombre...',
  'communications.contactPanel.contact.info.lastName': 'Apellido',
  'communications.contactPanel.contact.info.lastNamePlaceholder':
    'Ingresa el apellido...',
  'communications.contactPanel.contact.info.nationalId': 'CI',
  'communications.contactPanel.contact.info.nationalIdPlaceholder':
    'Ingresa el identificador nacional...',
  'communications.contactPanel.contact.info.companyPosition': 'Cargo',
  'communications.contactPanel.contact.info.companyPositionPlaceholder':
    'Ingresa el cargo...',
  'communications.contactPanel.contact.customFields.create':
    'Crea un campo personalizado de contacto',
  'communications.contactPanel.contact.customFields.error.title':
    'Error cargando los datos',
  'communications.contactPanel.contact.customFields.error.description':
    'No se pudieron cargar los campos personalizados. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.addresses.title':
    'Direcciones de contacto',
  'communications.contactPanel.contact.addresses.error.title':
    'Error al cargar direcciones',
  'communications.contactPanel.contact.addresses.error.description':
    'No se pudieron cargar las direcciones de contacto. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.addresses.empty':
    'Agrega una dirección a este contacto',
  'communications.contactPanel.contact.addresses.addError':
    'No se pudo agregar la dirección. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.addresses.updateError':
    'No se pudo actualizar la dirección. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.addresses.deleteError':
    'No se pudo eliminar la dirección. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.addresses.email': 'Correo',
  'communications.contactPanel.contact.addresses.phone': 'Teléfono',
  'communications.contactPanel.contact.addresses.whatsapp': 'WhatsApp',
  'communications.contactPanel.contact.addresses.placeholder':
    'Ingresa la dirección...',
  'communications.contactPanel.contact.addresses.deleteConfirm':
    '¿Quieres eliminar esta dirección?',
  'communications.filters.propertyOfInterest': 'Propiedad de interés',
  'communications.realtimeNotice.reconnecting': 'Reconectando',
  'communications.realtimeNotice.delayed':
    'Actualizaciones en vivo interrumpidas',
  'communications.realtimeNotice.description':
    'Los mensajes nuevos y los cambios de estado pueden tardar en aparecer. Intentaremos reconectar automáticamente.',
  'communications.realtimeNotice.explanation':
    'Acerca de las actualizaciones en vivo',
  'communications.conversationHeader.backToConversations':
    'Volver a conversaciones',
  'communications.conversationHeader.viewContactProfile':
    'Ver perfil del contacto',
  'communications.conversationHeader.moreActions': 'Más acciones',
  'communications.conversationHeader.tasks.overdueCount': '{count} vencidas',
  'communications.conversationHeader.tasks.upcomingCount': '{count} próximas',
  'communications.conversationHeader.tasks.clickToView': 'Haz clic para ver',
  'communications.contactPanel.contact.company.title': 'Empresa',
  'communications.contactPanel.contact.company.error.title':
    'Error al cargar información',
  'communications.contactPanel.contact.company.error.description':
    'No se pudo cargar la información de la empresa. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.company.empty':
    'Agrega una empresa a este contacto',
  'communications.contactPanel.contact.company.none': 'Sin empresa',
  'communications.contactPanel.contact.company.name': 'Nombre',
  'communications.contactPanel.contact.company.namePlaceholder':
    'Ingresa el nombre de la empresa...',
  'communications.contactPanel.contact.company.updateSuccess':
    'Empresa actualizada correctamente',
  'communications.contactPanel.contact.company.updateError':
    'No se pudo actualizar la empresa. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.company.deleteSuccess':
    'Empresa eliminada correctamente',
  'communications.contactPanel.contact.company.deleteError':
    'No se pudo eliminar la empresa. Por favor, inténtalo de nuevo.',
  'communications.contactPanel.contact.company.deleteModal.title':
    'Eliminar empresa',
  'communications.contactPanel.contact.company.deleteModal.description':
    '¿Está seguro que desea eliminar esta empresa? Esta acción no se puede deshacer.',
  'communications.messageBox.whatsapp.emptyState.noAvailableSender':
    'No hay remitentes de WhatsApp disponibles.',
  'communications.messageBox.whatsapp.emptyState.addContactAddress':
    'Agrega una dirección de WhatsApp a este contacto para chatear',
  'communications.messageBox.whatsapp.emptyState.selectAddresses':
    'Selecciona las direcciones de WhatsApp para chatear',
  'communications.messageBox.whatsapp.compactPlaceholder':
    'Escribe un mensaje…',
  'communications.whatsappExpirationAlert.remaining': '{timeLeft} restantes',
  'communications.whatsappExpirationAlert.expired.label': 'Sesión expirada',
  'communications.whatsappExpirationAlert.notActive.label': 'Sin sesión activa',
  'communications.whatsappExpirationAlert.explanation':
    'Sobre la ventana de respuesta',
  'communications.attachment.remove': 'Quitar archivo',
  'communications.attachment.uploading': 'Subiendo archivo…',
  'communications.attachment.ready': 'Listo para enviar',
  'communications.attachment.failed': 'No se pudo subir',
  'communications.attachment.errorExplanation':
    'No se pudo subir el archivo. Quítalo y vuelve a adjuntarlo para intentarlo de nuevo.',
  'communications.messageBox.whatsapp.compactFromLabel': 'De',
  'communications.messageBox.whatsapp.fromLabel': 'Desde',
  'communications.messageBox.whatsapp.toLabel': 'Para',
  'communications.messageBox.whatsapp.accountLabel': 'Cuenta de WhatsApp',
  'communications.messageBox.whatsapp.selectedAccountUnavailable':
    'Cuenta seleccionada no disponible',
  'communications.whatsappExpirationAlert.notActive.title':
    'Comienza una conversación de WhatsApp.',
  'communications.whatsappExpirationAlert.notActive.description':
    'Podrás escribir mensajes libres cuando recibas un mensaje del cliente. Intenta enviar una plantilla.',
  'communications.whatsappExpirationAlert.expired.title':
    'Esta conversación ha expirado.',
  'communications.whatsappExpirationAlert.expired.description':
    'Se reactivará cuando el cliente te envíe un mensaje. Intenta enviar una plantilla.',
  'communications.whatsappExpirationAlert.warning.title':
    'Esta conversación expirará en {timeLeft}.',
  'communications.whatsappExpirationAlert.warning.description':
    'Extiéndela haciendo que el cliente te envíe un mensaje.',
  'communications.whatsappExpirationAlert.active':
    'Esta conversación expirará en {timeLeft}.',
  'communications.panel.unassigned': 'Sin asignar',
  'communications.panel.allAssignees': 'Todos',
  'communications.panel.assigneesCount': '{count} asignados',
  'communications.panel.noFunnel.title': 'No hay embudo seleccionado',
  'communications.panel.noFunnel.description':
    'Por favor selecciona o crea un embudo para ver las conversaciones',
  'communications.panel.searchLabel': 'Buscar',
  'communications.panel.searchPlaceholder': 'Busca conversaciones...',
  'communications.panel.funnelTooltip':
    'Viendo las conversaciones del embudo {funnelName}',
  'communications.panel.assigneeTooltip':
    'Viendo las conversaciones asignadas a {assignee}',
  'communications.viewSwitcher.cards': 'Lista',
  'communications.viewSwitcher.pipeline': 'Columnas',
  'communications.viewSwitcher.table': 'Tabla',
  'communications.viewSwitcher.tooltip':
    'Viendo las conversaciones como {view}',
  'calls.page.title': 'Llamadas',
  'calls.page.actions.reports': 'Reportes',
  'calls.page.actions.featured': 'Destacadas',
  'calls.page.error.title': 'No se pudieron cargar las llamadas',
  'calls.page.error.description':
    'Intenta recargar la página o verifica tu conexión.',
  'calls.page.error.searchTooBroad':
    'La búsqueda tardó demasiado. Usa un número, contacto o agente más específico.',
  'calls.page.error.retry': 'Reintentar',
  'calls.search.validation.tooShort':
    'Ingresa al menos 3 caracteres para buscar.',
  'calls.search.validation.tooLong': 'Usa como máximo 100 caracteres.',
  'calls.search.validation.tooManyWords': 'Usa como máximo 5 palabras.',
  'calls.search.validation.noIndexableWord':
    'Incluye 3 letras o números consecutivos en al menos una palabra.',
  'calendar.agenda.title': 'Agenda',
  'calendar.agenda.actions.newTask': 'Nueva Tarea',
  'calendar.agenda.loading': 'Cargando tareas...',
  'calendar.agenda.loadingMore': 'Cargando más tareas...',
  'calendar.agenda.error.title': 'Error al cargar las tareas',
  'calendar.agenda.error.description':
    'No se pudieron cargar las tareas. Por favor, inténtalo de nuevo.',
  'calendar.agenda.error.retry': 'Reintentar',
  'calendar.agenda.view.list': 'Lista',
  'calendar.agenda.view.calendar': 'Calendario',
  'calendar.agenda.filters.button': 'Filtros',
  'calendar.agenda.filters.activeButton': 'Filtros activos',
  'calendar.agenda.filters.clear': 'Limpiar filtros',
  'calendar.agenda.filters.status.all': 'Todos los estados',
  'calendar.agenda.filters.status.scheduled': 'Programadas',
  'calendar.agenda.filters.status.completed': 'Completadas',
  'calendar.agenda.filters.status.cancelled': 'Canceladas',
  'calendar.agenda.filters.assignee.all': 'Todos los asignados',
  'calendar.agenda.filters.task.all': 'Todas las tareas',
  'calendar.agenda.filters.task.none': 'Sin conversación',
  'settings.customFields.includeTime.label': 'Incluir hora',
  'settings.customFields.includeTime.warning':
    'Al activar esta opción, el campo seguirá usando la misma clave y el mismo valor almacenado, pero la interfaz permitirá capturar y mostrar hora además de fecha.',

  // Users
  'users.title': 'Usuarios',
  'users.pagination.fetch': 'Traer',
  'users.pagination.records': 'registros',
  'users.pagination.summary': '{count} registros',
  'users.actions.invite': 'Invitar Usuario',
  'users.actions.resendAccess': 'Reenviar acceso',
  'users.actions.cancelInvite': 'Cancelar invitación',
  'users.actions.deactivate': 'Desactivar',
  'users.actions.reactivate': 'Reactivar',
  'users.error.title': 'Error al cargar los usuarios',
  'users.error.description':
    'No se pudieron cargar los usuarios. Por favor, inténtalo de nuevo.',
  'users.error.retry': 'Reintentar',
  'users.invite.success': 'Invitación enviada correctamente',
  'users.invite.email': 'Email',
  'users.invite.emailPlaceholder': 'usuario@ejemplo.com',
  'users.invite.emailInvalid': 'El email no es válido',
  'users.invite.firstName': 'Nombre',
  'users.invite.firstNamePlaceholder': 'Juana',
  'users.invite.lastName': 'Apellido',
  'users.invite.lastNamePlaceholder': 'Pérez',
  'users.invite.personalPhone': 'Teléfono personal',
  'users.invite.personalPhonePlaceholder': '+56912345678',
  'users.invite.personalPhoneHelp':
    'Importante: completa este campo para que el usuario pueda recibir notificaciones por WhatsApp.',
  'users.invite.profile': 'Perfil',
  'users.invite.team': 'Equipo',
  'users.invite.team.none': 'Sin equipo específico',
  'users.invite.modal.title': 'Invitar usuario',
  'users.invite.modal.description':
    'Cuando invitas un usuario le llegará un correo con instrucciones para entrar a Comos.',
  'users.invite.modal.cancel': 'Cancelar',
  'users.invite.userAlreadyExists':
    'Ya existe un usuario con ese email. Si corresponde, reenvía el onboarding desde la tabla.',
  'users.table.user': 'Usuario',
  'users.table.firstName': 'Nombre',
  'users.table.lastName': 'Apellido',
  'users.table.email': 'Email',
  'users.table.status': 'Estado',
  'users.table.profile': 'Perfil',
  'users.table.team': 'Equipo',
  'users.table.phone': 'Teléfono Personal',
  'users.table.phoneLabel': 'Teléfono',
  'users.table.phoneInvalid':
    'El teléfono no es válido. Usa formato internacional, por ejemplo +56912345678.',
  'users.status.pending': 'Pendiente',
  'users.status.active': 'Activo',
  'users.status.inactive': 'Inactivo',
  'users.status.cancelled': 'Cancelado',
  'users.profile.agent': 'Agente',
  'users.profile.admin': 'Administrador',
  'users.team.none': 'Sin equipo',
  'users.team.fallback': 'Equipo {id}',
  'users.filters.status.all': 'Todos los estados',
  'users.filters.status.active': 'Activos',
  'users.filters.status.inactive': 'Inactivos',
  'users.filters.status.currentAll': 'Estado: Todos',
  'users.filters.status.current': 'Estado: {value}',
  'users.filters.profile.all': 'Todos los perfiles',
  'users.filters.profile.admin': 'Administradores',
  'users.filters.profile.agent': 'Agentes',
  'users.filters.profile.currentAll': 'Perfil: Todos',
  'users.filters.profile.current': 'Perfil: {value}',
  'users.filters.team.all': 'Todos los equipos',
  'users.filters.team.fallback': 'Equipo {id}',
  'users.filters.team.currentAll': 'Equipo: Todos',
  'users.filters.team.current': 'Equipo: {name}',
  'users.filters.search.placeholder': 'Buscar usuarios...',
  'users.filters.search.currentAll': 'Búsqueda: Todos',
  'users.filters.search.current': 'Búsqueda: "{value}"',
  'users.filters.clearWithCount': 'Limpiar ({count})',
  'users.filters.active': 'Filtros activos:',
  'users.empty.title': 'No se encontraron usuarios',
  'users.empty.filteredDescription':
    'Intenta ajustar los filtros para ver más resultados',
  'users.empty.defaultDescription': 'No hay usuarios registrados en el sistema',

  // Catalog - Products
  'catalog.products.table.name': 'Nombre',
  'catalog.products.table.description': 'Descripción',
  'catalog.products.table.price': 'Precio',
  'catalog.products.table.source': 'Fuente',
  'catalog.products.table.updated': 'Actualizado',
  'catalog.products.table.actions.edit': 'Editar',
  'catalog.products.table.actions.delete': 'Eliminar',
  'catalog.products.table.emptyState.title': 'No se encontraron productos',
  'catalog.products.table.emptyState.description':
    'Agrega un producto o cambia tus filtros',
  'catalog.products.error.title': 'No se pudieron cargar los productos',
  'catalog.products.error.description':
    'Intenta recargar la página o verifica tu conexión.',
  'catalog.products.error.retry': 'Reintentar',
  'catalog.products.confirmDelete.title': 'Eliminar producto',
  'catalog.products.confirmDelete.confirm': 'Eliminar',
  'catalog.products.confirmDelete.cancel': 'Cancelar',
  'catalog.products.confirmDelete.messagePrefix': '¿Seguro que deseas eliminar',
  'catalog.products.confirmDelete.fallbackName': 'este producto',
  'catalog.products.confirmDelete.messageSuffix':
    '? Esta acción no se puede deshacer.',
  'catalog.products.form.edit': 'Editar producto',
  'catalog.products.form.create': 'Crear nuevo producto',
  'catalog.products.form.name': 'Nombre',
  'catalog.products.form.description': 'Descripción',
  'catalog.products.form.price': 'Precio',
  'catalog.products.form.currency': 'Moneda',
  'catalog.products.form.sourceUrl': 'URL origen',
  'catalog.products.form.sourceUrlPlaceholder': 'https://ejemplo.cl/producto',
  'catalog.products.form.customFields': 'CAMPOS PERSONALIZADOS',
  'catalog.products.form.saveChanges': 'Guardar cambios',
  'catalog.products.form.createButton': 'Crear producto',
  'catalog.products.form.cancel': 'Cancelar',
  'catalog.products.title': 'Productos',
  'catalog.products.import': 'Importar',
  'catalog.products.new': 'Nuevo producto',
  'catalog.products.filters.searchLabel': 'Buscar',
  'catalog.products.filters.searchPlaceholder':
    'Busca por nombre o descripción',
  'catalog.products.filters.currencyAll': 'Todas las monedas',
  'catalog.products.filters.clear': 'Limpiar filtros',
  'catalog.products.alert.create.success': 'Producto creado correctamente',
  'catalog.products.alert.create.error': 'Error al crear el producto',
  'catalog.products.alert.update.success': 'Producto actualizado correctamente',
  'catalog.products.alert.update.error': 'Error al actualizar el producto',
  'catalog.products.alert.delete.success': 'Producto eliminado correctamente',
  'catalog.products.alert.delete.error': 'Error al eliminar el producto',

  // Catalog - Properties
  'catalog.properties.title': 'Propiedades',
  'catalog.properties.new': 'Nueva',
  'catalog.properties.table.codigo': 'Código',
  'catalog.properties.table.name': 'Nombre',
  'catalog.properties.table.address': 'Dirección pública',
  'catalog.properties.table.price': 'Precio',
  'catalog.properties.table.cadastralId': 'ROL',
  'catalog.properties.table.commonExpenses': 'Gastos comunes',
  'catalog.properties.table.operation': 'Operación',
  'catalog.properties.table.assigned': 'Asignado',
  'catalog.properties.table.propertyType': 'Tipo',
  'catalog.properties.table.updated': 'Actualizado',
  'catalog.properties.table.emptyState.title': 'No se encontraron propiedades',
  'catalog.properties.table.emptyState.description':
    'Realiza una importación o cambia tus filtros',
  'catalog.properties.error.title': 'No se pudieron cargar las propiedades',
  'catalog.properties.error.description':
    'Intenta recargar la página o verifica tu conexión.',
  'catalog.properties.filters.searchLabel': 'Buscar',
  'catalog.properties.filters.searchPlaceholder':
    'Busca por título, ubicación o descripción',
  'catalog.properties.filters.operationAll': 'Todas las operaciones',
  'catalog.properties.filters.operationSale': 'Venta',
  'catalog.properties.filters.operationRent': 'Arriendo',
  'catalog.properties.filters.operationSaleAndRent': 'En venta y arriendo',
  'catalog.properties.filters.operationTemporaryRent': 'Arriendo temporal',
  'catalog.properties.filters.activeStatusLabel': 'Estado',
  'catalog.properties.filters.activeStatusActive': 'Activas',
  'catalog.properties.filters.activeStatusInactive': 'Inactivas',
  'catalog.properties.filters.activeStatusAll': 'Todas',
  'catalog.properties.filters.assignedAll': 'Todos los agentes',
  'catalog.properties.filters.assignedUnassigned': 'Sin asignar',
  'catalog.properties.filters.salePriceRange': 'Venta',
  'catalog.properties.filters.rentPriceRange': 'Arriendo',
  'catalog.properties.filters.rangeFrom': 'Desde',
  'catalog.properties.filters.rangeTo': 'Hasta',
  'catalog.properties.filters.region': 'Región',
  'catalog.properties.filters.locality': 'Comuna',
  'catalog.properties.filters.regionAll': 'Todas las regiones',
  'catalog.properties.filters.localityAll': 'Todas las comunas',
  'catalog.properties.filters.clear': 'Limpiar filtros',
  'catalog.properties.toolbar.sortLabel': 'Orden',
  'catalog.properties.toolbar.sort.updatedDesc': 'Actualizadas',
  'catalog.properties.toolbar.sort.createdDesc': 'Nuevas',
  'catalog.properties.toolbar.sort.priceDesc': 'Mayor precio',
  'catalog.properties.toolbar.sort.priceAsc': 'Menor precio',
  'catalog.properties.toolbar.viewLabel': 'Vista',
  'catalog.properties.toolbar.view.visual': 'Tarjetas',
  'catalog.properties.toolbar.view.compact': 'Tabla',
  'catalog.properties.toolbar.showToolbar': 'Mostrar barra',
  'catalog.properties.toolbar.hideToolbar': 'Ocultar barra',
  'catalog.properties.toolbar.filters': 'Filtros',
  'catalog.properties.toolbar.filtersWithCount': 'Filtros ({count})',
  'catalog.properties.header.actionsMenu': 'Acciones',
  'catalog.properties.activeFilters.clearAll': 'Limpiar todo',
  'catalog.properties.activeFilters.remove': 'Quitar filtro {label}',
  'catalog.properties.assigned.unassigned': 'Sin asignar',
  'catalog.properties.list.warning.noPhoto': 'Sin foto',
  'catalog.properties.list.warning.noPrice': 'Sin precio',
  'catalog.properties.list.warning.noLocation': 'Sin ubicación',
  'catalog.properties.list.warning.unassigned': 'Sin asignar',
  'catalog.properties.list.status.active': 'Activa',
  'catalog.properties.list.status.inactive': 'Inactiva',
  'catalog.properties.list.placeholder.noImageTitle': 'Sin imagen',
  'catalog.properties.list.badge.syncManaged': 'MeLi',
  'catalog.properties.list.provider.meli': 'Mercado Libre',
  'catalog.properties.list.provider.wasi': 'Wasi',
  'catalog.properties.list.provider.toppropiedades': 'Top Propiedades',
  'catalog.properties.list.provider.kiteprop': 'KiteProp',
  'catalog.properties.publications.page.title': 'Publicaciones',
  'catalog.properties.publications.page.subtitle':
    'Monitorea las publicaciones más recientes de portales en todas las propiedades.',
  'catalog.properties.publications.filters.title': 'Filtros',
  'catalog.properties.publications.filters.subtitle':
    'Acota la lista usando el mismo estado que muestra cada publicación.',
  'catalog.properties.publications.filters.status.all': 'Todos los estados',
  'catalog.properties.publications.filters.portal.all': 'Todos los portales',
  'catalog.properties.publications.filters.clear': 'Limpiar filtros',
  'catalog.properties.publications.filters.clearWithCount': 'Filtros ({count})',
  'catalog.properties.publications.table.code': 'Código',
  'catalog.properties.publications.table.property': 'Propiedad',
  'catalog.properties.publications.table.operation': 'Operación',
  'catalog.properties.publications.table.portal': 'Portal',
  'catalog.properties.publications.table.publication': 'Publicación',
  'catalog.properties.publications.table.status': 'Estado',
  'catalog.properties.publications.table.mode': 'Modo',
  'catalog.properties.publications.table.type': 'Tipo',
  'catalog.properties.publications.table.origin': 'Origen',
  'catalog.properties.publications.table.lastActivity': 'Última actividad',
  'catalog.properties.publications.table.actions': 'Acciones',
  'catalog.properties.publications.status.draft': 'Borrador',
  'catalog.properties.publications.status.published': 'Publicada',
  'catalog.properties.publications.status.paused': 'Pausada',
  'catalog.properties.publications.status.unpublished': 'No publicada',
  'catalog.properties.publications.status.error': 'Con error',
  'catalog.properties.publications.status.paymentRequired': 'Pendiente de pago',
  'catalog.properties.publications.status.underReview': 'En revisión',
  'catalog.properties.publications.status.closed': 'Finalizada',
  'catalog.properties.publications.statusTooltip.draft':
    'La publicación existe en Comos, pero todavía no está activa en el portal.',
  'catalog.properties.publications.statusTooltip.published':
    'La publicación está activa en el portal y Comos la sigue administrando.',
  'catalog.properties.publications.statusTooltip.paused':
    'La publicación sigue existiendo, pero el portal la mantiene pausada.',
  'catalog.properties.publications.statusTooltip.unpublished':
    'La publicación ya no está activa en el portal.',
  'catalog.properties.publications.statusTooltip.error':
    'La última acción sobre esta publicación falló y requiere revisión.',
  'catalog.properties.publications.statusTooltip.paymentRequired':
    'La publicación fue creada, pero el portal todavía requiere completar el pago o activar el plan correspondiente.',
  'catalog.properties.publications.statusTooltip.underReview':
    'El portal detuvo temporalmente esta publicación mientras la revisa.',
  'catalog.properties.publications.statusTooltip.closed':
    'El portal marcó esta publicación como finalizada o inactiva.',
  'catalog.properties.publications.statusTooltip.referenceOnly':
    'Comos conoce esta publicación solo como referencia y no la administra.',
  'catalog.properties.publications.statusTooltip.queuedPublish':
    'Comos ya encoló la publicación y está esperando la confirmación del portal.',
  'catalog.properties.publications.statusTooltip.unknown':
    'Comos todavía no tiene suficiente información para determinar el estado real de esta publicación.',
  'catalog.properties.publications.mode.managedPublish':
    'Publicada desde Comos',
  'catalog.properties.publications.mode.managedPublishTooltip':
    'Esta publicación se gestiona directamente desde Comos.',
  'catalog.properties.publications.mode.managedSync': 'Importada',
  'catalog.properties.publications.mode.managedSyncTooltip':
    'Esta publicación entró a Comos desde el flujo de sincronización del portal.',
  'catalog.properties.publications.mode.observedExternal': 'Referencia',
  'catalog.properties.publications.mode.observedExternalTooltip':
    'Esta fila existe como referencia externa y no se gestiona desde Comos.',
  'catalog.properties.publications.mode.unknown': 'Desconocido',
  'catalog.properties.publications.mode.unknownTooltip':
    'Comos todavía no tiene suficiente información para clasificar cómo se gestiona esta fila.',
  'catalog.properties.publications.type.connected': 'Vinculada',
  'catalog.properties.publications.type.connectedTooltip':
    'Esta es la fila local activa vinculada a la publicación real del portal.',
  'catalog.properties.publications.type.referenceOnly': 'Referencia',
  'catalog.properties.publications.type.referenceOnlyTooltip':
    'Esta fila es solo informativa y no administra activamente la publicación del portal.',
  'catalog.properties.publications.type.disconnected': 'Sin vínculo',
  'catalog.properties.publications.type.disconnectedTooltip':
    'Esta fila existe en Comos, pero actualmente no está vinculada a una publicación activa del portal.',
  'catalog.properties.publications.type.unknown': 'Desconocido',
  'catalog.properties.publications.type.unknownTooltip':
    'Comos todavía no tiene suficiente información para clasificar el vínculo actual.',
  'catalog.properties.publications.origin.unknown': 'Desconocido',
  'catalog.properties.publications.origin.meliTooltip':
    'Esta publicación se originó desde actividad de Mercado Libre.',
  'catalog.properties.publications.origin.wasiTooltip':
    'Esta publicación se originó desde actividad de Wasi.',
  'catalog.properties.publications.origin.toppropiedadesTooltip':
    'Esta publicación se originó desde actividad de Top Propiedades.',
  'catalog.properties.publications.origin.unknownTooltip':
    'Comos todavía no tiene suficiente información para identificar qué proveedor originó esta fila.',
  'catalog.properties.publications.operation.SALE': 'Venta',
  'catalog.properties.publications.operation.RENT': 'Arriendo',
  'catalog.properties.publications.operation.TEMPORARY_RENT':
    'Arriendo temporal',
  'catalog.properties.publications.operation.SALE_AND_RENT': 'Venta y arriendo',
  'catalog.properties.publications.operation.unknown': 'Sin definir',
  'catalog.properties.publications.property.unknownName':
    'Propiedad por completar',
  'catalog.properties.publications.property.unknownAddress':
    'Dirección por completar',
  'catalog.properties.publications.publication.unknown': 'Sin código',
  'catalog.properties.publications.empty.title': 'Todavía no hay publicaciones',
  'catalog.properties.publications.empty.description':
    'Cuando tus portales sincronicen o publiques desde Comos, las publicaciones vinculadas aparecerán aquí.',
  'catalog.properties.publications.error.title':
    'No pudimos cargar las publicaciones',
  'catalog.properties.publications.error.description':
    'Actualiza la página o vuelve a intentarlo en un momento.',
  'catalog.properties.error.retry': 'Reintentar',
  'catalog.properties.list.actions.openMap': 'Ver el mapa',
  'catalog.properties.list.badge.imported': 'Origen: {source}',
  'catalog.properties.list.fallback.location': 'Ubicación por completar',
  'catalog.properties.list.fallback.address': 'Dirección pública por completar',
  'catalog.properties.list.fallback.price': 'Precio por completar',
  'catalog.properties.list.fallback.metrics': 'Faltan características clave',
  'catalog.properties.list.metric.bedrooms': 'Dormitorios',
  'catalog.properties.list.metric.bathrooms': 'Baños',
  'catalog.properties.list.metric.areaUsable': 'Sup. útil',
  'catalog.properties.list.metric.areaTotal': 'Sup. total',
  'catalog.properties.list.metric.parkingLots': 'Estac.',
  'catalog.properties.list.updated': 'Actualizada {value}',
  'catalog.properties.form.operation': 'Operación',
  'catalog.properties.form.name': 'Nombre',
  'catalog.properties.form.description': 'Descripción',
  'catalog.properties.form.salePriceAmount': 'Monto precio venta',
  'catalog.properties.form.salePriceCurrency': 'Moneda precio venta',
  'catalog.properties.form.rentPriceAmount': 'Monto precio arriendo',
  'catalog.properties.form.rentPriceCurrency': 'Moneda precio arriendo',
  'catalog.properties.form.isActive': 'Propiedad activa',
  'catalog.properties.form.cadastralId': 'ROL',
  'catalog.properties.form.propertyType': 'Tipo de propiedad',
  'catalog.properties.form.condition': 'Condición',
  'catalog.properties.form.locality': 'Localidad',
  'catalog.properties.form.region': 'Región',
  'catalog.properties.form.addressDisplay': 'Dirección pública',
  'catalog.properties.form.streetName': 'Calle',
  'catalog.properties.form.streetNumber': 'Número',
  'catalog.properties.form.unit': 'Unidad / Depto.',
  'catalog.properties.form.neighborhood': 'Barrio / sector',
  'catalog.properties.form.externalMedia.title': 'Contenido multimedia externo',
  'catalog.properties.form.externalMedia.help':
    'Agrega videos de YouTube o tours virtuales de Matterport. Cada portal publicará el primer formato compatible.',
  'catalog.properties.form.externalMedia.provider.youtube': 'Video de YouTube',
  'catalog.properties.form.externalMedia.provider.matterport':
    'Tour virtual de Matterport',
  'catalog.properties.form.externalMedia.providerLabel':
    'Proveedor del contenido externo {position}',
  'catalog.properties.form.externalMedia.urlLabel':
    'URL del contenido externo {position}',
  'catalog.properties.form.externalMedia.add': 'Agregar contenido',
  'catalog.properties.form.externalMedia.remove': 'Quitar',
  'catalog.properties.form.bedrooms': 'Dormitorios',
  'catalog.properties.form.bathrooms': 'Baños',
  'catalog.properties.form.rooms': 'Ambientes',
  'catalog.properties.form.parkingLots': 'Estacionamientos',
  'catalog.properties.form.warehouses': 'Bodegas',
  'catalog.properties.form.unitFloor': 'Número de piso de la unidad',
  'catalog.properties.form.floors': 'Cantidad de pisos',
  'catalog.properties.form.apartmentsPerFloor': 'Departamentos por piso',
  'catalog.properties.form.propertyAge': 'Antigüedad',
  'catalog.properties.form.landAccess': 'Acceso',
  'catalog.properties.form.landAccess.DIRT': 'Tierra',
  'catalog.properties.form.landAccess.SAND': 'Arena',
  'catalog.properties.form.landAccess.ASPHALT': 'Asfalto',
  'catalog.properties.form.landAccess.GRAVEL': 'Ripio',
  'catalog.properties.form.landAccess.OTHER': 'Otro',
  'catalog.properties.form.orientation': 'Orientación',
  'catalog.properties.form.orientation.N': 'Norte',
  'catalog.properties.form.orientation.S': 'Sur',
  'catalog.properties.form.orientation.E': 'Oriente',
  'catalog.properties.form.orientation.W': 'Poniente',
  'catalog.properties.form.orientation.NE': 'Nororiente',
  'catalog.properties.form.orientation.NW': 'Norponiente',
  'catalog.properties.form.orientation.SE': 'Suroriente',
  'catalog.properties.form.orientation.SW': 'Surponiente',
  'catalog.properties.form.booleanState.unset': 'No informado',
  'catalog.properties.form.booleanState.yes': 'Sí',
  'catalog.properties.form.booleanState.no': 'No',
  'catalog.properties.form.featureState.legend':
    'Cada clic pasa al estado siguiente.',
  'catalog.properties.form.featureState.nextHint': 'Clic → {state}',
  'catalog.properties.form.subsection.main.title': 'Información principal',
  'catalog.properties.form.subsection.distribution.title': 'Distribución',
  'catalog.properties.form.subsection.building.title': 'Edificio y orientación',
  'catalog.properties.form.subsection.main.description':
    'Características base de la unidad que suelen ser obligatorias en portales.',
  'catalog.properties.form.subsection.layout.title': 'Distribución y edificio',
  'catalog.properties.form.subsection.layout.description':
    'Datos estructurales del edificio o de la unidad dentro del edificio.',
  'catalog.properties.form.subsection.surfaces.title': 'Superficies',
  'catalog.properties.form.surfaceUsable': 'Superficie útil (m²)',
  'catalog.properties.form.surfaceUsableHelp': 'Metros interiores utilizables.',
  'catalog.properties.form.surfaceUsableHelpOptional':
    'Solo si aplica. Si no existe, déjala vacía.',
  'catalog.properties.form.surfaceCovered': 'Superficie construida (m²)',
  'catalog.properties.form.surfaceCoveredHelp':
    'Metros construidos o edificados.',
  'catalog.properties.form.surfaceCoveredHelpOptional':
    'Solo si existe construcción.',
  'catalog.properties.form.surfaceTotal': 'Superficie total (m²)',
  'catalog.properties.form.surfaceTotalHelpLot':
    'Total publicado. En casas o terrenos, corresponde al terreno.',
  'catalog.properties.form.surfaceTotalHelpUnit':
    'Total publicado de la unidad.',
  'catalog.properties.form.surfaceOutdoor': 'Superficie exterior (m²)',
  'catalog.properties.form.surfaceOutdoorHelp':
    'Patio, terraza, jardín u otras áreas exteriores de uso exclusivo.',
  'catalog.properties.form.surfaceOutdoorHelpApartment':
    'Terraza u otras áreas exteriores de uso exclusivo.',
  'catalog.properties.form.surfaceOutdoorHelpLot': 'Patio, terraza o jardín.',
  'catalog.properties.form.surfacesHelp':
    'Usa los metros informados en la fuente original. Si un dato no existe, déjalo vacío.',
  'catalog.properties.form.featuresHelp':
    'Marca las amenidades y atributos que correspondan a esta propiedad.',
  'catalog.properties.form.featureGroup.conditions.title':
    'Condiciones y visibilidad',
  'catalog.properties.form.featureGroup.conditions.description':
    'Aspectos comerciales o de publicación que no siempre se conocen con certeza.',
  'catalog.properties.form.featureGroup.privateSpaces.title':
    'Espacios privados y confort',
  'catalog.properties.form.featureGroup.privateSpaces.description':
    'Ambientes, terminaciones y comodidades propias de la unidad.',
  'catalog.properties.form.featureGroup.commonAreas.title':
    'Áreas comunes y equipamiento',
  'catalog.properties.form.featureGroup.commonAreas.description':
    'Equipamiento del edificio o condominio, incluyendo seguridad.',
  'catalog.properties.form.feature.furnished': 'Amoblado',
  'catalog.properties.form.feature.petsAllowed': 'Admite mascotas',
  'catalog.properties.form.feature.hasVirtualTour': 'Tour virtual',
  'catalog.properties.form.feature.hasBalcony': 'Balcón',
  'catalog.properties.form.feature.hasKitchen': 'Cocina',
  'catalog.properties.form.feature.hasLift': 'Ascensor',
  'catalog.properties.form.feature.hasPlayground': 'Área de juegos',
  'catalog.properties.form.feature.hasRoofGarden': 'Azotea',
  'catalog.properties.form.feature.hasBusinessCenter': 'Cowork',
  'catalog.properties.form.feature.hasCinemaHall': 'Área de cine',
  'catalog.properties.form.feature.hasTennisCourt': 'Cancha de tenis',
  'catalog.properties.form.feature.hasGarden': 'Jardín',
  'catalog.properties.form.feature.hasPatio': 'Patio',
  'catalog.properties.form.feature.hasTerrace': 'Terraza',
  'catalog.properties.form.feature.hasLaundry': 'Lavandería',
  'catalog.properties.form.feature.hasPool': 'Piscina',
  'catalog.properties.form.feature.hasGym': 'Gimnasio',
  'catalog.properties.form.feature.hasSecurity': 'Seguridad',
  'catalog.properties.form.feature.hasHeating': 'Calefacción',
  'catalog.properties.form.feature.hasAirConditioning': 'Aire acondicionado',
  'catalog.properties.form.feature.hasInternetAccess': 'Acceso a internet',
  'catalog.properties.validation.nameRequired': 'El nombre es obligatorio',
  'catalog.properties.validation.nameTooLong':
    'El nombre no puede superar los {max} caracteres',
  'catalog.properties.validation.invalidUrl': 'URL inválida',
  'catalog.properties.validation.nonNegativeNumber':
    '{field} debe ser un número positivo',
  'catalog.properties.validation.nonNegativeInteger':
    '{field} debe ser un número entero positivo',
  'catalog.properties.form.commonExpensesAmount': 'Gastos comunes (CLP)',
  'catalog.properties.form.sourceUrl': 'URL de origen',
  'catalog.properties.form.sourceUrlPlaceholder':
    'https://ejemplo.cl/propiedad',
  'catalog.properties.propertyType.HOUSE': 'Casa',
  'catalog.properties.propertyType.APARTMENT': 'Departamento',
  'catalog.properties.propertyType.PARCEL': 'Parcela',
  'catalog.properties.propertyType.APARTMENT_STUDIO': 'Departamento - Estudio',
  'catalog.properties.propertyType.OFFICE': 'Oficina',
  'catalog.properties.propertyType.RETAIL': 'Local comercial',
  'catalog.properties.propertyType.WAREHOUSE': 'Bodega',
  'catalog.properties.propertyType.LAND': 'Terreno',
  'catalog.properties.propertyType.PARKING': 'Estacionamiento',
  'catalog.properties.propertyType.INDUSTRIAL': 'Industrial',
  'catalog.properties.propertyType.OTHER': 'Otro',
  'catalog.properties.propertyCondition.USED': 'Usada',
  'catalog.properties.propertyCondition.NEW': 'Nueva',
  'catalog.properties.price.saleLabel': 'Venta',
  'catalog.properties.price.rentLabel': 'Arriendo',
  'catalog.properties.operation.SALE': 'Venta',
  'catalog.properties.operation.RENT': 'Arriendo',
  'catalog.properties.operation.SALE_AND_RENT': 'Venta y Arriendo',
  'catalog.properties.operation.TEMPORARY_RENT': 'Arriendo temporal',
  'catalog.properties.import.title': 'Importar propiedades',
  'catalog.properties.import.description.tabular':
    'Sube un archivo de exportación (CSV/XLS/XLSX) para iniciar una importación o actualización.',
  'catalog.properties.import.description.spreadsheet':
    'Sube un archivo de exportación (XLS/XLSX) para iniciar una importación o actualización.',
  'catalog.properties.import.confirm': 'Iniciar importación',
  'catalog.properties.import.file.label.tabular': 'Archivo (CSV/XLS/XLSX)',
  'catalog.properties.import.file.label.spreadsheet': 'Archivo (XLS/XLSX)',
  'catalog.properties.import.provider.label': 'Proveedor',
  'catalog.properties.import.provider.option.prop360': 'Prop360 (Convecta)',
  'catalog.properties.import.provider.option.kutt': 'Kutt',
  'catalog.properties.import.provider.option.ilist': 'Ilist',
  'catalog.properties.import.provider.option.globalbrokers': 'Global Brokers',
  'catalog.properties.import.alert.success':
    'La importación de tus propiedades ha comenzado. Puede tardar unos minutos en completarse.',
  'catalog.properties.import.alert.noFile.tabular':
    'Selecciona un archivo CSV, XLS o XLSX.',
  'catalog.properties.import.alert.noFile.spreadsheet':
    'Selecciona un archivo XLS o XLSX.',
  'catalog.properties.import.alert.filterValueRequired':
    'Debes ingresar un valor para filtrar.',
  'catalog.properties.import.filter.toggle':
    'Importar sólo propiedades que coincidan',
  'catalog.properties.import.filter.columnLabel': 'Columna',
  'catalog.properties.import.filter.valueLabel': 'Valor a buscar',
  'catalog.properties.import.filter.column.agente': 'Agente',
  'catalog.properties.import.filter.column.oficina': 'Oficina',
  'catalog.properties.import.filter.column.type1': 'Tipo 1',
  'catalog.properties.import.filter.column.status': 'Estado',
  'catalog.properties.import.filter.column.region': 'Región',
  'catalog.properties.import.filter.matchType.equals': 'Igual a',
  'catalog.properties.import.filter.matchType.contains': 'Contiene',
  'catalog.properties.import.filter.matchType.startsWith': 'Comienza con',
  'catalog.properties.import.syncMissingPolicy.label':
    'Si una propiedad deja de llegar',
  'catalog.properties.import.syncMissingPolicy.help':
    'Elige si conservarla o desactivarla cuando deje de llegar en la importación.',
  'catalog.properties.import.syncMissingPolicy.option.upsert': 'Conservarla',
  'catalog.properties.import.syncMissingPolicy.option.replace': 'Desactivarla',
  'catalog.properties.import.kutt.filter.column.comuna': 'Comuna',
  'catalog.properties.import.kutt.filter.column.region': 'Región',
  'catalog.properties.import.kutt.filter.column.propertyType':
    'Tipo de propiedad',
  'catalog.properties.import.kutt.filter.column.operation': 'Tipo de operación',
  'catalog.properties.import.kutt.filter.column.status': 'Estado',
  'catalog.properties.import.ilist.filter.column.agent': 'Agente',
  'catalog.properties.import.ilist.filter.column.locality': 'Comuna',
  'catalog.properties.import.ilist.filter.column.province': 'Provincia',
  'catalog.properties.import.ilist.filter.column.propertyType':
    'Tipo de propiedad',
  'catalog.properties.import.ilist.filter.column.status':
    'Estado de la captación',
  'catalog.properties.import.globalbrokers.filter.column.locality': 'Comuna',
  'catalog.properties.import.globalbrokers.filter.column.status':
    'Estado de publicación',
  'catalog.properties.import.globalbrokers.filter.column.propertyType':
    'Tipo de propiedad',
  'catalog.properties.import.globalbrokers.filter.column.operation':
    'Tipo de publicación',
  'catalog.properties.import.globalbrokers.filter.column.currency': 'Moneda',
  'catalog.properties.import.assignment.label': 'Asignación',
  'catalog.properties.import.assignment.mode.keep': 'No asignar',
  'catalog.properties.import.assignment.mode.forceUser':
    'Asignar todo al usuario...',
  'catalog.properties.import.assignment.mode.auto': 'Asignar automático',
  'catalog.properties.import.assignment.userPlaceholder':
    'Selecciona un usuario',
  'catalog.properties.import.assignment.userEmpty':
    'No se encontraron usuarios',
  'catalog.properties.import.assignment.alert.userRequired':
    'Selecciona un usuario para asignar las propiedades.',
  'catalog.properties.import.assignment.help.keep':
    'No asigna ni cambia el usuario asignado en las propiedades importadas.',
  'catalog.properties.import.assignment.help.forceUser':
    'Asigna todas las propiedades importadas al usuario seleccionado (sobrescribe la asignación actual).',
  'catalog.properties.import.assignment.help.auto':
    'Usa la columna "Agente" para asociar usuarios. El nombre debe ser igual al nombre del usuario en la plataforma (sobrescribe la asignación actual).',
  'catalog.properties.confirmDeactivate.title': 'Desactivar propiedad',
  'catalog.properties.confirmDeactivate.confirm': 'Desactivar',
  'catalog.properties.confirmDeactivate.cancel': 'Cancelar',
  'catalog.properties.confirmDeactivate.fallbackName': 'esta propiedad',
  'catalog.properties.confirmDeactivate.messagePrefix':
    '¿Seguro que deseas desactivar',
  'catalog.properties.confirmDeactivate.messageSuffix':
    '? La propiedad dejará de estar activa en Comos.',
  'catalog.properties.confirmDeactivate.publicationImpact':
    'Si esta propiedad tiene publicaciones activas vinculadas, también se despublicarán en sus respectivos portales.',
  'catalog.properties.import.button': 'Importar',
  'catalog.properties.form.edit': 'Editar propiedad',
  'catalog.properties.form.create': 'Crear nueva propiedad',
  'catalog.properties.form.namePlaceholder': 'Nombre de la propiedad',
  'catalog.properties.form.descriptionPlaceholder': 'Describe la propiedad',
  'catalog.properties.form.latitude': 'Latitud',
  'catalog.properties.form.longitude': 'Longitud',
  'catalog.properties.editor.unsavedChanges': 'Cambios sin guardar',
  'catalog.properties.location.edit': 'Editar ubicación',
  'catalog.properties.location.add': 'Agregar ubicación',
  'catalog.properties.location.apply': 'Aplicar ubicación',
  'catalog.properties.location.saveWithProperty':
    'La ubicación se guardará al guardar la propiedad.',
  'catalog.properties.location.noAddress': 'Sin dirección',
  'catalog.properties.location.adjustMap': 'Ajustar en el mapa',
  'catalog.properties.location.unitSummary': 'Depto.',
  'catalog.properties.location.mapStripSetHelp': 'Ubicación definida',
  'shared.location.map.thumbnailAlt':
    'Ubicación de la propiedad en Google Maps',
  'shared.location.map.thumbnailUnavailable': 'Vista previa no disponible',
  'catalog.properties.location.mapStripHelp':
    'Define la posición exacta de la propiedad.',
  'catalog.properties.location.placeOnMap': 'Ubicar en el mapa',
  'catalog.properties.location.allCountries': 'Todos los países',
  'catalog.properties.location.searchCountry': 'País',
  'catalog.properties.location.country': 'País de la propiedad',
  'catalog.properties.location.countryPlaceholder': 'Selecciona un país',
  'catalog.properties.location.changeCountry': 'Cambiar',
  'catalog.properties.location.done': 'Listo',
  'catalog.properties.location.countryHelp':
    'Se completa con la dirección seleccionada. Cambiar el país borra los datos de dirección y el punto del mapa.',
  'catalog.properties.location.region': 'Región / estado',
  'catalog.properties.location.locality': 'Ciudad / localidad',
  'catalog.properties.location.map.reverseError':
    'No se encontró la dirección de este punto. Revisa el país e ingresa la dirección manualmente.',
  'shared.location.autocomplete.searchError':
    'La búsqueda de direcciones no está disponible. Intenta de nuevo o ingresa los datos manualmente.',
  'shared.location.autocomplete.resolveError':
    'No se pudieron cargar los datos de la dirección. Intenta otra vez o ingrésalos manualmente.',
  'catalog.properties.location.preview.title': 'Vista previa del mapa',
  'catalog.properties.location.preview.open': 'Abrir en Google Maps',
  'catalog.properties.location.preview.empty':
    'Agrega una dirección o coordenadas para previsualizar la ubicación de la propiedad.',
  'catalog.properties.location.preview.emptyAddress':
    'El mapa usa la dirección y las coordenadas que ingresas aquí.',
  'catalog.properties.location.preview.help':
    'Usa la dirección completa cuando sea posible. Las coordenadas ayudan a ajustar la posición final en el mapa.',
  'catalog.properties.location.autocomplete.title':
    'Busca la dirección en el mapa',
  'catalog.properties.location.autocomplete.description':
    'Busca una dirección en cualquier país y luego ajusta el punto del mapa o ingresa los datos manualmente.',
  'catalog.properties.location.autocomplete.placeholder':
    'Busca calle, edificio, barrio o comuna',
  'catalog.properties.location.regionPlaceholder':
    'Escribe o selecciona una región / estado',
  'catalog.properties.location.localityPlaceholder':
    'Escribe o selecciona una ciudad / localidad o ciudad',
  'catalog.properties.location.neighborhoodPlaceholder': 'Barrio o sector',
  'catalog.properties.location.addressPlaceholder':
    'Dirección pública que se mostrará externamente',
  'catalog.properties.location.streetNamePlaceholder': 'Calle',
  'catalog.properties.location.streetNumberPlaceholder': '123',
  'catalog.properties.location.unitPlaceholder': 'Depto. 101',
  'catalog.properties.location.map.help':
    'Haz clic en el mapa o mueve el marcador para ajustar la ubicación final.',
  'catalog.properties.location.map.empty':
    'Busca una dirección o haz clic en el mapa para definir la ubicación.',
  'catalog.properties.location.map.reverseLoading':
    'Actualizando la dirección desde el punto seleccionado…',
  'shared.location.autocomplete.help':
    'Escribe al menos 3 caracteres para buscar direcciones exactas.',
  'shared.location.autocomplete.loading': 'Buscando direcciones…',
  'shared.loading': 'Cargando…',
  'shared.location.autocomplete.empty': 'No se encontraron direcciones.',
  'shared.location.autocomplete.configurationMissing':
    'Google Maps todavía no está configurado.',
  'shared.location.map.configurationMissing':
    'Google Maps todavía no está configurado. Agrega VITE_GOOGLE_MAPS_API_KEY para habilitar el mapa interactivo.',
  'shared.location.map.loadError': 'No se pudo cargar Google Maps.',
  'shared.location.map.markerTitle': 'Marcador de ubicación de la propiedad',
  'catalog.properties.editor.createTitle': 'Crear propiedad',
  'catalog.properties.editor.editTitle': 'Editar propiedad',
  'catalog.properties.editor.createSubtitle':
    'Comienza con la información base y continúa con la publicación una vez guardada la propiedad.',
  'catalog.properties.editor.editSubtitle':
    'Mantén los datos de la propiedad y su estado de publicación en un solo lugar.',
  'catalog.properties.editor.backToList': 'Volver a propiedades',
  'catalog.properties.editor.save': 'Guardar',
  'catalog.properties.editor.create': 'Crear',
  'catalog.properties.editor.sections.overview': 'Resumen',
  'catalog.properties.editor.sections.overviewDescription':
    'Define la información principal que verán los clientes y los portales.',
  'catalog.properties.editor.sections.pricing': 'Precios',
  'catalog.properties.editor.sections.pricingDescription':
    'Configura los valores de venta y arriendo que alimentarán las publicaciones.',
  'catalog.properties.editor.sections.location': 'Ubicación',
  'catalog.properties.editor.sections.locationDescription':
    'Completa la dirección pública y las coordenadas usadas para publicación y búsqueda.',
  'catalog.properties.editor.sections.media': 'Medios',
  'catalog.properties.editor.sections.mediaDescription':
    'Gestiona las imágenes y otros archivos enviados a los portales.',
  'catalog.properties.editor.sections.publishing': 'Publicación',
  'catalog.properties.editor.sections.publishingDescription':
    'Configura los datos específicos de publicación y su estado.',
  'catalog.properties.editor.sections.characteristics':
    'Superficies y características',
  'catalog.properties.editor.sections.characteristicsDescription':
    'Registra los datos estructurales usados en importaciones, búsqueda y publicación.',
  'catalog.properties.editor.sections.mainInformation': 'Información principal',
  'catalog.properties.editor.sections.mainInformationDescription':
    'Completa la distribución, la información del edificio y las superficies que describen la unidad.',
  'catalog.properties.editor.sections.features': 'Características',
  'catalog.properties.editor.sections.featuresDescription':
    'Marca las amenidades, equipamiento y condiciones especiales asociadas a esta propiedad.',
  'catalog.properties.editor.sections.metadata': 'Metadatos de origen',
  'catalog.properties.editor.sections.metadataDescription':
    'Mantén referencias del origen y trazabilidad de importación para esta propiedad.',
  'catalog.properties.editor.placeholders.name': 'Nombre de la propiedad',
  'catalog.properties.editor.placeholders.description':
    'Describe la propiedad y sus principales atributos comerciales.',
  'catalog.properties.editor.loadErrorTitle':
    'No fue posible cargar la propiedad',
  'catalog.properties.editor.loadErrorDescription':
    'Revisa el identificador o vuelve al listado e inténtalo nuevamente.',
  'catalog.properties.editor.publishing.title': 'Publicación',
  'catalog.properties.editor.publishing.description':
    'Revisa y administra las publicaciones asociadas a esta propiedad.',
  'catalog.properties.editor.publishing.operationsTitle':
    'Publicación por operación',
  'catalog.properties.editor.publishing.operationsDescription':
    'Revisa el estado por operación y administra los detalles de publicación.',
  'catalog.properties.editor.publishing.syncCardTitle': 'Sincronización',
  'catalog.properties.editor.publishing.syncTimeline.title': 'Actividad',
  'catalog.properties.editor.publishing.syncTimeline.empty':
    'Todavía no hay eventos de sincronización para esta propiedad.',
  'catalog.properties.editor.publishing.syncTimeline.syncApplied':
    'Datos actualizados',
  'catalog.properties.editor.publishing.syncTimeline.syncSkipped':
    'No hay nuevas actualizaciones',
  'catalog.properties.editor.publishing.syncTimeline.syncFailed':
    'Error al actualizar',
  'catalog.properties.editor.publishing.publicationIdentifier':
    'Publicación {value}',
  'catalog.properties.editor.publishing.publicationGeneric': 'Publicación',
  'catalog.properties.editor.publishing.saveFirstTitle':
    'Guarda primero la propiedad',
  'catalog.properties.editor.publishing.saveFirstDescription':
    'La sección de publicación estará disponible cuando la propiedad exista en Comos.',
  'catalog.properties.editor.publishing.connectTitle':
    'Conecta Mercado Libre primero',
  'catalog.properties.editor.publishing.connectDescription':
    'Ve a Integraciones y conecta Mercado Libre antes de administrar publicaciones.',
  'catalog.properties.editor.publishing.unsupportedTitle':
    'Operación no soportada',
  'catalog.properties.editor.publishing.unsupportedDescription':
    'La operación de esta propiedad todavía no es publicable en Mercado Libre.',
  'catalog.properties.editor.publishing.syncModeTitle':
    'El modo sincronización está activo',
  'catalog.properties.editor.publishing.syncModeDescription':
    'El modo sincronización está activo. Las acciones de publicación desde Comos están deshabilitadas.',
  'catalog.properties.editor.publishing.sourceOfTruthTitle': 'Fuente de verdad',
  'catalog.properties.editor.publishing.sourceOfTruthSyncDescription':
    'Esta propiedad está administrada por una integración. Los cambios en Comos pueden ser reemplazados en la próxima actualización.',
  'catalog.properties.editor.publishing.sourceOfTruthPublishDescription':
    'Esta propiedad se originó en Mercado Libre. Revisa con cuidado los cambios de publicación para no sobrescribir inesperadamente el origen sincronizado.',
  'catalog.properties.editor.publishing.syncOwnership.modeSync': 'SYNC',
  'catalog.properties.editor.publishing.syncOwnership.modePublish':
    'PUBLICACIÓN',
  'catalog.properties.editor.publishing.syncOwnership.sourceSystem':
    'Sistema origen',
  'catalog.properties.editor.publishing.syncOwnership.sourceId': 'ID origen',
  'catalog.properties.editor.publishing.syncOwnership.sourceCode':
    'Código origen',
  'catalog.properties.editor.publishing.syncOwnership.linkedPublicationsLabel':
    'Publicaciones vinculadas',
  'catalog.properties.editor.publishing.syncOwnership.linkedPublications':
    '{count} publicaciones vinculadas',
  'catalog.properties.editor.publishing.syncOwnership.assignmentTitle':
    'Asignación del agente',
  'catalog.properties.editor.publishing.syncOwnership.assignmentResolved':
    'Asignada en Comos',
  'catalog.properties.editor.publishing.syncOwnership.assignmentResolvedDescription':
    'Se encontró un usuario de Comos a partir del contacto vendedor informado por Mercado Libre.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentResolvedBySourceDescription':
    'Se asignó automáticamente en Comos usando el {value} informado por Mercado Libre.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentPending':
    'Revisión manual pendiente',
  'catalog.properties.editor.publishing.syncOwnership.assignmentPendingDescription':
    'Comos todavía no pudo resolver un usuario asignado a partir del contacto vendedor.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentAmbiguous':
    'Múltiples posibles asignados',
  'catalog.properties.editor.publishing.syncOwnership.assignmentAmbiguousDescription':
    'El contacto vendedor de Mercado Libre coincide con más de un usuario de Comos y requiere revisión manual.',
  'catalog.properties.editor.publishing.syncOwnership.assignmentSource.email':
    'correo',
  'catalog.properties.editor.publishing.syncOwnership.assignmentSource.phone':
    'teléfono',
  'catalog.properties.editor.publishing.syncOwnership.fieldsTitle':
    'Campos administrados',
  'catalog.properties.editor.publishing.syncOwnership.consequencesTitle':
    'Qué ocurre en este modo',
  'catalog.properties.editor.publishing.syncOwnership.field.title': 'Título',
  'catalog.properties.editor.publishing.syncOwnership.field.description':
    'Descripción',
  'catalog.properties.editor.publishing.syncOwnership.field.location':
    'Ubicación',
  'catalog.properties.editor.publishing.syncOwnership.field.media': 'Medios',
  'catalog.properties.editor.publishing.syncOwnership.field.status': 'Estado',
  'catalog.properties.editor.publishing.syncOwnership.field.assignee':
    'Asignación',
  'catalog.properties.editor.publishing.syncOwnership.consequence.overwrite':
    'La próxima sincronización de Mercado Libre puede sobrescribir estos campos en Comos.',
  'catalog.properties.editor.publishing.syncOwnership.consequence.publishLocked':
    'Las acciones de publicación permanecen bloqueadas mientras esta integración use modo sincronización.',
  'catalog.properties.editor.publishing.syncOwnership.consequence.publishSource':
    'Comos es la fuente de verdad actual para los cambios de publicación.',
  'catalog.properties.editor.publishing.syncOwnership.consequence.ignoreUnlinked':
    'Las publicaciones de Mercado Libre no vinculadas se ignoran mientras la integración permanezca en modo publicación.',
  'catalog.properties.editor.publishing.syncManagedPublicationHint':
    'Esta publicación es administrada por la sincronización y puede sobrescribirse en la próxima actualización del proveedor.',
  'catalog.properties.editor.publishing.viewDetails': 'Ver detalle',
  'catalog.properties.editor.publishing.selected': 'Seleccionada',
  'catalog.properties.editor.publishing.actions.viewTooltip':
    'Revisar esta publicación',
  'catalog.properties.editor.publishing.actions.selectedTooltip':
    'Publicación actualmente seleccionada',
  'catalog.properties.editor.publishing.actions.manage':
    'Administrar publicación',
  'catalog.properties.editor.publishing.actions.manageTooltip':
    'Abrir la configuración de esta publicación en Mercado Libre',
  'catalog.properties.editor.publishing.actions.manageDescription':
    'administrar esta publicación desde Comos',
  'catalog.properties.editor.publishing.actions.openExternal':
    'Abrir publicación',
  'catalog.properties.editor.publishing.actions.openExternalTooltip':
    'Abrir la publicación pública en el portal',
  'catalog.properties.editor.publishing.actions.openInMenuCaption': 'Abrir en…',
  'catalog.properties.editor.publishing.actions.openInProvider':
    'Ver en {provider}',
  'catalog.properties.editor.publishing.actions.repairSync':
    'Sincronizar ahora',
  'catalog.properties.editor.publishing.actions.publish': 'Publicar',
  'catalog.properties.editor.publishing.actions.publishDescription':
    'publicar o actualizar esta publicación desde Comos',
  'catalog.properties.editor.publishing.actions.publishTooltip':
    'Publicar o actualizar esta publicación en Mercado Libre',
  'catalog.properties.editor.publishing.actions.publishInactiveTooltip':
    'Activa la propiedad en Comos antes de publicarla o actualizarla en Mercado Libre.',
  'catalog.properties.editor.publishing.actions.publishIssuesTooltip':
    '{firstIssue}\n\nHay {count} problemas de validación.\nRevisa el detalle completo en el modal de administración.',
  'catalog.properties.editor.publishing.actions.publishIssuesCount':
    'Hay {count} problemas de validación.',
  'catalog.properties.editor.publishing.actions.publishIssuesDetailsHint':
    'Revisa el detalle completo en el modal de administración.',
  'catalog.properties.meli.actions.validating': 'Validando publicación…',
  'catalog.properties.editor.publishing.actions.history': 'Ver actividad',
  'catalog.properties.editor.publishing.actions.historyTooltip':
    'Abrir actividad de la publicación',
  'catalog.properties.editor.publishing.history.showOlderPublications':
    'Ver {count} publicaciones anteriores',
  'catalog.properties.editor.publishing.history.hideOlderPublications':
    'Ocultar {count} publicaciones anteriores',
  'catalog.properties.editor.publishing.actions.unpublish': 'Despublicar',
  'catalog.properties.editor.publishing.actions.unpublishDescription':
    'despublicar esta publicación desde Comos',
  'catalog.properties.editor.publishing.actions.unpublishTooltip':
    'Retirar esta publicación de Mercado Libre',
  'catalog.properties.editor.publishing.actions.integrationMissingTooltip':
    'Conecta {provider} para {action}.',
  'catalog.properties.editor.publishing.actions.integrationDisconnectedTooltip':
    '{provider} está desconectado. Reconéctalo para {action}.',
  'catalog.properties.editor.publishing.summary.pendingPublish':
    'Estamos publicando esta operación',
  'catalog.properties.editor.publishing.summary.updatedAt':
    'Actualizada {value}',
  'catalog.properties.editor.publishing.summary.syncAssignmentAmbiguous':
    'La sincronización de Mercado Libre requiere revisar la asignación.',
  'catalog.properties.editor.publishing.summary.syncAssignmentPending':
    'La sincronización de Mercado Libre todavía no tiene un asignado coincidente.',
  'catalog.properties.editor.publishing.summary.syncAssignmentResolved':
    'Sincronizada · asignada por {value}.',
  'catalog.properties.editor.publishing.summary.syncAssignmentResolvedGeneric':
    'Sincronizada · asignada automáticamente.',
  'catalog.properties.editor.publishing.summary.publishSource':
    'Comos controla esta publicación desde este editor.',
  'catalog.properties.editor.publishing.summary.referenceOnly':
    'Publicada en {provider}. No está conectada ni administrada desde Comos.',
  'catalog.properties.editor.publishing.summary.referenceOnlyWithSource':
    'Importada desde {source}. No está conectada ni administrada desde Comos.',
  'catalog.properties.editor.publishing.summary.paymentRequired':
    'Publicada, pero Mercado Libre todavía requiere pago.',
  'catalog.properties.publicationAlerts.billingBlocked.title':
    'Pausa por facturación en Mercado Libre',
  'catalog.properties.publicationAlerts.billingBlocked.summary':
    'Publicación pausada por un saldo pendiente',
  'catalog.properties.publicationAlerts.billingBlocked.description':
    'Regulariza el saldo pendiente en Mercado Libre. Esta pausa no cambia la disponibilidad de la propiedad en Comos.',
  'catalog.properties.publicationAlerts.billingPauseContinued.title':
    'La publicación sigue pausada en Mercado Libre',
  'catalog.properties.publicationAlerts.billingPauseContinued.summary':
    'La publicación sigue pausada después de levantarse la restricción de facturación',
  'catalog.properties.publicationAlerts.billingPauseContinued.description':
    'Revisa la publicación en Mercado Libre. Esta pausa no cambia la disponibilidad de la propiedad; usa los controles habituales de la propiedad si su disponibilidad cambió.',
  'catalog.properties.publicationAlerts.paymentRequired.title':
    'Pago pendiente en el portal',
  'catalog.properties.publicationAlerts.paymentRequired.summary':
    'Mercado Libre todavía requiere un paso de pago.',
  'catalog.properties.publicationAlerts.paymentRequired.description':
    'La publicación fue creada, pero el portal todavía requiere completar el pago o activar el plan correspondiente.',
  'catalog.properties.publicationAlerts.underReview.title':
    'Revisión pendiente en el portal',
  'catalog.properties.publicationAlerts.underReview.summary':
    'Mercado Libre inactivó temporalmente esta publicación mientras la revisa.',
  'catalog.properties.publicationAlerts.underReview.description':
    'Revisa la publicación directamente en Mercado Libre para entender la restricción y resolverla allí.',
  'catalog.properties.editor.publishing.notPublishedDescription':
    'Esta operación todavía no está publicada.',
  'catalog.properties.editor.publishing.status.referenceOnly':
    'Referencia externa',
  'catalog.properties.editor.publishing.operationUnknown':
    'Operación sin definir',
  'catalog.properties.editor.publishing.activity.externalId': 'ID {value}',
  'catalog.properties.editor.publishing.activity.synced': 'Sincronizada',
  'catalog.properties.editor.publishing.activity.attempted': 'Intentada',
  'catalog.properties.editor.publishing.activity.updated': 'Actualizada',
  'catalog.properties.editor.publishing.activity.nextSync':
    'Próxima sincronización',
  'catalog.properties.editor.publishing.syncedAt':
    'Última sincronización: {value}',
  'catalog.properties.editor.publishing.target.meli': 'Mercado Libre',
  'catalog.properties.editor.publishing.target.meliPoi':
    'Mercado Libre + PortalInmobiliario',
  'catalog.properties.editor.confirmRepublish.title':
    'Actualizar publicaciones activas',
  'catalog.properties.editor.confirmRepublish.description':
    'Guardar estos cambios actualizará las publicaciones activas vinculadas a esta propiedad en sus respectivos portales.',
  'catalog.properties.editor.confirmRepublish.confirm': 'Guardar y actualizar',
  'catalog.properties.editor.confirmRepublish.cancel': 'Cancelar',
  'catalog.properties.editor.confirmDeactivate.title': 'Desactivar propiedad',
  'catalog.properties.editor.confirmDeactivate.description':
    'Guardar estos cambios desactivará esta propiedad en Comos.',
  'catalog.properties.editor.confirmDeactivate.confirm': 'Guardar y desactivar',
  'catalog.properties.editor.confirmDeactivate.cancel': 'Cancelar',
  'catalog.properties.table.actions.view': 'Ver',
  'catalog.properties.table.actions.edit': 'Editar',
  'catalog.properties.table.actions.deactivate': 'Desactivar',
  'catalog.properties.alert.create.success': 'Propiedad creada correctamente',
  'catalog.properties.alert.create.error': 'Error al crear la propiedad',
  'catalog.properties.alert.update.success':
    'Propiedad actualizada correctamente',
  'catalog.properties.alert.update.error': 'Error al actualizar la propiedad',
  'catalog.properties.alert.deactivate.success':
    'Propiedad desactivada correctamente',
  'catalog.properties.alert.deactivate.error':
    'Error al desactivar la propiedad',
  'catalog.properties.permissions.readRequiredTitle':
    'No tienes permisos para ver propiedades.',
  'catalog.properties.permissions.readRequiredDescription':
    'Necesitas permisos de lectura de catálogo para acceder a esta vista.',
  'catalog.properties.publications.permissions.readRequiredTitle':
    'No tienes permisos para ver publicaciones.',
  'catalog.properties.publications.permissions.readRequiredDescription':
    'Necesitas permisos de lectura de integraciones para revisar publicaciones de portales.',
  'catalog.properties.meli.modal.title': 'Publicación en Mercado Libre',
  'catalog.properties.meli.modal.description':
    'Valida y gestiona la publicación de esta propiedad en Mercado Libre.',
  'catalog.properties.meli.unsupportedOperation':
    'Esta propiedad no tiene una operación compatible para publicar en Mercado Libre.',
  'catalog.properties.meli.form.operation': 'Operación',
  'catalog.properties.meli.form.portalTarget': 'Portal',
  'catalog.properties.meli.form.selectedOperation': 'Operación seleccionada',
  'catalog.properties.meli.form.listingType': 'Tipo de publicación',
  'catalog.properties.meli.form.listingType.default':
    'Usar predeterminado de Mercado Libre',
  'catalog.properties.meli.listingTypes.free': 'Gratis',
  'catalog.properties.meli.listingTypes.goldPremium': 'Oro Premium',
  'catalog.properties.meli.listingTypes.gold': 'Oro',
  'catalog.properties.meli.listingTypes.silver': 'Plata',
  'catalog.properties.meli.category.helpTitle':
    'La categoría se resuelve automáticamente',
  'catalog.properties.meli.category.helpDescription':
    'Comos selecciona la categoría de Mercado Libre a partir del tipo de propiedad y la operación. Sólo necesitas completar los datos estructurados.',
  'catalog.properties.meli.category.resolvedLabel': 'Categoría resuelta',
  'catalog.properties.meli.category.inlineDescription':
    'Comos calcula esta categoría a partir del tipo de propiedad, la operación y los campos estructurados.',
  'catalog.properties.meli.category.autoResolved':
    'Seleccionada automáticamente según los datos de la propiedad.',
  'catalog.properties.meli.category.unavailable':
    'Completa los datos estructurados de la propiedad para resolver la categoría automáticamente.',
  'catalog.properties.meli.portalTarget.meli': 'Mercado Libre',
  'catalog.properties.meli.portalTarget.meliPoi':
    'Mercado Libre + Portal Inmobiliario',
  'catalog.properties.meli.images.title': 'Imágenes',
  'catalog.properties.meli.images.description':
    'Selecciona cuáles imágenes de la propiedad se usarán en esta publicación.',
  'catalog.properties.meli.images.empty':
    'Agrega imágenes de la propiedad en la sección multimedia antes de publicar.',
  'catalog.properties.meli.images.selectionHint':
    'Si no seleccionas un subconjunto, se usarán todas las imágenes de la propiedad.',
  'catalog.properties.meli.validation.field.sellerContact': 'Contacto vendedor',
  'catalog.properties.meli.validation.field.isSuitableForPets':
    'Admite mascotas',
  'catalog.properties.meli.validation.issue.missing_title':
    'El título de la propiedad es obligatorio para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_description':
    'La descripción de la propiedad es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_property_type':
    'El tipo de propiedad es obligatorio para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_condition':
    'La condición de la propiedad es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_operation':
    'La operación de la propiedad es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_sale_price':
    'Debes ingresar un precio de venta válido para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_rent_price':
    'Debes ingresar un precio de arriendo válido para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_sale_currency':
    'Debes ingresar una moneda de venta válida para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_rent_currency':
    'Debes ingresar una moneda de arriendo válida para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_address_line':
    'Debes completar la dirección pública para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_location_node':
    'Debes completar una ubicación clasificada de Mercado Libre. Revisa barrio o comuna.',
  'catalog.properties.meli.validation.issue.missing_latitude':
    'La latitud es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_longitude':
    'La longitud es obligatoria para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_seller_contact':
    'Debes configurar un contacto vendedor para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_pictures':
    'Agrega al menos una imagen antes de publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.resolved_location_required':
    'Debes completar una ubicación válida para publicar en Mercado Libre.',
  'catalog.properties.meli.validation.issue.required_area_total':
    'La superficie total es obligatoria en Mercado Libre para la categoría resuelta.',
  'catalog.properties.meli.validation.issue.required_area_usable':
    'La superficie útil es obligatoria en Mercado Libre para la categoría resuelta.',
  'catalog.properties.meli.validation.issue.required_bedrooms':
    'Los dormitorios son obligatorios en Mercado Libre para la categoría resuelta.',
  'catalog.properties.meli.validation.issue.required_bathrooms':
    'Los baños son obligatorios en Mercado Libre para la categoría resuelta.',
  'catalog.properties.meli.validation.issue.required_parking_lots':
    'Los estacionamientos son obligatorios en Mercado Libre para la categoría resuelta. Si no tiene estacionamientos, indica 0.',
  'catalog.properties.meli.validation.issue.inactive_property':
    'Activa esta propiedad en Comos antes de publicarla o actualizarla en Mercado Libre.',
  'catalog.properties.meli.validation.issue.missing_category_required_attribute':
    'Completa {field}. Mercado Libre lo exige para esta categoría de propiedad.',
  'catalog.properties.meli.validation.issue.unsupported_external_media':
    'Usa una URL válida de YouTube o un enlace compartido de Matterport.',
  'catalog.properties.meli.currentPublication.syncManaged':
    'Vinculada con {provider}',
  'catalog.properties.meli.currentPublication.syncManagedDescription':
    'Los cambios detectados en la publicación origen pueden sincronizarse en Comos y actualizar esta propiedad.',
  'catalog.properties.meli.currentPublication.syncManagedSyncModeDescription':
    'Puedes revisar esta publicación desde Comos, pero {provider} controla los cambios.',
  'catalog.properties.meli.currentPublication.syncManagedPublishModeDescription':
    'Esta publicación se originó en {provider} y puede volver a sincronizarse sobre cambios hechos en Comos.',
  'catalog.properties.meli.currentPublication.paymentRequiredBadge':
    'Pago pendiente',
  'catalog.properties.meli.currentPublication.paymentRequiredDescription':
    'Mercado Libre creó la publicación, pero el portal todavía requiere completar un paso de pago antes de dejarla completamente activa.',
  'catalog.properties.meli.currentPublication.openExternal':
    'Abrir publicación en Mercado Libre',
  'catalog.properties.meli.currentPublication.pendingPublish':
    'Estamos enviando esta publicación a Mercado Libre.',
  'catalog.properties.meli.currentPublication.history.modalTitle':
    'Actividad de publicación · {operation}',
  'catalog.properties.meli.currentPublication.history.modalDescription':
    'Revisa la trazabilidad completa de esta operación en Mercado Libre.',
  'catalog.properties.meli.currentPublication.history.title': 'Actividad',
  'catalog.properties.meli.currentPublication.history.empty':
    'Todavía no hay eventos para esta publicación.',
  'catalog.properties.meli.currentPublication.history.created': 'Creada',
  'catalog.properties.meli.currentPublication.history.draft_prepared':
    'Borrador preparado',
  'catalog.properties.meli.currentPublication.history.publish_enqueued':
    'Publicación solicitada',
  'catalog.properties.meli.currentPublication.history.published': 'Publicada',
  'catalog.properties.meli.currentPublication.history.publish_failed':
    'Publicación con error',
  'catalog.properties.meli.currentPublication.history.pause_enqueued':
    'Pausa solicitada',
  'catalog.properties.meli.currentPublication.history.paused': 'Pausada',
  'catalog.properties.meli.currentPublication.history.pause_failed':
    'Pausa con error',
  'catalog.properties.meli.currentPublication.history.unpublish_enqueued':
    'Despublicación solicitada',
  'catalog.properties.meli.currentPublication.history.unpublished':
    'Despublicada',
  'catalog.properties.meli.currentPublication.history.unpublish_failed':
    'Despublicación con error',
  'catalog.properties.meli.currentPublication.history.sync_applied':
    'Datos actualizados',
  'catalog.properties.meli.currentPublication.history.sync_skipped':
    'No hay nuevas actualizaciones',
  'catalog.properties.meli.currentPublication.history.sync_failed':
    'Error al actualizar',
  'catalog.properties.meli.currentPublication.history.attempted':
    'Último intento',
  'catalog.properties.meli.currentPublication.history.synced':
    'Última sincronización',
  'catalog.properties.meli.currentPublication.history.updated':
    'Última actualización',
  'catalog.properties.meli.currentPublication.history.nextSync':
    'Próxima sincronización',
  'catalog.properties.meli.currentPublication.history.error': 'Último error',
  'catalog.properties.publicationProblems.missingRemoteListing':
    'La publicación ya no existe en el inventario remoto del vendedor.',
  'catalog.properties.meli.currentPublication.history.filter.all': 'Todo',
  'catalog.properties.meli.currentPublication.history.filter.lifecycle':
    'Publicación',
  'catalog.properties.meli.currentPublication.history.filter.sync':
    'Sincronización',
  'catalog.properties.meli.currentPublication.history.details.itemId':
    'Publicación',
  'catalog.properties.meli.currentPublication.history.details.action': 'Acción',
  'catalog.properties.meli.currentPublication.history.details.code': 'Código',
  'catalog.properties.meli.currentPublication.history.details.portalTarget':
    'Destino',
  'catalog.properties.meli.currentPublication.history.details.listingTypeId':
    'Plan',
  'catalog.properties.meli.currentPublication.history.details.categoryId':
    'Categoría',
  'catalog.properties.meli.currentPublication.history.details.status': 'Estado',
  'catalog.properties.meli.currentPublication.history.details.paymentRequired':
    'Pago requerido',
  'catalog.properties.meli.currentPublication.history.details.reason': 'Motivo',
  'catalog.properties.meli.currentPublication.history.details.remoteStatus':
    'Estado proveedor',
  'catalog.properties.meli.currentPublication.history.details.propertyAction':
    'Propiedad',
  'catalog.properties.meli.currentPublication.history.details.publicationAction':
    'Publicación',
  'catalog.properties.meli.currentPublication.history.details.assigneeSource':
    'Asignación por',
  'catalog.properties.meli.currentPublication.history.details.assigneeResolution':
    'Resolución de asignación',
  'catalog.properties.meli.currentPublication.history.value.assigneeSource.email':
    'Email',
  'catalog.properties.meli.currentPublication.history.value.assigneeSource.phone':
    'Teléfono',
  'catalog.properties.meli.currentPublication.history.value.assigneeSource.none':
    'Sin coincidencia',
  'catalog.properties.meli.currentPublication.history.value.assigneeResolution.resolved':
    'Resuelta automáticamente',
  'catalog.properties.meli.currentPublication.history.value.assigneeResolution.ambiguous':
    'Requiere revisión manual',
  'catalog.properties.meli.currentPublication.history.value.assigneeResolution.notFound':
    'Sin coincidencia',
  'catalog.properties.meli.currentPublication.history.value.paymentRequired.yes':
    'Sí',
  'catalog.properties.meli.currentPublication.history.value.paymentRequired.no':
    'No',
  'catalog.properties.meli.currentPublication.history.value.propertyAction.created':
    'Creada',
  'catalog.properties.meli.currentPublication.history.value.propertyAction.updated':
    'Actualizada',
  'catalog.properties.meli.currentPublication.history.value.publicationAction.created':
    'Creada',
  'catalog.properties.meli.currentPublication.history.value.publicationAction.updated':
    'Actualizada',
  'integrations.activity.type.connection_connected': 'Integración conectada',
  'integrations.activity.type.connection_updated': 'Configuración actualizada',
  'integrations.activity.type.connection_disconnected':
    'Integración desconectada',
  'integrations.activity.type.sync_requested': 'Sincronización solicitada',
  'integrations.activity.type.sync_started': 'Sincronización iniciada',
  'integrations.activity.type.sync_applied': 'Datos sincronizados',
  'integrations.activity.type.sync_skipped': 'Sin cambios para aplicar',
  'integrations.activity.type.sync_failed': 'Error de sincronización',
  'integrations.activity.type.sync_completed': 'Sincronización completada',
  'integrations.activity.type.sync_superseded': 'Sincronización reemplazada',
  'integrations.activity.type.sync_reconciliation_applied':
    'Publicación reconciliada',
  'integrations.activity.type.publication_created': 'Publicación creada',
  'integrations.activity.type.publication_draft_prepared': 'Borrador preparado',
  'integrations.activity.type.publication_publish_enqueued':
    'Publicación en cola',
  'integrations.activity.type.publication_published': 'Publicación publicada',
  'integrations.activity.type.publication_publish_failed': 'Error al publicar',
  'integrations.activity.type.publication_pause_enqueued': 'Pausa en cola',
  'integrations.activity.type.publication_paused': 'Publicación pausada',
  'integrations.activity.type.publication_pause_failed': 'Error al pausar',
  'integrations.activity.type.publication_unpublish_enqueued':
    'Despublicación en cola',
  'integrations.activity.type.publication_unpublished':
    'Publicación despublicada',
  'integrations.activity.type.publication_unpublish_failed':
    'Error al despublicar',
  'integrations.activity.details.providerSubject': 'Cuenta origen',
  'integrations.activity.details.processedCount': 'Items procesados',
  'integrations.activity.details.failedCount': 'Items con error',
  'integrations.activity.details.limit': 'Tamaño de página',
  'integrations.activity.details.previousStatus': 'Estado anterior',
  'integrations.activity.details.healthStatus': 'Salud',
  'integrations.activity.details.previousHealthStatus': 'Salud anterior',
  'integrations.activity.details.sourceEventType': 'Origen',
  'integrations.activity.details.staleReason': 'Motivo',
  'integrations.activity.details.cursor': 'Cursor',
  'integrations.activity.details.failedItemCount': 'Items con error',
  'integrations.activity.details.phase': 'Fase',
  'integrations.activity.details.mappingSyncRevision': 'Revisión vigente',
  'integrations.activity.details.reconciliationTriggered':
    'Reconciliación ejecutada',
  'integrations.activity.value.sourceEventType.backfill': 'Backfill',
  'integrations.activity.value.sourceEventType.notification': 'Notificación',
  'integrations.activity.value.staleReason.mapping_not_found':
    'No se encontró la conexión en subscriptions',
  'integrations.activity.value.staleReason.missing_event_sync_revision':
    'La corrida en cola no tenía revisión de sincronización',
  'integrations.activity.value.staleReason.mapping_missing_sync_revision':
    'La conexión actual no tiene revisión de sincronización',
  'integrations.activity.value.staleReason.stale_sync_revision':
    'Fue reemplazada por una sincronización más nueva',
  'catalog.properties.meli.status.draft': 'Borrador',
  'catalog.properties.meli.status.queuedPublish': 'Publicando',
  'catalog.properties.meli.status.published': 'Publicada',
  'catalog.properties.meli.status.paused': 'Pausada',
  'catalog.properties.meli.status.unpublished': 'Despublicada',
  'catalog.properties.meli.status.error': 'Con error',
  'catalog.properties.meli.status.notPublished': 'Sin publicar',
  'catalog.properties.meli.draft.title': 'Validación',
  'catalog.properties.meli.draft.issuesCount': '{count} observaciones',
  'catalog.properties.meli.draft.selectedListingType':
    'Plan seleccionado: {listingTypeName}',
  'catalog.properties.meli.draft.noIssues':
    'La publicación está lista para enviarse a Mercado Libre.',
  'catalog.properties.meli.draft.empty':
    'La validación se actualiza automáticamente cuando cambias los datos de la publicación.',
  'catalog.properties.meli.actions.publish': 'Publicar',
  'catalog.properties.meli.actions.pause': 'Pausar',
  'catalog.properties.meli.actions.unpublish': 'Despublicar',
  'catalog.properties.meli.actions.close': 'Cerrar',
  'catalog.properties.meli.alert.fixDraftIssues':
    'Corrige las observaciones antes de publicar en Mercado Libre.',
  'catalog.properties.meli.alert.publishQueued':
    'La publicación comenzó a procesarse y aparecerá actualizada en breve.',
  'catalog.properties.meli.alert.pauseQueued':
    'La pausa comenzó a procesarse y se reflejará en breve.',
  'catalog.properties.meli.alert.unpublishQueued':
    'La despublicación comenzó a procesarse y se reflejará en breve.',
  'catalog.properties.editor.publishing.alert.repairSyncQueued':
    'La reparación del sync quedó en cola y las publicaciones origen se reprocesarán en breve.',
  'catalog.properties.media.title': 'Archivos de la propiedad',
  'catalog.properties.media.description':
    'Sube los archivos que representan esta propiedad. Se reutilizarán en la ficha y en las publicaciones de portales.',
  'catalog.properties.media.empty':
    'Todavía no hay archivos agregados a esta propiedad.',
  'catalog.properties.media.upload': 'Subir archivos',
  'catalog.properties.media.countSingular': '{count} archivo',
  'catalog.properties.media.countPlural': '{count} archivos',
  'catalog.properties.media.dropzone.title':
    'Arrastra archivos aquí o selecciónalos desde tu computador',
  'catalog.properties.media.dropzone.helper':
    'Suelta los archivos para agregarlos a la propiedad.',
  'catalog.properties.media.preview': 'Ver',
  'catalog.properties.media.select': 'Usar',
  'catalog.properties.media.selected': 'Usando',
  'catalog.properties.media.reorder': 'Arrastrar para reordenar',
  'catalog.properties.media.remove': 'Quitar',
  'catalog.properties.form.sourceSystem': 'Sistema de origen',
  'catalog.properties.form.sourceSystemPlaceholder':
    'prop360, ilist, toppropiedades…',
  'catalog.properties.form.sourceId': 'ID de origen',
  'catalog.properties.form.sourceIdPlaceholder':
    'Identificador externo estable',
  'catalog.properties.form.sourceCode': 'Código de origen',
  'catalog.properties.form.sourceCodePlaceholder':
    'Código comercial o referencia externa',
  'catalog.properties.form.mercadoLibreCode': 'Código Mercado Libre',
  'catalog.properties.form.mercadoLibreCodePlaceholder':
    'Código interno o referencia de Mercado Libre',

  // Sidebar - Menu Groups
  'sidebar.crm': 'CRM',
  'sidebar.automation': 'Automatización',
  'sidebar.analytics': 'Analítica',
  'sidebar.catalog': 'Catálogo',
  'sidebar.settings': 'Ajustes',

  // Sidebar - CRM Menu Items
  'sidebar.communications': 'Comunicaciones',
  'sidebar.notifications': 'Notificaciones',
  'sidebar.agenda': 'Agenda',
  'sidebar.contacts': 'Contactos',
  'communications.pipeline.empty.title': 'No hay conversaciones',
  'communications.pipeline.empty.description':
    'Arrastra y suelta conversaciones aquí',
  'communications.pipeline.empty.noFunnel':
    'Selecciona un embudo para ver las conversaciones',
  'communications.pipeline.actions.collapseColumn': 'Contraer columna',
  'communications.pipeline.actions.expandColumn': 'Expandir columna',
  'communications.pipeline.actions.columnMenu': 'Acciones de columna',
  'communications.pipeline.actions.hideAiStatuses':
    'Ocultar todos los estados de IA',
  'communications.pipeline.actions.showAiStatuses':
    'Mostrar todos los estados de IA',
  'communications.pipeline.actions.hideAllStatuses':
    'Ocultar todos los estados',
  'communications.pipeline.actions.showAllStatuses':
    'Mostrar todos los estados',
  'communications.pipeline.actions.quickAutomation':
    'Crear automatización rápida',
  'communications.pipeline.actions.quickAutomationTitle':
    'Automatización rápida',
  'communications.pipeline.actions.quickAutomationConfirm':
    'Crear automatización',
  'automations.quickHandoff.fields.funnel': 'Embudo actual',
  'automations.quickHandoff.fields.currentFunnelFallback':
    'Embudo seleccionado',
  'automations.quickHandoff.fields.destinationStatus':
    'Estado de asistencia humana',
  'automations.quickHandoff.fields.enabledStatuses': 'Estados atendidos por IA',
  'automations.quickHandoff.fields.aiAgent': 'Agente IA',
  'automations.quickHandoff.fields.excludedContent':
    'Texto que no debe derivar',
  'automations.quickHandoff.placeholders.destinationStatus':
    'Selecciona el estado de destino',
  'automations.quickHandoff.placeholders.enabledStatuses':
    'Selecciona los estados atendidos por IA',
  'automations.quickHandoff.placeholders.aiAgent': 'Selecciona el Agente IA',
  'automations.quickHandoff.placeholders.excludedContent':
    'Escribe el texto que debe excluirse',
  'automations.quickHandoff.empty.statuses':
    'Este embudo no tiene estados disponibles',
  'automations.quickHandoff.empty.aiAgents':
    'No hay Agentes IA con usuario asociado',
  'automations.quickHandoff.hints.noSuggestedStatuses':
    'No encontramos estados de IA automáticamente. Selecciona al menos uno.',
  'automations.quickHandoff.hints.excludedContent':
    'Si un mensaje saliente contiene este texto, la conversación no se derivará.',
  'automations.quickHandoff.errors.employeePermissionTitle':
    'No puedes consultar Agentes IA',
  'automations.quickHandoff.errors.employeePermissionDescription':
    'Necesitas permiso de lectura de Agentes IA para configurar esta plantilla.',
  'automations.quickHandoff.errors.userPermissionTitle':
    'No puedes consultar usuarios',
  'automations.quickHandoff.errors.userPermissionDescription':
    'Necesitas permiso de lectura de usuarios para mostrar sus nombres y configurar esta plantilla.',
  'automations.quickHandoff.errors.setupTitle':
    'No pudimos cargar la configuración',
  'automations.quickHandoff.errors.setupDescription':
    'Revisa tu conexión o permisos e inténtalo nuevamente.',
  'automations.quickHandoff.errors.templateTitle':
    'La plantilla requiere revisión técnica',
  'automations.quickHandoff.errors.templateDescription':
    'La definición actual no coincide con el contrato de derivación esperado.',
  'automations.quickHandoff.errors.contextTitle': 'Falta el embudo actual',
  'automations.quickHandoff.errors.contextDescription':
    'Selecciona un embudo en Comunicaciones antes de crear esta automatización.',
  'automations.quickHandoff.errors.invalidDefinition':
    'Definición de plantilla inválida: falta la definición del workflow.',
  'automations.quickHandoff.errors.missingTrigger':
    'Definición de plantilla inválida: falta el trigger del workflow.',
  'automations.quickHandoff.errors.workflowCreate':
    'No pudimos crear el workflow. Puedes intentarlo nuevamente.',
  'automations.quickHandoff.errors.triggerCreate':
    'El workflow se creó, pero no pudimos activar su trigger.',
  'automations.quickHandoff.actions.retryLoad': 'Intentar de nuevo',
  'automations.quickHandoff.actions.retryActivation': 'Reintentar activación',
  'automations.quickHandoff.partial.title': 'Activación pendiente',
  'automations.quickHandoff.partial.description':
    'El workflow {workflowId} ya fue creado. Reintenta para adjuntar su trigger sin crear otro.',
  'automations.quickHandoff.closeWarning':
    'El workflow {workflowId} ya fue creado, pero todavía no tiene trigger. Si cierras, tendrás que recuperarlo manualmente. ¿Quieres cerrar de todas formas?',
  'automations.quickHandoff.alerts.created':
    'Automatización creada. Workflow {workflowId}, versión {version}, trigger {triggerId}.',
  'automations.quickAutomation.fields.activationStatus':
    'Estado que activa la automatización',
  'automations.quickAutomation.fields.assigneeUser': 'Usuario a asignar',
  'automations.quickAutomation.placeholders.activationStatus':
    'Selecciona un estado del embudo',
  'automations.quickAutomation.placeholders.assigneeUser':
    'Selecciona un usuario',
  'automations.quickAutomation.empty.statuses':
    'Este embudo no tiene estados disponibles',
  'automations.quickAutomation.empty.users':
    'No hay usuarios humanos disponibles',
  'automations.quickAutomation.errors.templateDescription':
    'La definición actual no coincide con el contrato esperado para esta automatización rápida.',

  // AI Agent operations
  'automations.aiAgents.index.title': 'Agentes IA',
  'automations.aiAgents.index.description':
    'Configura tus agentes y revisa cómo están ejecutando su trabajo.',
  'automations.aiAgents.index.create': 'Nuevo Agente IA',
  'automations.aiAgents.index.assistance': 'Centro de asistencia IA',
  'automations.aiAgents.index.executions': 'Ver ejecuciones',
  'automations.aiAgents.index.edit': 'Editar',
  'automations.aiAgents.index.unnamed': 'Agente IA sin nombre',
  'automations.aiAgents.index.noDescription': 'Sin descripción',
  'automations.aiAgents.index.emptyTitle': 'Aún no hay Agentes IA',
  'automations.aiAgents.index.emptyDescription':
    'Crea un Agente IA para comenzar a automatizar trabajo.',
  'automations.aiAgents.index.errorTitle': 'No pudimos cargar tus Agentes IA',
  'automations.aiAgents.index.errorDescription':
    'Revisa tu conexión e inténtalo nuevamente.',
  'automations.aiAgents.actions.retry': 'Intentar de nuevo',
  'automations.aiAgents.actions.copyId': 'Copiar ID',
  'automations.aiAgents.actions.copied': 'ID copiado',
  'automations.aiAgents.actions.loadMore': 'Cargar más',
  'automations.aiAgents.actions.clearDates': 'Limpiar fechas',
  'automations.aiAgents.form.constraints.add': 'Agregar',
  'automations.aiAgents.form.constraints.placeholder':
    'Agregar restricciones...',
  'automations.aiAgents.form.constraints.empty':
    'No has agregado ninguna restricción',
  'automations.aiAgents.form.constraints.sizeWarningTitle':
    'Muchas restricciones pueden reducir la revisión de mensajes',
  'automations.aiAgents.form.constraints.sizeWarningDescriptionSingular':
    'Este agente IA tiene {constraintCount} restricción y {characterCount} caracteres. Sus mensajes seguirán enviándose, pero podrían omitir la revisión preventiva de calidad cuando el contexto sea demasiado grande. Mueve información de referencia a la base de conocimiento y reglas específicas del flujo a las instrucciones del embudo.',
  'automations.aiAgents.form.constraints.sizeWarningDescriptionPlural':
    'Este agente IA tiene {constraintCount} restricciones y {characterCount} caracteres. Sus mensajes seguirán enviándose, pero podrían omitir la revisión preventiva de calidad cuando el contexto sea demasiado grande. Mueve información de referencia a la base de conocimiento y reglas específicas del flujo a las instrucciones del embudo.',
  'automations.aiAgents.assistance.title': 'Centro de asistencia IA',
  'automations.aiAgents.assistance.description':
    'Revisa bloqueos de Agentes IA y resultados entregados que podrían requerir atención, y abre la ejecución o conversación correspondiente.',
  'automations.aiAgents.assistance.back': 'Volver a Agentes IA',
  'automations.aiAgents.assistance.expandObjective': 'Ver objetivo completo',
  'automations.aiAgents.assistance.collapseObjective': 'Contraer objetivo',
  'automations.aiAgents.assistance.status.open': 'Abierta',
  'automations.aiAgents.assistance.status.resolved': 'Resuelta',
  'automations.aiAgents.assistance.category.missingCapability':
    'Falta una capacidad',
  'automations.aiAgents.assistance.category.configurationUnavailable':
    'Configuración no disponible',
  'automations.aiAgents.assistance.category.terminalToolFailure':
    'Falla terminal de herramienta',
  'automations.aiAgents.assistance.category.repeatedToolFailure':
    'Falla repetida de herramienta',
  'automations.aiAgents.assistance.category.terminalOperationFailure':
    'No se pudo completar de forma segura.',
  'automations.aiAgents.assistance.category.messageFidelityReview':
    'Mensaje requiere revisión',
  'automations.aiAgents.assistance.capability':
    'Capacidad requerida: {capability}',
  'automations.aiAgents.assistance.requiredTool':
    'Acción requerida: {toolName}',
  'automations.aiAgents.assistance.requiredAnyTool':
    'Cualquier acción compatible: {toolNames}',
  'automations.aiAgents.assistance.toolAttempts':
    '{toolName} falló {attempts} veces.',
  'automations.aiAgents.assistance.affectedTool': 'Acción afectada: {toolName}',
  'automations.aiAgents.assistance.reason.missingCapability':
    'La capacidad requerida no está disponible.',
  'automations.aiAgents.assistance.reason.configurationUnavailable':
    'La configuración o integración requerida no está disponible.',
  'automations.aiAgents.assistance.reason.terminalToolFailure':
    'La acción no pudo completarse y necesita revisión.',
  'automations.aiAgents.assistance.reason.repeatedToolFailure':
    'La acción no pudo completarse después de varios intentos.',
  'automations.aiAgents.assistance.reason.terminalOperationFailure':
    'La acción no pudo completarse de forma segura después de un intento de corrección.',
  'automations.aiAgents.assistance.reason.messageFidelityReview':
    'Una respuesta enviada mantuvo observaciones de revisión sin resolver.',
  'automations.aiAgents.assistance.advisory.messageFidelityReviewContext':
    'Acción afectada: {operation} · Observaciones sin resolver: {issueCount}',
  'automations.aiAgents.assistance.conversation':
    'Conversación {conversationId}',
  'automations.aiAgents.assistance.openConversation':
    'Ir a conversación {conversationId}',
  'automations.aiAgents.assistance.openConversationLabel':
    'Abrir conversación {conversationId}',
  'automations.aiAgents.assistance.openExecution': 'Revisar ejecución',
  'automations.aiAgents.assistance.dismiss': 'Descartar',
  'automations.aiAgents.assistance.dismissLabel': 'Descartar asistencia',
  'automations.aiAgents.assistance.dismissError':
    'No pudimos descartar esta asistencia. Inténtalo nuevamente.',
  'automations.aiAgents.assistance.unknownAgent': 'Agente IA desconocido',
  'automations.aiAgents.assistance.filters.status': 'Estado de asistencia',
  'automations.aiAgents.assistance.filters.category': 'Tipo de asistencia',
  'automations.aiAgents.assistance.filters.agent': 'Agente IA',
  'automations.aiAgents.assistance.filters.conversation': 'ID de conversación',
  'automations.aiAgents.assistance.filters.conversationPlaceholder':
    'ID de conversación',
  'automations.aiAgents.assistance.filters.applyConversation':
    'Aplicar filtro de conversación',
  'automations.aiAgents.assistance.filters.invalidConversation':
    'Ingresa un ID de conversación numérico positivo.',
  'automations.aiAgents.assistance.filters.allCategories':
    'Todas las categorías',
  'automations.aiAgents.assistance.filters.allAgents': 'Todos los Agentes IA',
  'automations.aiAgents.assistance.filters.reset': 'Restablecer filtros',
  'automations.aiAgents.assistance.emptyTitle': 'No se requiere asistencia',
  'automations.aiAgents.assistance.emptyDescription':
    'No hay trabajo de Agentes IA que coincida con los filtros seleccionados.',
  'automations.aiAgents.assistance.partialDirectoryWarning':
    'No se pudieron cargar todas las identidades de Agentes IA. Los nombres y filtros de agentes pueden estar incompletos.',
  'automations.aiAgents.assistance.partialListWarning':
    'No se pudieron cargar algunos registros de asistencia. Reintenta para actualizar la lista.',
  'automations.aiAgents.assistance.errorTitle':
    'No pudimos cargar la asistencia de Agentes IA',
  'automations.aiAgents.assistance.errorDescription':
    'Revisa tu conexión e inténtalo nuevamente.',
  'automations.aiAgents.executions.title': 'Ejecuciones',
  'automations.aiAgents.executions.description':
    'Revisa resultados, bloqueos y actividad de {agentName}.',
  'automations.aiAgents.executions.back': 'Volver a Agentes IA',
  'automations.aiAgents.executions.unknownAgent': 'este Agente IA',
  'automations.aiAgents.executions.genericTitle': 'Ejecución',
  'automations.aiAgents.executions.contact': 'Contacto',
  'automations.aiAgents.executions.startedAt': 'Inicio',
  'automations.aiAgents.executions.duration': 'Duración',
  'automations.aiAgents.executions.blocker': 'Motivo del bloqueo',
  'automations.aiAgents.executions.blockerReasonFallback':
    'La ejecución no pudo completar el trabajo requerido.',
  'automations.aiAgents.executions.emptyTitle': 'No hay ejecuciones',
  'automations.aiAgents.executions.emptyDescription':
    'No encontramos ejecuciones para el rango seleccionado.',
  'automations.aiAgents.executions.errorTitle':
    'No pudimos cargar las ejecuciones',
  'automations.aiAgents.executions.errorDescription':
    'Revisa tu conexión e inténtalo nuevamente.',
  'automations.aiAgents.executions.status.completed': 'Completada',
  'automations.aiAgents.executions.status.failed': 'Fallida',
  'automations.aiAgents.executions.status.running': 'En ejecución',
  'automations.aiAgents.executions.status.blocked': 'Requiere ayuda',
  'automations.aiAgents.executions.status.unknown': 'Sin estado',
  'automations.aiAgents.executions.dateRange.trigger':
    'Filtrar por rango de fechas',
  'automations.aiAgents.executions.dateRange.title': 'Rango de ejecuciones',
  'automations.aiAgents.executions.dateRange.presets': 'Rangos rápidos',
  'automations.aiAgents.executions.dateRange.from': 'Desde',
  'automations.aiAgents.executions.dateRange.to': 'Hasta',
  'automations.aiAgents.executions.dateRange.close':
    'Cerrar selector de fechas',
  'automations.aiAgents.executions.dateRange.all': 'Todas las fechas',
  'automations.aiAgents.executions.dateRange.today': 'Hoy',
  'automations.aiAgents.executions.dateRange.last7Days': 'Últimos 7 días',
  'automations.aiAgents.executions.dateRange.last30Days': 'Últimos 30 días',
  'automations.aiAgents.executions.dateRange.missing':
    'Selecciona una fecha de inicio y una fecha de término.',
  'automations.aiAgents.executions.dateRange.invalid':
    'Ingresa fechas válidas.',
  'automations.aiAgents.executions.dateRange.order':
    'La fecha de inicio debe ser anterior a la fecha de término.',
  'automations.aiAgents.executions.dateRange.beforeMin':
    'La fecha de inicio está fuera del rango permitido.',
  'automations.aiAgents.executions.dateRange.afterMax':
    'La fecha de término está fuera del rango permitido.',
  'automations.aiAgents.detail.title': 'Detalle de la ejecución',
  'automations.aiAgents.detail.description':
    'Resultado, contexto y actividad del Agente IA.',
  'automations.aiAgents.detail.back': 'Volver a ejecuciones',
  'automations.aiAgents.detail.summary': 'Resumen',
  'automations.aiAgents.detail.timeline': 'Cronología',
  'automations.aiAgents.detail.technical': 'Datos técnicos',
  'automations.aiAgents.detail.errorTitle': 'No pudimos cargar esta ejecución',
  'automations.aiAgents.detail.errorDescription':
    'Revisa tu conexión e inténtalo nuevamente.',
  'automations.aiAgents.detail.outcome': 'Resultado',
  'automations.aiAgents.detail.objective': 'Objetivo',
  'automations.aiAgents.detail.context': 'Contexto de trabajo',
  'automations.aiAgents.detail.plan': 'Plan',
  'automations.aiAgents.detail.actions': 'Acciones realizadas',
  'automations.aiAgents.detail.blocker': 'El Agente IA necesita ayuda',
  'automations.aiAgents.detail.affectedWork': 'Trabajo pendiente',
  'automations.aiAgents.detail.noObjective': 'No se registró un objetivo.',
  'automations.aiAgents.detail.noContext':
    'No se registró contexto de negocio.',
  'automations.aiAgents.detail.noPlan': 'No se registró un plan.',
  'automations.aiAgents.detail.noActions':
    'No se registraron acciones externas.',
  'automations.aiAgents.detail.contact': 'Contacto',
  'automations.aiAgents.detail.funnel': 'Embudo',
  'automations.aiAgents.detail.funnelStatus': 'Estado actual',
  'automations.aiAgents.detail.latestInteraction': 'Último mensaje',
  'automations.aiAgents.detail.property': 'Propiedad de interés',
  'automations.aiAgents.detail.moreContext': 'Ver contexto completo',
  'automations.aiAgents.detail.trigger': 'Disparador de la ejecución',
  'automations.aiAgents.detail.contactChannels': 'Canales de contacto',
  'automations.aiAgents.detail.statusInstructions':
    'Instrucciones del estado actual',
  'automations.aiAgents.detail.recentInteractions': 'Interacciones recientes',
  'automations.aiAgents.detail.inbound': 'Entrante',
  'automations.aiAgents.detail.outbound': 'Saliente',
  'automations.aiAgents.detail.messagesShown':
    'Mostrando {shown} de {total} mensajes',
  'automations.aiAgents.detail.callsCount': '{count} llamadas',
  'automations.aiAgents.detail.propertyDetails': 'Detalles de la propiedad',
  'automations.aiAgents.detail.active': 'Activa',
  'automations.aiAgents.detail.inactive': 'Inactiva',
  'automations.aiAgents.detail.bedrooms': '{count} dormitorios',
  'automations.aiAgents.detail.bathrooms': '{count} baños',
  'automations.aiAgents.detail.rentPrice': 'Precio de arriendo',
  'automations.aiAgents.detail.salePrice': 'Precio de venta',
  'automations.aiAgents.detail.openSource': 'Abrir fuente',
  'automations.aiAgents.detail.phaseDetails': 'Detalles de la fase',
  'automations.aiAgents.detail.actionDetails': 'Detalles de la acción',
  'automations.aiAgents.detail.plannedTasks': 'Trabajo planificado',
  'automations.aiAgents.detail.result': 'Resultado',
  'automations.aiAgents.detail.goalAchieved': 'Logrado',
  'automations.aiAgents.detail.goalNotAchieved': 'No logrado',
  'automations.aiAgents.detail.reason': 'Razón',
  'automations.aiAgents.detail.validatorAction': 'Decisión de validación',
  'automations.aiAgents.detail.affectedTodo': 'Trabajo afectado',
  'automations.aiAgents.detail.nextTodo': 'Siguiente trabajo',
  'automations.aiAgents.detail.remainingTodos': 'Trabajos pendientes',
  'automations.aiAgents.detail.executedTools': 'Herramientas ejecutadas',
  'automations.aiAgents.detail.duration': 'Duración',
  'automations.aiAgents.detail.contextFacts': 'Contexto recopilado',
  'automations.aiAgents.detail.messages': 'Mensajes recopilados',
  'automations.aiAgents.detail.calls': 'Llamadas recopiladas',
  'automations.aiAgents.detail.searchQuery': 'Búsqueda realizada',
  'automations.aiAgents.detail.resultsCount': 'Resultados',
  'automations.aiAgents.detail.sentMessages': 'Mensajes enviados',
  'automations.aiAgents.detail.attemptedMessages': 'Mensajes intentados',
  'automations.aiAgents.detail.failedMessages': 'Mensajes fallidos',
  'automations.aiAgents.detail.updatedFields': 'Campos actualizados',
  'automations.aiAgents.detail.task': 'Tarea',
  'automations.aiAgents.detail.taskStatus': 'Estado de la tarea',
  'automations.aiAgents.detail.taskDueDate': 'Vencimiento',
  'automations.aiAgents.detail.selectedProperty': 'Propiedad seleccionada',
  'automations.aiAgents.detail.propertyCleared':
    'Selección de propiedad eliminada',
  'automations.aiAgents.detail.validator.completedTodo': 'Trabajo completado',
  'automations.aiAgents.detail.validator.completedObjective':
    'Objetivo completado',
  'automations.aiAgents.detail.validator.cancelledTodo': 'Trabajo cancelado',
  'automations.aiAgents.detail.validator.cancelledObjective':
    'Objetivo cancelado',
  'automations.aiAgents.detail.validator.keptInProgress':
    'Trabajo mantenido en progreso',
  'automations.aiAgents.detail.validator.blockedTodo': 'Trabajo bloqueado',
  'automations.aiAgents.detail.validator.blockedObjective':
    'Objetivo bloqueado',
  'automations.aiAgents.detail.validator.blockedReasonFallback':
    'La ejecución no pudo completar el trabajo requerido.',
  'automations.aiAgents.detail.timelineEmptyTitle': 'Sin actividad registrada',
  'automations.aiAgents.detail.timelineEmptyDescription':
    'Esta ejecución todavía no tiene fases ni acciones.',
  'automations.aiAgents.detail.cycle': 'Ciclo {cycle}',
  'automations.aiAgents.detail.step': 'Paso {number}',
  'automations.aiAgents.detail.technicalDescription':
    'Entradas, salidas y errores redactados para soporte técnico.',
  'automations.aiAgents.detail.technicalPreviewTruncated':
    'Esta vista redactada está truncada para mantener la página responsiva.',
  'automations.aiAgents.detail.loadFullTechnicalPayload':
    'Cargar contenido completo',
  'automations.aiAgents.detail.noTechnicalData':
    'Este paso no contiene datos técnicos.',
  'automations.aiAgents.detail.phase.fetchContext': 'Recopilación de contexto',
  'automations.aiAgents.detail.phase.fetchContextDescription':
    'Reunió la información necesaria para trabajar.',
  'automations.aiAgents.detail.phase.planner': 'Diseño del plan',
  'automations.aiAgents.detail.phase.plannerDescription':
    'Definió el objetivo y las acciones a realizar.',
  'automations.aiAgents.detail.phase.executor': 'Ejecución del plan',
  'automations.aiAgents.detail.phase.executorDescription':
    'Decidió y coordinó las acciones del plan.',
  'automations.aiAgents.detail.phase.validator': 'Validación',
  'automations.aiAgents.detail.phase.validatorDescription':
    'Evaluó el resultado y el trabajo pendiente.',
  'automations.aiAgents.detail.phase.workflow': 'Acciones del plan',
  'automations.aiAgents.detail.phase.workflowDescription':
    'Ejecutó las herramientas necesarias.',
  'automations.aiAgents.detail.phase.unknown': 'Actividad del Agente IA',
  'automations.aiAgents.detail.phase.unknownDescription':
    'Registró actividad durante la ejecución.',
  'automations.aiAgents.detail.toolAction': 'Acción',
  'automations.aiAgents.metadata.additionalTriggers': '{name} y {count} más',
  'automations.aiAgents.metadata.workspace.funnelStatus': 'Estado de embudo',
  'automations.aiAgents.metadata.triggers.messageReceived': 'Mensaje recibido',
  'automations.aiAgents.metadata.triggers.whatsappMessageReceived':
    'Mensaje WhatsApp recibido',
  'automations.aiAgents.metadata.triggers.callCompleted': 'Llamada completada',
  'automations.aiAgents.metadata.triggers.callMissed': 'Llamada perdida',
  'automations.aiAgents.metadata.triggers.taskCompleted': 'Tarea completada',
  'automations.aiAgents.metadata.triggers.taskCancelled': 'Tarea cancelada',
  'automations.aiAgents.metadata.triggers.funnelStatusChanged':
    'Cambio de estado en embudo',
  'automations.aiAgents.metadata.triggers.contactCreated': 'Contacto creado',
  'automations.aiAgents.metadata.triggers.contactUpdated':
    'Contacto actualizado',
  'automations.aiAgents.metadata.triggers.scheduledTime': 'Hora programada',
  'automations.aiAgents.metadata.triggers.workflowStarted': 'Workflow iniciado',
  'automations.aiAgents.metadata.triggers.manual': 'Disparador manual',
  'automations.aiAgents.metadata.tools.listWhatsappTemplates':
    'Listado de plantillas de WhatsApp',
  'automations.aiAgents.metadata.tools.getWhatsappTemplate':
    'Lectura de plantilla de WhatsApp',
  'automations.aiAgents.metadata.tools.sendWhatsappTemplate':
    'Envío de plantilla de WhatsApp',
  'automations.aiAgents.metadata.tools.sendWhatsappMessage':
    'Envío de mensaje por WhatsApp',
  'automations.aiAgents.metadata.tools.listTasks': 'Listado de tareas',
  'automations.aiAgents.metadata.tools.createTask': 'Creación de una tarea',
  'automations.aiAgents.metadata.tools.updateTask':
    'Actualización de una tarea',
  'automations.aiAgents.metadata.tools.completeTask': 'Tarea completada',
  'automations.aiAgents.metadata.tools.cancelTask': 'Tarea cancelada',
  'automations.aiAgents.metadata.tools.getTask': 'Obtención de una tarea',
  'automations.aiAgents.metadata.tools.makePhoneCall': 'Llamada iniciada',
  'automations.aiAgents.metadata.tools.updateFields': 'Actualización de campos',
  'automations.aiAgents.metadata.tools.updateStatus': 'Actualización de estado',
  'automations.aiAgents.metadata.tools.replaceFollowUp':
    'Programación del próximo seguimiento',
  'automations.aiAgents.metadata.tools.updateContactConversationFields':
    'Actualización de datos del contacto y la conversación',
  'automations.aiAgents.metadata.tools.updateConversationStatus':
    'Cambio de estado de la conversación',
  'automations.aiAgents.metadata.tools.getFunnelStatuses':
    'Consulta de estados del embudo',
  'automations.aiAgents.metadata.tools.listWhatsappPhones':
    'Consulta de líneas de WhatsApp',
  'automations.aiAgents.metadata.tools.searchProperties':
    'Búsqueda de propiedades',
  'automations.aiAgents.metadata.tools.selectPropertyOfInterest':
    'Selección de propiedad de interés',
  'automations.aiAgents.metadata.tools.escalateToHumanAssistance':
    'Derivación a asistencia humana',
  'automations.aiAgents.metadata.tools.readyToScheduleVisit':
    'Derivación para coordinar una visita',
  'automations.aiAgents.metadata.tools.searchKnowledgeBase':
    'Búsqueda en la base de conocimiento',
  'automations.aiAgents.metadata.tools.searchProducts': 'Búsqueda de productos',
  'automations.aiAgents.metadata.tools.deleteTask': 'Eliminación de una tarea',
  'automations.aiAgents.metadata.tools.createProduct': 'Creación de producto',
  'automations.aiAgents.metadata.tools.deleteProduct':
    'Eliminación de producto',
  'automations.aiAgents.metadata.tools.getProduct': 'Consulta de producto',
  'automations.aiAgents.metadata.tools.importProducts':
    'Importación de productos',
  'automations.aiAgents.metadata.tools.listProducts': 'Listado de productos',
  'automations.aiAgents.metadata.tools.updateProduct':
    'Actualización de producto',
  'automations.aiAgents.metadata.tools.createProperty': 'Creación de propiedad',
  'automations.aiAgents.metadata.tools.deleteProperty':
    'Eliminación de propiedad',
  'automations.aiAgents.metadata.tools.getProperty': 'Consulta de propiedad',
  'automations.aiAgents.metadata.tools.importProp360':
    'Importación de archivo Prop360',
  'automations.aiAgents.metadata.tools.importProperties':
    'Importación de propiedades',
  'automations.aiAgents.metadata.tools.listProperties':
    'Listado de propiedades',
  'automations.aiAgents.metadata.tools.updateProperty':
    'Actualización de propiedad',
  'automations.aiAgents.metadata.tools.sendPlatformEmail': 'Envío de correo',
  'automations.aiAgents.metadata.tools.callLanguageModel':
    'Ejecución de modelo de lenguaje',
  'automations.aiAgents.metadata.tools.createConversation':
    'Creación de conversación',
  'automations.aiAgents.metadata.tools.publishPhaseToolsCompleted':
    'Registro de acciones completadas',
  'automations.aiAgents.metadata.tools.getConversation':
    'Consulta de conversación',
  'automations.aiAgents.metadata.tools.getConversationCalls':
    'Consulta de llamadas de la conversación',
  'automations.aiAgents.metadata.tools.conditionalGate':
    'Evaluación de una condición',
  'automations.aiAgents.metadata.tools.crawlWebsite': 'Lectura de sitio web',
  'automations.aiAgents.metadata.tools.getDateTime': 'Consulta de fecha y hora',
  'automations.aiAgents.metadata.tools.extractWebpageContent':
    'Extracción de contenido web',
  'automations.aiAgents.metadata.tools.fetchConversationHistory':
    'Consulta del historial de conversación',
  'automations.aiAgents.metadata.tools.getHubspotContact':
    'Consulta de contacto en HubSpot',
  'automations.aiAgents.metadata.tools.listUsers': 'Listado de usuarios',
  'automations.aiAgents.metadata.tools.extractConversationFields':
    'Extracción de datos de la conversación',
  'automations.aiAgents.metadata.tools.getContact': 'Consulta de contacto',
  'automations.aiAgents.metadata.tools.getContactByProvider':
    'Consulta de contacto por canal',
  'automations.aiAgents.metadata.tools.getContactFields':
    'Consulta de campos del contacto',
  'automations.aiAgents.metadata.tools.getConversationFields':
    'Consulta de campos de la conversación',
  'automations.aiAgents.metadata.tools.getConversationMessages':
    'Consulta de mensajes de la conversación',
  'automations.aiAgents.metadata.tools.getFunnelAddress':
    'Consulta de dirección del embudo',
  'automations.aiAgents.metadata.tools.getFunnelAddresses':
    'Listado de direcciones del embudo',
  'automations.aiAgents.metadata.tools.updateContact':
    'Actualización de contacto',
  'automations.aiAgents.metadata.tools.updateConversation':
    'Actualización de conversación',
  'automations.aiAgents.metadata.tools.randomNumber':
    'Generación de número aleatorio',
  'automations.aiAgents.metadata.tools.roundRobinPick':
    'Selección por rotación',
  'automations.aiAgents.metadata.tools.runParallel':
    'Ejecución de acciones en paralelo',
  'automations.aiAgents.metadata.tools.runWorkflow':
    'Ejecución de automatización',
  'automations.aiAgents.metadata.tools.searchWeb': 'Búsqueda web',
  'automations.aiAgents.metadata.tools.selectFromList':
    'Selección desde una lista',
  'automations.aiAgents.metadata.tools.sendWebhook': 'Envío de webhook',
  'automations.aiAgents.metadata.tools.syncHubspotContact':
    'Sincronización de contacto con HubSpot',
  'automations.aiAgents.metadata.tools.matchTextPattern':
    'Evaluación de patrón de texto',
  'automations.aiAgents.metadata.tools.wait': 'Espera',
  'automations.aiAgents.metadata.capabilities.noAction':
    'No requiere una acción',
  'automations.aiAgents.metadata.capabilities.customAction':
    'Ejecución de una acción personalizada',

  // Sidebar - Automation Menu Items
  'sidebar.agents': 'Agentes IA',
  'sidebar.automations': 'Automatizaciones',

  // Sidebar - Analytics Menu Items
  'sidebar.calls': 'Llamadas',
  'sidebar.reports': 'Reportes',
  'sidebar.report-dashboard': 'Reportes',

  // Reports Dashboard
  'reports.dashboard.pageTitle': 'Reportes',
  'reports.dashboard.pageDescription':
    'Crea widgets de métricas compartidos y ajusta filtros para que todos los administradores sigan la operación con claridad.',
  'reports.dashboard.description':
    'Agrega widgets compartidos, duplica vistas y ajusta filtros.',
  'reports.dashboard.defaultLayoutNotice':
    'Estás usando la distribución predeterminada porque todavía no se ha guardado un dashboard compartido.',
  'reports.dashboard.widgetFallbackTitle': 'Widget',
  'reports.dashboard.duplicateSuffix': '(copia)',
  'reports.dashboard.actions.addWidget': 'Nuevo widget',
  'reports.dashboard.actions.reset': 'Restablecer',
  'reports.dashboard.resetConfirm.title': 'Restablecer widgets',
  'reports.dashboard.resetConfirm.description':
    'Se restaurará el dashboard compartido a la configuración predeterminada y se perderán los cambios guardados para todos los administradores.',
  'reports.dashboard.resetConfirm.confirm': 'Restablecer',
  'reports.dashboard.resetConfirm.cancel': 'Cancelar',
  'reports.calls.pageTitle': 'Reportes de llamadas',
  'reports.calls.pageDescription':
    'Métricas históricas y análisis avanzados para entender el rendimiento del canal de llamadas.',
  'reports.calls.backLabel': 'Volver a llamadas',
  'reports.calls.views': 'Vistas',
  'reports.calls.tabs.basic': 'Básicos',
  'reports.calls.tabs.advanced': 'Avanzados',
  'reports.calls.filters.allCalls': 'Todas las llamadas',
  'reports.calls.filters.effective': 'Solo efectivas',
  'reports.calls.filters.missed': 'Solo perdidas',
  'reports.calls.filters.voicemail': 'Solo buzón de voz',
  'reports.advanced.agentPerformance.export.button': 'Descargar',
  'reports.advanced.agentPerformance.export.headers.index': 'N°',
  'reports.advanced.agentPerformance.export.headers.agent': 'Agente',
  'reports.advanced.agentPerformance.export.headers.connectedEffective':
    'Conectadas: Efectivas',
  'reports.advanced.agentPerformance.export.headers.connectedVoicemail':
    'Conectadas: Buzón de voz',
  'reports.advanced.agentPerformance.export.headers.noAnswer': 'No contesta',
  'reports.advanced.agentPerformance.export.headers.rejected': 'Rechazadas',
  'reports.advanced.agentPerformance.export.headers.total': 'Total',
  'reports.advanced.agentPerformance.export.headers.averageDuration':
    'Duración promedio',
  'reports.advanced.agentPerformance.export.headers.minutesTalked':
    'Minutos hablados',
  'reports.advanced.agentPerformance.export.headers.leadCount': '# Leads',
  'reports.advanced.agentPerformance.export.headers.leadContactability':
    'Contactabilidad de leads (%)',
  'reports.advanced.agentPerformance.export.headers.callContactability':
    'Contactabilidad de llamadas (%)',
  'reports.advanced.agentPerformance.export.headers.callsPerLead':
    '# Llamadas/lead',
  'reports.advanced.agentPerformance.export.headers.expertise': 'Experticia',
  'reports.advanced.agentPerformance.export.headers.confidence': 'Confianza',
  'reports.advanced.agentPerformance.export.headers.objections': 'Objeciones',
  'reports.advanced.agentPerformance.export.headers.closing': 'Cierre',
  'reports.advanced.agentPerformance.export.headers.totalPerformance':
    'Desempeño Total',
  'reports.advanced.agentPerformance.export.headers.team': 'Equipo',
  'reports.dashboard.actions.configure': 'Configurar',
  'reports.dashboard.actions.cancel': 'Cancelar',
  'reports.dashboard.actions.save': 'Guardar',
  'reports.dashboard.actions.drag': 'Arrastrar',
  'reports.dashboard.actions.editConfiguration': 'Editar configuración',
  'reports.dashboard.alerts.updated': 'Dashboard actualizado.',
  'reports.dashboard.alerts.duplicated': 'Widget duplicado.',
  'reports.dashboard.alerts.removed': 'Widget eliminado.',
  'reports.dashboard.alerts.reset': 'Dashboard restablecido.',
  'reports.dashboard.errors.defaultWidgetNotFound':
    'No se encontró la plantilla predeterminada del widget.',
  'reports.dashboard.errors.saveWidget': 'No se pudo guardar el widget.',
  'reports.dashboard.errors.duplicateWidget': 'No se pudo duplicar el widget.',
  'reports.dashboard.errors.removeWidget': 'No se pudo eliminar el widget.',
  'reports.dashboard.errors.resetDashboard':
    'No se pudo restablecer el dashboard.',
  'reports.dashboard.errors.reorderDashboard':
    'No se pudo reordenar el dashboard.',
  'reports.dashboard.errors.loadDashboardTitle':
    'No se pudo cargar el dashboard',
  'reports.dashboard.errors.loadDashboardDescription':
    'Reintenta para volver a cargar los widgets.',
  'reports.dashboard.errors.widgetLoadTitle': 'No se pudo cargar el widget',
  'reports.dashboard.errors.widgetLoadDescription':
    'Revisa los filtros o intenta nuevamente.',
  'reports.dashboard.catalog.title': 'Catálogo',
  'reports.dashboard.catalog.description':
    'Elige un widget y luego ajusta sus filtros con vista previa en vivo.',
  'reports.dashboard.modal.configureTitle': 'Configurar widget',
  'reports.dashboard.modal.addTitle': 'Agregar widget',
  'reports.dashboard.modal.configureDescription':
    'Ajusta filtros y revisa la vista previa antes de guardar.',
  'reports.dashboard.modal.addDescription':
    'Elige un widget y luego ajusta sus filtros en la vista previa.',
  'reports.dashboard.editor.mobile.settings': 'Configurar',
  'reports.dashboard.editor.mobile.preview': 'Vista previa',
  'reports.dashboard.editor.title': 'Configuración visual',
  'reports.dashboard.editor.description':
    'Ajusta filtros y revisa la vista previa antes de guardar.',
  'reports.dashboard.warnings.noFunnelsTitle': 'No hay embudos disponibles',
  'reports.dashboard.warnings.noFunnelsDescription':
    'Este widget necesita un embudo para configurarse. Crea un embudo antes de guardarlo.',
  'reports.dashboard.warnings.noStatusesTitle': 'El embudo no tiene estados',
  'reports.dashboard.warnings.noStatusesDescription':
    'El embudo seleccionado todavía no tiene estados configurados. Agrega estados antes de usar este widget.',
  'reports.dashboard.fields.title.label': 'Título',
  'reports.dashboard.fields.title.hint':
    'Es el nombre principal del widget. Si lo dejas vacío, se usará el título predeterminado del tipo de reporte.',
  'reports.dashboard.fields.title.helper':
    'Úsalo para distinguir dos widgets similares con filtros distintos.',
  'reports.dashboard.fields.label.label': 'Etiqueta',
  'reports.dashboard.fields.label.hint':
    'Es un distintivo corto opcional que aparece encima del título, por ejemplo para marcar prioridad, etapa o audiencia.',
  'reports.dashboard.fields.label.placeholder': 'Ej. Prioridad alta',
  'reports.dashboard.fields.label.helper':
    'Funciona mejor con textos breves de una a tres palabras.',
  'reports.dashboard.fields.color.label': 'Color del widget',
  'reports.dashboard.fields.color.hint':
    'Elige uno de los fondos suaves del sistema para diferenciar la tarjeta. Si agregas una etiqueta, usará el mismo color como acento.',
  'reports.dashboard.fields.color.helper':
    'El color cambia la superficie de la tarjeta y mantiene el texto con el contraste correcto.',
  'reports.dashboard.fields.dateRange.label': 'Rango de fechas',
  'reports.dashboard.fields.dateRange.hint':
    'Define desde qué periodo se calculan los datos del widget. Puedes usar presets rápidos o un rango personalizado.',
  'reports.dashboard.fields.dateRange.helper':
    'Cambiar este filtro actualiza la vista previa con el mismo cálculo que verá el usuario en el panel.',
  'reports.dashboard.fields.users.label': 'Usuarios',
  'reports.dashboard.fields.users.hint':
    'Limita el widget a eventos registrados para usuarios asignados específicos. Déjalo vacío para incluir a todos.',
  'reports.dashboard.fields.users.helper':
    'Este filtro usa el usuario asignado que quedó registrado cuando ocurrió cada evento del reporte.',
  'reports.dashboard.fields.users.loadingMessage': 'Cargando usuarios…',
  'reports.dashboard.fields.users.emptyMessage':
    'No hay usuarios disponibles para este filtro.',
  'reports.dashboard.fields.funnel.label': 'Embudo',
  'reports.dashboard.fields.funnel.hint':
    'Selecciona el embudo del que se tomarán estados, conversaciones y campos de desglose.',
  'reports.dashboard.fields.funnel.helper':
    'Al cambiar de embudo, también cambian los estados y los campos disponibles para este widget.',
  'reports.dashboard.fields.visibleStatuses.label': 'Estados visibles',
  'reports.dashboard.fields.visibleStatuses.helper':
    'Selecciona qué estados entran al cálculo y en qué orden se muestran en la tarjeta.',
  'reports.dashboard.fields.statuses.loadingMessage': 'Cargando estados…',
  'reports.dashboard.fields.statuses.emptyMessage':
    'No hay estados disponibles.',
  'reports.dashboard.fields.status.label': 'Estado',
  'reports.dashboard.fields.status.placeholder': 'Selecciona un estado',
  'reports.dashboard.fields.status.helper':
    'Este widget cuenta la primera vez que una conversación entra al estado elegido.',
  'reports.dashboard.fields.visibleColumns.label': 'Columnas visibles',
  'reports.dashboard.fields.visibleColumns.helper':
    'Oculta columnas que no aportan a la comparación para mantener la tabla legible.',
  'reports.dashboard.fields.breakdown.label': 'Desglose',
  'reports.dashboard.fields.breakdown.hint':
    'Divide los resultados por un campo personalizado del embudo para comparar segmentos dentro del mismo widget.',
  'reports.dashboard.fields.breakdown.none': 'Sin desglose',
  'reports.dashboard.fields.breakdown.helper':
    'Si no necesitas segmentar el dato, deja esta opción en “Sin desglose”.',
  'reports.dashboard.fields.limit.label': 'Límite',
  'reports.dashboard.fields.limit.hint':
    'Controla cuántas propiedades se muestran en el ranking para mantener la tarjeta legible.',
  'reports.dashboard.fields.limit.helper':
    'Entre 5 y 10 filas suele funcionar mejor para paneles pequeños.',
  'reports.dashboard.preview.title': 'Vista previa',
  'reports.dashboard.preview.description':
    'Esta tarjeta usa el mismo renderer y la misma consulta que el dashboard final.',
  'reports.dashboard.preview.helper':
    'En pantallas pequeñas puedes cambiar entre configuración y vista previa usando las pestañas superiores.',
  'reports.dashboard.validation.invalidTitle': 'Configuración inválida',
  'reports.dashboard.validation.incompleteTitle': 'Completa la configuración',
  'reports.dashboard.empty.noDataTitle': 'Sin datos',
  'reports.dashboard.empty.funnelStatusFunnel':
    'No se registraron entradas a estos estados en el período.',
  'reports.dashboard.empty.timeseries':
    'No hubo primeras entradas en el período seleccionado.',
  'reports.dashboard.empty.noPropertiesTitle': 'Sin propiedades',
  'reports.dashboard.empty.propertyTypeDistribution':
    'No hay propiedades activas en el período seleccionado.',
  'reports.dashboard.empty.noRankingTitle': 'Sin ranking',
  'reports.dashboard.empty.propertyInterestRanking':
    'No hubo cambios de interés por propiedad en el período.',
  'reports.dashboard.empty.noAssignmentsTitle': 'Sin asignaciones',
  'reports.dashboard.empty.userAssignmentRanking':
    'No hubo asignaciones en el período o faltan estados visibles.',
  'reports.dashboard.table.user': 'Usuario',
  'reports.dashboard.table.property': 'Propiedad',
  'reports.dashboard.table.consultations': 'Consultas',
  'reports.dashboard.table.total': 'Total',
  'reports.dashboard.setupIssues.selectFunnel':
    'Selecciona un embudo para cargar estados y calcular este reporte.',
  'reports.dashboard.setupIssues.selectAtLeastOneStatus':
    'Selecciona al menos un estado para mostrar el widget.',
  'reports.dashboard.setupIssues.selectTimeseriesStatus':
    'Selecciona un estado para mostrar la serie de tiempo.',
  'reports.dashboard.setupIssues.selectAssignmentFunnel':
    'Selecciona un embudo para mostrar asignaciones por estado.',
  'reports.dashboard.setupIssues.selectStatusColumn':
    'Selecciona al menos una columna de estado para la tabla.',
  'reports.dashboard.setupIssues.reviewConfiguration':
    'Revisa la configuración del widget antes de intentar cargarlo.',
  'reports.dashboard.thumbnail.property': 'Propiedad',
  'reports.dashboard.thumbnail.consultations': 'Consultas',
  'reports.dashboard.thumbnail.user': 'Usuario',
  'reports.dashboard.datePreset.today': 'Hoy',
  'reports.dashboard.datePreset.last7Days': 'Últimos 7 días',
  'reports.dashboard.datePreset.thisMonth': 'Este mes',
  'reports.dashboard.datePreset.last30Days': 'Últimos 30 días',
  'reports.dashboard.datePreset.customRange': 'Rango personalizado',
  'reports.dashboard.dateRange.from': 'Desde',
  'reports.dashboard.dateRange.to': 'Hasta',
  'reports.dashboard.dateRange.trigger': 'Cambiar rango de fechas del reporte',
  'reports.dashboard.dateRange.title': 'Seleccionar rango de fechas',
  'reports.dashboard.dateRange.close': 'Cerrar selector de fechas',
  'reports.dashboard.dateRange.presets': 'Rangos rápidos',
  'reports.dashboard.dateRange.timezone':
    'Las fechas usan la zona horaria {timezone}.',
  'reports.dashboard.dateRange.currentSelection': 'Selección actual:',
  'reports.dashboard.dateRange.errors.missing':
    'Selecciona una fecha de inicio y una fecha de término.',
  'reports.dashboard.dateRange.errors.invalid':
    'Ingresa fechas válidas en formato YYYY-MM-DD.',
  'reports.dashboard.dateRange.errors.order':
    'La fecha inicial del rango personalizado debe ser anterior o igual a la fecha final.',
  'reports.dashboard.dateRange.errors.beforeMin':
    'El rango seleccionado comienza antes de la fecha más antigua disponible.',
  'reports.dashboard.dateRange.errors.afterMax':
    'Los reportes no pueden incluir fechas futuras.',
  'reports.advanced.dateRange.title': 'Período de reportes',
  'reports.advanced.dateRange.description':
    'Este rango de fechas se aplica a todos los reportes de esta página.',
  'reports.advanced.options.groupBy.day': 'Día',
  'reports.advanced.options.groupBy.week': 'Semana',
  'reports.advanced.options.groupBy.month': 'Mes',
  'reports.advanced.options.direction.all': 'Todas',
  'reports.advanced.options.direction.incoming': 'Entrantes',
  'reports.advanced.options.direction.outgoing': 'Salientes',
  'reports.advanced.options.profile.agentsOnly': 'Solo agentes',
  'reports.advanced.options.profile.activeUsersOnly': 'Solo usuarios activos',
  'reports.advanced.options.profile.allUsers': 'Todos',
  'reports.advanced.filters.teamsPlaceholder': 'Selecciona equipos',
  'reports.advanced.filters.agentsPlaceholder': 'Selecciona agentes',
  'reports.advanced.filters.allTeams': 'Todos los equipos',
  'reports.advanced.filters.unassignedTeam': 'Sin equipo',
  'reports.advanced.filters.teamFallback': 'Equipo #{id}',
  'reports.advanced.pagination.rowsPerPage': '{count} filas',
  'reports.advanced.pagination.summary': 'Mostrando {visible} de {total} filas',
  'reports.advanced.table.empty': 'No se encontraron datos',
  'reports.advanced.table.sortBy': 'Ordenar por',
  'reports.advanced.table.ascending': 'menor a mayor',
  'reports.advanced.table.descending': 'mayor a menor',
  'reports.advanced.table.headers.agent': 'Agente',
  'reports.advanced.table.headers.team': 'Equipo',
  'reports.advanced.table.headers.profile': 'Perfil',
  'reports.advanced.table.headers.connected': 'Conectadas',
  'reports.advanced.table.headers.voicemail': 'Buzón',
  'reports.advanced.table.headers.noAnswer': 'No contesta',
  'reports.advanced.table.headers.rejected': 'Rechazadas',
  'reports.advanced.table.headers.averageDuration': 'Duración prom.',
  'reports.advanced.table.headers.minutesOnline': 'Minutos en línea',
  'reports.advanced.table.headers.totalCalls': 'Totales',
  'reports.advanced.table.headers.leads': 'Leads',
  'reports.advanced.table.headers.leadContactability':
    'Contactabilidad de leads (%)',
  'reports.advanced.table.headers.callContactability':
    'Contactabilidad de llamadas (%)',
  'reports.advanced.table.headers.callsPerLead': 'Llamadas / Lead',
  'reports.advanced.table.headers.expertise': 'Expertise',
  'reports.advanced.table.headers.confidence': 'Confianza',
  'reports.advanced.table.headers.objections': 'Objeciones',
  'reports.advanced.table.headers.closing': 'Cierre',
  'reports.advanced.table.headers.performance': 'Desempeño',
  'reports.advanced.table.headers.total': 'Total',
  'reports.advanced.table.headers.average': 'Promedio',
  'reports.advanced.table.headers.timeRange': 'Rango horario',
  'reports.advanced.table.headers.date': 'Fecha',
  'reports.advanced.table.headers.objection': 'Objeción',
  'reports.advanced.table.headers.contact': 'Contacto',
  'reports.advanced.table.headers.phone': 'Teléfono',
  'reports.advanced.table.headers.open': 'Abrir',
  'reports.advanced.weekdays.monday': 'Lunes',
  'reports.advanced.weekdays.tuesday': 'Martes',
  'reports.advanced.weekdays.wednesday': 'Miércoles',
  'reports.advanced.weekdays.thursday': 'Jueves',
  'reports.advanced.weekdays.friday': 'Viernes',
  'reports.advanced.weekdays.saturday': 'Sábado',
  'reports.advanced.weekdays.sunday': 'Domingo',
  'reports.advanced.actions.viewContact': 'Ver contacto',
  'reports.advanced.summary.agents': 'Agentes',
  'reports.advanced.summary.totalCalls': 'Llamadas totales',
  'reports.advanced.summary.averageCallsPerAgent': 'Prom. llamadas / agente',
  'reports.advanced.summary.minutesOnline': 'Minutos en línea',
  'reports.advanced.summary.averageConnectedPerAgent':
    'Prom. conectadas / agente',
  'reports.advanced.summary.note':
    'Resumen calculado sobre los filtros activos de esta tabla.',
  'reports.advanced.metrics.exactMinutes': 'Minutos exactos',
  'reports.advanced.metrics.roundedMinutes': 'Minutos redondeados',
  'reports.advanced.metrics.extractions': 'Extracciones',
  'reports.advanced.tabs.callVolume': '# llamadas',
  'reports.advanced.tabs.contactability': '% contactabilidad',
  'reports.advanced.sections.agentPerformance.title': 'Rendimiento por agente',
  'reports.advanced.sections.agentPerformance.description':
    'Métricas operativas y puntajes de análisis por agente dentro del rango seleccionado.',
  'reports.advanced.sections.agentCalls.title': 'Llamadas por agente',
  'reports.advanced.sections.agentCalls.description':
    'Serie de tiempo de llamadas por agente.',
  'reports.advanced.sections.featuredCalls.title':
    'Llamadas destacadas por agente',
  'reports.advanced.sections.featuredCalls.description':
    'Conteo de llamadas con puntaje destacado en el análisis.',
  'reports.advanced.sections.agentHourly.title': 'Conectadas por hora y agente',
  'reports.advanced.sections.agentHourly.description':
    'Distribución horaria de llamadas completadas por agente.',
  'reports.advanced.sections.outgoingHeatmap.title':
    'Actividad saliente por día y horario',
  'reports.advanced.sections.outgoingHeatmap.description':
    'Distribución de llamadas salientes por bloque horario, con cambio entre volumen y contactabilidad.',
  'reports.advanced.sections.objections.title': 'Objeciones detectadas',
  'reports.advanced.sections.objections.description':
    'Extracciones recientes de objeciones con acceso al contacto cuando aplica.',
  'reports.advanced.sections.leadQualification.title': 'Calificación de leads',
  'reports.advanced.sections.leadQualification.description':
    'Distribución de clasificación de leads derivada del análisis.',
  'reports.advanced.sections.connectedMinutes.title': 'Minutos conectados',
  'reports.advanced.sections.connectedMinutes.description':
    'Evolución de minutos hablados en llamadas completadas.',
  'reports.advanced.sections.extractions.title': 'Extracciones de análisis',
  'reports.advanced.sections.extractions.description':
    'Extracciones más frecuentes dentro del período seleccionado.',
  'reports.advanced.sections.contactabilityByPhone.title':
    'Contactabilidad por teléfono',
  'reports.advanced.sections.contactabilityByPhone.description':
    'Ratio de efectividad por número de origen en los días con volumen suficiente.',
  'reports.dashboard.color.primary': 'Principal',
  'reports.dashboard.color.secondary': 'Secundario',
  'reports.dashboard.color.neutral': 'Neutral',
  'reports.dashboard.color.danger': 'Rojo',
  'reports.dashboard.color.warning': 'Ámbar',
  'reports.dashboard.color.success': 'Verde',
  'reports.dashboard.color.info': 'Azul',
  'reports.dashboard.color.whatsapp': 'WhatsApp',
  'reports.dashboard.color.call': 'Llamadas',
  'reports.dashboard.color.email': 'Email',

  // Sidebar - Catalog Menu Items
  'sidebar.products': 'Productos',
  'sidebar.properties': 'Propiedades',

  // Sidebar - Settings Menu Items
  'sidebar.settings-communications': 'Embudos',
  'sidebar.settings-properties': 'Propiedades',
  'settings.properties.title': 'Propiedades',
  'settings.properties.description':
    'Configuración de propiedades para toda tu empresa.',
  'settings.properties.code.invalid':
    'La preferencia guardada no es válida. Se muestran los códigos Comos hasta que guardes una opción válida o restablezcas el valor predeterminado.',
  'settings.properties.code.label': 'Código de propiedad a mostrar',
  'settings.properties.code.comos': 'Código de Comos',
  'settings.properties.code.external': 'Código externo',
  'settings.properties.code.help':
    'Elige el código que se muestra en Comos. Si falta el código externo o hay códigos diferentes, se muestra el código de Comos con una etiqueta discreta.',
  'settings.properties.code.error':
    'No pudimos cargar o guardar la configuración. Inténtalo de nuevo.',
  'settings.properties.code.saved':
    'Preferencia de código de propiedad guardada.',
  'settings.properties.noPermission':
    'No tienes permiso para administrar esta configuración.',
  'sidebar.settings-preferences': 'Preferencias',
  'sidebar.settings-users': 'Usuarios',
  'sidebar.settings-integrations': 'Integraciones',
  'sidebar.settings-custom-fields': 'Campos personalizados',
  'sidebar.settings-credentials': 'Credenciales',

  // Settings - Employees
  'settings.employees.title': 'Agentes IA',
  'settings.employees.description':
    'Configura el comportamiento compartido de tus agentes IA.',
  'settings.employees.responseWait.title': 'Tiempo de respuesta',
  'settings.employees.responseWait.description':
    'Agrupa mensajes cercanos antes de responder.',
  'settings.employees.responseWait.label':
    'Tiempo de espera antes de responder',
  'settings.employees.responseWait.help':
    'Segundos de espera antes de responder. Se usa para agrupar eventos y evitar respuestas duplicadas.',
  'settings.employees.responseWait.rangeWarning':
    'Usa un número entero entre {min} y {max} segundos.',
  'settings.employees.actions.save': 'Guardar cambios',
  'settings.employees.actions.cancel': 'Cancelar',
  'settings.employees.actions.reset': 'Restablecer valores predeterminados',
  'settings.employees.update.success':
    'Configuración de agentes IA actualizada.',
  'settings.employees.update.error':
    'No se pudo actualizar la configuración de agentes IA.',
  'settings.employees.error.title':
    'No se pudo cargar la configuración de agentes IA',
  'settings.employees.error.description':
    'Actualiza la página o intenta nuevamente más tarde.',
  'sidebar.settings-notifications': 'Notificaciones',
  'settings.preferences.title': 'Preferencias',
  'settings.preferences.description':
    'Administra comportamientos personales de la aplicación y preferencias guardadas en este navegador.',
  'settings.preferences.sections.messaging.title': 'Mensajería',
  'settings.preferences.sections.messaging.description':
    'Preferencias personales para redactar y gestionar conversaciones en este navegador.',

  // Settings - Integrations
  'settings.integrations.title': 'Integraciones',
  'settings.integrations.forbidden':
    'No tienes permisos para ver las integraciones.',
  'settings.integrations.notAvailable': '—',
  'settings.integrations.status.connected': 'Conectado',
  'settings.integrations.status.disabled': 'Deshabilitado',
  'settings.integrations.status.disconnected': 'No conectado',
  'settings.integrations.status.error': 'Error',
  'settings.integrations.health.healthy': 'Saludable',
  'settings.integrations.health.paused': 'En pausa',
  'settings.integrations.health.error': 'Requiere atención',
  'settings.integrations.health.syncing': 'Sincronizando',
  'settings.integrations.sync.startingSoon': 'Comenzará pronto',
  'settings.integrations.index.description':
    'Conecta las herramientas que ya usa tu equipo con Comos y administra cada integración desde una página dedicada.',
  'settings.integrations.index.back': 'Todas las integraciones',
  'settings.integrations.activity.title': 'Actividad reciente',
  'settings.integrations.activity.empty':
    'Todavía no hay actividad para esta integración.',
  'shared.activitySection.title': 'Actividad',
  'settings.integrations.syncSummary.lastSuccess': 'Sincronización',
  'settings.integrations.syncSummary.lastAttempt': 'Intento',
  'settings.integrations.syncSummary.next': 'Próxima',
  'settings.integrations.syncSummary.pausedUntil': 'Pausada',
  'settings.integrations.syncSummary.lastError': 'Error',
  'settings.integrations.sync.editBlockedWhileSyncing':
    'Esta integración está sincronizando. Espera a que termine para guardar cambios.',
  'settings.integrations.sidebar.sections': 'Secciones',
  'settings.integrations.sidebar.messaging': 'Mensajería',
  'settings.integrations.sidebar.whatsapp': 'WhatsApp',
  'settings.integrations.sidebar.realEstate': 'Inmobiliario',
  'settings.integrations.sidebar.realEstateProviders': 'Propiedades',
  'settings.integrations.whatsapp.title': 'WhatsApp',
  'settings.integrations.whatsapp.description':
    'Conecta tu portafolio comercial de Meta para que Comos pueda enviar y recibir mensajes de WhatsApp.',
  'settings.integrations.whatsapp.actions.connect': 'Conectar con Facebook',
  'settings.integrations.whatsapp.actions.connectShort': 'Conectar',
  'settings.integrations.whatsapp.warning.keepTabOpen':
    'Al comenzar, se abrirá una ventana de Meta. Mantén esta pestaña abierta hasta que Comos confirme la conexión.',
  'settings.integrations.whatsapp.warning.adminRequired':
    'Necesitas permisos de administrador para conectar una cuenta de Meta.',
  'settings.integrations.whatsapp.warning.solutionAssociationVerification':
    'Esta cuenta necesita atención antes de poder usarse. Sigue las indicaciones de abajo o contacta al soporte de Comos.',
  'settings.integrations.whatsapp.warning.managedFunding':
    'Esta cuenta usa facturación administrada por Comos. Contacta al soporte de Comos si necesitas ayuda con los cobros de WhatsApp.',
  'settings.integrations.whatsapp.warning.managedDeletionBlocked':
    'Esta cuenta usa facturación administrada por Comos. Contacta al soporte de Comos para cambiar la facturación o desconectarla.',
  'settings.integrations.whatsapp.billing.title':
    'Facturación de cuentas de WhatsApp',
  'settings.integrations.whatsapp.billing.label':
    'Usar la línea de crédito administrada por Comos',
  'settings.integrations.whatsapp.billing.helper':
    'Activa esta opción y completa Conectar con Facebook para agregar una cuenta o cambiar una existente a facturación administrada por Comos. Cambiar esta opción por sí sola no modifica las cuentas conectadas; desactivarla no elimina la facturación administrada.',
  'settings.integrations.whatsapp.billing.loading':
    'Cargando la política de facturación de WhatsApp',
  'settings.integrations.whatsapp.billing.loadError':
    'Comos no pudo cargar la política de facturación. La facturación administrada seguirá no disponible hasta que vuelvas a intentarlo.',
  'settings.integrations.whatsapp.billing.updateSuccess':
    'Se actualizó la política de facturación de WhatsApp.',
  'settings.integrations.whatsapp.billing.updateError':
    'Comos no pudo actualizar la política de facturación. Se recargó el último valor guardado; inténtalo nuevamente.',
  'settings.integrations.whatsapp.errors.configuration':
    'La configuración de facturación administrada está incompleta. No se abrió la ventana de registro de Meta.',
  'settings.integrations.whatsapp.errors.onboardingConfiguration':
    'Comos no pudo preparar un intento seguro de conexión de WhatsApp. No se abrió ninguna ventana de Meta; inténtalo nuevamente.',
  'settings.integrations.whatsapp.errors.finalization':
    'Comos no pudo terminar la configuración. Revisa esta cuenta abajo y sigue el paso indicado. Si ya aparece conectada, no necesitas volver a conectarla.',
  'settings.integrations.whatsapp.errors.delete':
    'No pudimos terminar de desconectar esta cuenta. Contacta al soporte de Comos si volver a intentarlo no ayuda.',
  'settings.integrations.whatsapp.errors.incompleteSession':
    'Meta no entregó toda la información de la cuenta necesaria para terminar de conectar WhatsApp. Inténtalo nuevamente o contacta a soporte.',
  'settings.integrations.whatsapp.errors.unsupportedCompletion':
    'Este flujo de registro de WhatsApp todavía no es compatible. No se guardó una integración parcial.',
  'settings.integrations.whatsapp.errors.metaSignup':
    'Meta no pudo completar el registro de WhatsApp. Revisa la información en la ventana de registro e inténtalo nuevamente.',
  'settings.integrations.whatsapp.errors.signupCancelled':
    'Se canceló la conexión de WhatsApp. No se guardaron cambios; puedes intentarlo nuevamente cuando quieras.',
  'settings.integrations.whatsapp.errors.signupTimeout':
    'La ventana de Meta no terminó a tiempo. Cierra cualquier ventana de registro de Meta que siga abierta antes de intentarlo nuevamente. No se guardó una conexión parcial.',
  'settings.integrations.whatsapp.progress.title': 'Conectando WhatsApp',
  'settings.integrations.whatsapp.progress.subtitle':
    'Mantén abierta esta pestaña de Comos hasta completar ambos pasos.',
  'settings.integrations.whatsapp.progress.meta.label':
    'Completa los pasos en Meta',
  'settings.integrations.whatsapp.progress.meta.active':
    'Completa todos los pasos en la ventana de Meta y presiona Finalizar en la última pantalla.',
  'settings.integrations.whatsapp.progress.meta.complete':
    'Meta entregó correctamente los datos de la cuenta.',
  'settings.integrations.whatsapp.progress.meta.notice':
    'Para completar la conexión, presiona Finalizar en Meta y espera a Comos. Para cancelar, cierra este diálogo. Los permisos ya otorgados en Meta no se revocan.',
  'settings.integrations.whatsapp.progress.finalizing.label':
    'Deja que Comos termine la conexión',
  'settings.integrations.whatsapp.progress.finalizing.pending':
    'Esto comienza automáticamente cuando terminas en Meta.',
  'settings.integrations.whatsapp.progress.finalizing.active':
    'Comos está configurando la cuenta, los números y los webhooks.',
  'settings.integrations.whatsapp.progress.finalizing.notice':
    'Comos está finalizando la conexión. Mantén esta pestaña abierta hasta ver la confirmación.',
  'settings.integrations.whatsapp.connection.linked': 'Integración enlazada',
  'settings.integrations.whatsapp.connection.created':
    'La integración de WhatsApp se creó correctamente.',
  'settings.integrations.whatsapp.connection.quarantinedSaved':
    'La cuenta de WhatsApp se guardó para revisión. El envío de mensajes sigue bloqueado.',
  'settings.integrations.whatsapp.connection.provider': 'Proveedor',
  'settings.integrations.whatsapp.connection.id': 'Identificador',
  'settings.integrations.whatsapp.connection.activatedAt': 'Activada en',
  'settings.integrations.whatsapp.accounts.title': 'Cuentas conectadas',
  'settings.integrations.whatsapp.accounts.defaultName': 'WhatsApp Business',
  'settings.integrations.whatsapp.errors.tenantUnavailable':
    'Tu espacio de trabajo no está disponible. Recarga la página e inténtalo de nuevo.',
  'settings.integrations.whatsapp.accounts.identifier': 'ID: {id}',
  'settings.integrations.whatsapp.accounts.connectedAt': 'Conectado el {date}',
  'settings.integrations.whatsapp.accounts.updatedAt': 'Actualizado el {date}',
  'settings.integrations.whatsapp.accounts.reason': 'Motivo: {reason}',
  'settings.integrations.whatsapp.accounts.phoneCount':
    'Números de teléfono ({count})',
  'settings.integrations.whatsapp.accounts.inactive': 'Inactiva',
  'settings.integrations.whatsapp.accounts.connectedHeading':
    'Cuentas conectadas ({count})',
  'settings.integrations.whatsapp.accounts.disconnectedHeading':
    'Cuentas desconectadas ({count})',
  'settings.integrations.whatsapp.accounts.emptyTitle':
    'No hay cuentas de WhatsApp conectadas',
  'settings.integrations.whatsapp.accounts.emptyDescription':
    'Usa el botón “Conectar con Facebook” para agregar tu primera cuenta',
  'settings.integrations.whatsapp.accounts.confirmRemoval':
    '¿Desconectar esta cuenta de Comos? Ya no podrás enviar ni recibir sus mensajes en Comos. No se eliminarán tu cuenta de WhatsApp ni tu historial de chats.',
  'settings.integrations.whatsapp.accounts.confirmDisconnectedRemoval':
    '¿Terminar de desconectar esta cuenta de Comos? No se eliminarán tu cuenta de WhatsApp ni tu historial de chats. Si no podemos terminar de forma segura, conservaremos la conexión guardada para que soporte te ayude.',
  'settings.integrations.whatsapp.recovery.action': 'Verificar conexión',
  'communications.messageBox.whatsapp.connectionUnavailable':
    'Este número de WhatsApp no está disponible para enviar mensajes. Revisa su conexión en Configuración → Integraciones.',
  'communications.messageBox.whatsapp.availabilityError':
    'No pudimos verificar este remitente de WhatsApp. Inténtalo nuevamente en un momento.',
  'communications.messageBox.whatsapp.openIntegrations': 'Abrir integraciones',
  'communications.messageBox.whatsapp.queued': 'Pendiente',
  'communications.messageBox.whatsapp.sendError':
    'No se pudo enviar el mensaje. Inténtalo nuevamente.',
  'settings.integrations.whatsapp.recovery.pending': 'Reintentando conexión…',
  'settings.integrations.whatsapp.recovery.helper':
    'La configuración de la conexión no terminó. Inténtalo de nuevo aquí; no necesitas repetir los pasos de Facebook.',
  'settings.integrations.whatsapp.recovery.success':
    'Tu conexión de WhatsApp está lista.',
  'settings.integrations.whatsapp.recovery.error':
    'No pudimos terminar la configuración. Revisa el estado actualizado de la cuenta abajo. Si aún necesita atención, contacta al soporte de Comos.',
  'settings.integrations.whatsapp.recovery.importWarning':
    'No se pudieron importar algunos contactos o mensajes anteriores. Esto es independiente del estado de tu conexión. Contacta al soporte de Comos si necesitas ayuda con la importación.',
  'settings.integrations.whatsapp.offboarding.title':
    '¿Necesitas cambiar la facturación o desconectar?',
  'settings.integrations.whatsapp.offboarding.assisted':
    'Para cambiar quién paga tus cobros de WhatsApp o desconectar esta cuenta, contacta al soporte de Comos desde “Necesito ayuda”. Te guiaremos durante el proceso.',
  'settings.integrations.whatsapp.recovery.reconnect':
    'Comos no puede acceder a esta cuenta. Usa “Conectar con Facebook” arriba para volver a conectarla. Si Meta no te permite continuar, contacta al soporte de Comos.',
  'settings.integrations.whatsapp.recovery.support':
    'Necesitamos revisar esta cuenta antes de continuar. Contacta al soporte de Comos desde “Necesito ayuda”. No necesitas eliminar tu cuenta de WhatsApp.',
  'settings.integrations.whatsapp.recovery.metaChange':
    'Meta informó un cambio en esta cuenta. Contacta al soporte de Comos desde “Necesito ayuda” para que te ayudemos a reconectarla de forma segura.',
  'settings.integrations.whatsapp.recovery.adminRequired':
    'Esta conexión necesita atención. Pide ayuda a alguien que administre las integraciones de tu espacio de trabajo.',
  'settings.integrations.whatsapp.offboarding.pending':
    'La desconexión aún no termina. Contacta al soporte de Comos desde “Necesito ayuda” si necesitas asistencia. Reintentar la conexión no completará la desconexión.',
  'settings.integrations.whatsapp.phone.verified': 'Verificado',
  'settings.integrations.whatsapp.phone.unverified': 'No verificado',
  'settings.integrations.whatsapp.phone.pending': 'Pendiente',
  'settings.integrations.whatsapp.phone.unknown': 'Desconocido',
  'settings.integrations.whatsapp.phone.quality.high': 'Calidad alta',
  'settings.integrations.whatsapp.phone.quality.medium': 'Calidad media',
  'settings.integrations.whatsapp.phone.quality.low': 'Calidad baja',
  'settings.integrations.whatsapp.phone.quality.unrated': 'Sin calificar',
  'settings.integrations.whatsapp.accounts.subtitle':
    'Administra tus cuentas de WhatsApp Business conectadas y sus números.',
  'settings.integrations.whatsapp.accounts.connectedCount':
    '{count} conectadas',
  'settings.integrations.whatsapp.accounts.connectedCount.one':
    '{count} conectada',
  'settings.integrations.whatsapp.accounts.connectedCount.other':
    '{count} conectadas',
  'settings.integrations.whatsapp.accounts.disconnectedCount':
    '{count} desconectadas',
  'settings.integrations.whatsapp.accounts.disconnectedCount.one':
    '{count} desconectada',
  'settings.integrations.whatsapp.accounts.disconnectedCount.other':
    '{count} desconectadas',
  'settings.integrations.realEstate.title': 'Propiedades',
  'settings.integrations.realEstate.description':
    'Conecta un proveedor para importar y mantener sincronizada tu información.',
  'settings.integrations.wasi.subtitle':
    'Conecta Wasi usando la API para mantener tus propiedades sincronizadas.',
  'settings.integrations.wasi.noCredentials':
    'No hay credenciales de Wasi disponibles. Crea una API key en Configuración → Credenciales y vuelve aquí para conectarla.',
  'settings.integrations.wasi.companyId.label': 'id_company',
  'settings.integrations.wasi.companyId.placeholder': 'Ej: 12345',
  'settings.integrations.wasi.companyId.help':
    'Identificador de tu empresa en Wasi. Lo encuentras en la configuración de tu cuenta de Wasi.',
  'settings.integrations.wasi.credential.label': 'Credencial (API key)',
  'settings.integrations.wasi.credential.select': 'Selecciona una credencial',
  'settings.integrations.wasi.credential.actions.create.tooltip':
    'Agrega una nueva credencial',
  'settings.integrations.wasi.credential.help':
    'Selecciona la credencial que contiene tu API key de Wasi.',
  'settings.integrations.wasi.autoAssign.label': 'Asignación automática',
  'settings.integrations.wasi.autoAssign.help':
    'Usa el contacto del vendedor para asociar usuarios de Comos cuando haya una coincidencia automática.',
  'settings.integrations.wasi.syncMissingPolicy.label':
    'Si una propiedad deja de llegar',
  'settings.integrations.wasi.syncMissingPolicy.help':
    'Elige si conservarla o desactivarla cuando deje de llegar desde la integración.',
  'settings.integrations.wasi.syncMissingPolicy.option.upsert': 'Conservarla',
  'settings.integrations.wasi.syncMissingPolicy.option.replace': 'Desactivarla',
  'settings.integrations.wasi.propertyScope.label':
    'Qué propiedades sincronizar',
  'settings.integrations.wasi.propertyScope.help':
    'Elige si la sincronización debe considerar todas las propiedades del vendedor o solo las activas.',
  'settings.integrations.wasi.propertyScope.option.all': 'Todas',
  'settings.integrations.wasi.propertyScope.option.active': 'Sólo activas',
  'settings.integrations.wasi.autoSync.label.enabled': 'Sincronización activa',
  'settings.integrations.wasi.autoSync.label.paused': 'Sincronización pausada',
  'settings.integrations.wasi.syncFrequency.label': 'Frecuencia (minutos)',
  'settings.integrations.wasi.syncFrequency.help':
    'Cada cuánto se ejecuta la sincronización automática. Mínimo {min} minutos.',
  'settings.integrations.wasi.actions.connect': 'Conectar',
  'settings.integrations.wasi.actions.connect.tooltip':
    'Conectar usando esta API key e id_company',
  'settings.integrations.wasi.actions.saveChanges': 'Guardar',
  'settings.integrations.wasi.actions.saveChanges.tooltip':
    'Guarda los cambios de esta conexión',
  'settings.integrations.wasi.actions.disconnect': 'Desconectar',
  'settings.integrations.wasi.actions.disconnect.tooltip':
    'Desconecta y detiene la sincronización automática',
  'settings.integrations.wasi.actions.syncNow': 'Sincronizar ahora',
  'settings.integrations.wasi.actions.syncNow.tooltip':
    'Inicia una sincronización ahora',
  'settings.integrations.wasi.sync.lastSuccess':
    'Última sincronización exitosa:',
  'settings.integrations.wasi.sync.lastAttempt':
    'Último intento de sincronización:',
  'settings.integrations.wasi.sync.next': 'Próxima sincronización:',
  'settings.integrations.wasi.sync.pausedUntil': 'Pausado hasta:',
  'settings.integrations.wasi.sync.lastError': 'Último error:',
  'settings.integrations.wasi.health.error.message':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios.',
  'settings.integrations.wasi.health.error.messageWithDetails':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios. El detalle del error es: {message}.',
  'settings.integrations.wasi.health.error.cta': 'Corregir conexión',
  'settings.integrations.wasi.health.paused.message':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente.',
  'settings.integrations.wasi.health.paused.messageWithDetails':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente. El detalle del error es: {message}.',
  'settings.integrations.wasi.disconnectDialog.title': 'Desconectar Wasi',
  'settings.integrations.wasi.disconnectDialog.description':
    'Esto desconectará Wasi y detendrá las futuras sincronizaciones automáticas. Puedes volver a conectarlo cuando quieras.',
  'settings.integrations.wasi.disconnectDialog.cancel': 'Cancelar',
  'settings.integrations.wasi.disconnectDialog.confirm': 'Desconectar',
  'settings.integrations.wasi.disconnect.success': 'Wasi desconectado.',
  'settings.integrations.wasi.disconnect.error':
    'No se pudo desconectar Wasi. Intenta nuevamente.',
  'settings.integrations.permissions.readRequired':
    'No tienes permisos para ver integraciones.',

  'settings.integrations.meli.title': 'Mercado Libre',
  'settings.integrations.meli.subtitle':
    'Conecta Mercado Libre para mantener tus propiedades sincronizadas.',
  'settings.integrations.meli.connectedAccount.label': 'Cuenta conectada',
  'settings.integrations.meli.connectedAccount.loading':
    'Cargando cuenta conectada…',
  'settings.integrations.meli.connectedAccount.loadError':
    'No pudimos verificar qué cuenta de Mercado Libre está conectada actualmente.',
  'settings.integrations.meli.connectedAccount.mismatch':
    'La cuenta autorizada (ID {currentId}) es distinta de la cuenta configurada (ID {configuredId}). Vuelve a conectar Mercado Libre antes de sincronizar o publicar.',
  'settings.integrations.meli.actions.connect': 'Conectar con MercadoLibre',
  'settings.integrations.meli.actions.connectShort': 'Conectar',
  'settings.integrations.meli.actions.disconnect': 'Desconectar',
  'settings.integrations.meli.actions.syncNow': 'Sincronizar ahora',
  'settings.integrations.meli.actions.reauthorize':
    'Volver a autorizar Mercado Libre',
  'settings.integrations.meli.actions.retrySync': 'Reintentar sincronización',
  'settings.integrations.meli.health.authorizationFailed':
    'Mercado Libre no pudo renovar la autorización de esta conexión.',
  'settings.integrations.meli.health.permissionDenied':
    'Mercado Libre restringió el acceso a esta operación. Revisa los permisos de tu cuenta y vuelve a intentarlo.',
  'settings.integrations.meli.actions.syncNow.success':
    'Sincronización de MercadoLibre solicitada correctamente',
  'settings.integrations.meli.connect.started':
    'Se inició la autorización de Mercado Libre. Complétala en la pestaña abierta.',
  'settings.integrations.meli.connect.error':
    'No se pudo iniciar la autorización de Mercado Libre: {message}',
  'settings.integrations.meli.disconnected.help':
    'Haz clic en Conectar para autorizar Mercado Libre. Serás redirigido a Mercado Libre para otorgar acceso.',
  'settings.integrations.meli.connected.help':
    'Mercado Libre está conectado. Tus propiedades se mantendrán sincronizadas.',
  'settings.integrations.meli.mode.label': 'Modo de integración',
  'settings.integrations.meli.mode.description':
    'Define si Comos publicará avisos o si sólo sincronizará el catálogo existente de Mercado Libre.',
  'settings.integrations.meli.mode.options.publish': 'Publicar desde Comos',
  'settings.integrations.meli.mode.options.sync':
    'Sincronizar desde Mercado Libre',
  'settings.integrations.meli.mode.save': 'Guardar',
  'settings.integrations.meli.mode.saveTooltip':
    'Guarda la configuración actual de Mercado Libre.',
  'settings.integrations.meli.mode.confirm.title':
    'Confirmar cambio del modo de integración',
  'settings.integrations.meli.mode.confirm.toSyncDescription':
    'Con el modo "Sincronizar", Mercado Libre será la fuente principal. Comos solo traerá tus publicaciones desde Mercado Libre y no permitirá publicar nuevas desde aquí.',
  'settings.integrations.meli.mode.confirm.toPublishDescription':
    'Con el modo "Publicar", Comos será la fuente principal. Solo podrás publicar desde Comos y no se importarán nuevas publicaciones desde Mercado Libre, excepto las que ya estén vinculadas.',
  'settings.integrations.meli.mode.confirm.warning':
    'Elige "Sincronizar" si sigues gestionando tus propiedades en Mercado Libre. Elige "Publicar" si prefieres administrar y actualizar tus publicaciones directamente en Comos.',
  'settings.integrations.meli.mode.confirm.cancel': 'Cancelar',
  'settings.integrations.meli.mode.confirm.confirm': 'Confirmar y guardar',
  'settings.integrations.meli.mode.saved': 'Modo de Mercado Libre actualizado.',
  'settings.integrations.meli.mode.error':
    'No se pudo actualizar el modo de Mercado Libre: {message}',
  'settings.integrations.meli.mode.missingCredential':
    'Mercado Libre no tiene credencial asociada. Reconecta la integración.',
  'settings.integrations.meli.autoAssign.label': 'Asignación automática',
  'settings.integrations.meli.autoAssign.help':
    'Usa el contacto del vendedor para asociar usuarios de Comos cuando haya una coincidencia automática.',
  'settings.integrations.meli.syncMissingPolicy.label':
    'Si una publicación deja de llegar',
  'settings.integrations.meli.syncMissingPolicy.help':
    'Elige si conservar las publicaciones que ya tienes o actualizarlas con lo que llega desde Mercado Libre.',
  'settings.integrations.meli.syncMissingPolicy.option.upsert': 'Conservarla',
  'settings.integrations.meli.syncMissingPolicy.option.replace': 'Desactivarla',
  'settings.integrations.meli.propertyScope.label':
    'Qué publicaciones sincronizar',
  'settings.integrations.meli.propertyScope.help':
    'Elige si la sincronización debe considerar todas las publicaciones del vendedor o solo las activas.',
  'settings.integrations.meli.propertyScope.option.all': 'Todas',
  'settings.integrations.meli.propertyScope.option.active': 'Sólo activas',
  'settings.integrations.meli.sellerContactWhatsApp.label':
    'WhatsApp de contacto',
  'settings.integrations.meli.sellerContactWhatsApp.select':
    'Selecciona una cuenta de WhatsApp',
  'settings.integrations.meli.sellerContactWhatsApp.help':
    'Esta cuenta central se publicará junto al nombre y correo del usuario asignado a cada propiedad.',
  'settings.integrations.meli.sellerContactWhatsApp.loading':
    'Cargando cuentas de WhatsApp conectadas…',
  'settings.integrations.meli.sellerContactWhatsApp.loadError':
    'No pudimos cargar las cuentas de WhatsApp. Reintenta antes de publicar en Mercado Libre.',
  'settings.integrations.meli.sellerContactWhatsApp.emailOnly':
    'No hay cuentas de WhatsApp conectadas. Las publicaciones usarán sólo el nombre y correo del usuario asignado.',
  'settings.integrations.meli.sellerContactWhatsApp.required':
    'Hay varias cuentas conectadas. Selecciona cuál se publicará en Mercado Libre.',
  'settings.integrations.meli.sellerContactWhatsApp.stale':
    'La cuenta de WhatsApp seleccionada ya no está conectada. Conecta una cuenta de WhatsApp antes de publicar.',
  'settings.integrations.meli.sellerContactWhatsApp.staleWithConnectedAccounts':
    'La cuenta de WhatsApp seleccionada ya no está conectada. Selecciona otra cuenta conectada antes de publicar.',
  'settings.integrations.meli.disconnect.title': 'Desconectar Mercado Libre',
  'settings.integrations.meli.disconnect.description':
    'Esto desconectará Mercado Libre y detendrá las futuras sincronizaciones automáticas. Puedes volver a conectarlo cuando quieras.',
  'settings.integrations.meli.disconnect.confirm': 'Desconectar',
  'settings.integrations.meli.disconnect.cancel': 'Cancelar',
  'settings.integrations.meli.disconnect.success':
    'Integración de Mercado Libre desconectada.',
  'settings.integrations.meli.disconnect.error':
    'No se pudo desconectar Mercado Libre: {message}',
  'settings.integrations.wasi.title': 'Wasi',
  'settings.integrations.2clics.title': '2clics',
  'settings.integrations.2clics.subtitle':
    'Importa tus propiedades desde 2clics (API)',
  'settings.integrations.2clics.noCredentials':
    'No hay credenciales de 2clics disponibles. Crea una API key en Configuración → Credenciales y vuelve aquí para conectarla.',
  'settings.integrations.2clics.credential.label': 'Credencial (API key)',
  'settings.integrations.2clics.credential.select': 'Selecciona una credencial',
  'settings.integrations.2clics.credential.actions.create.tooltip':
    'Agrega una nueva credencial',
  'settings.integrations.2clics.credential.help':
    'Selecciona la credencial que contiene tu API key de 2clics.',
  'settings.integrations.2clics.autoAssign.label': 'Asignación automática',
  'settings.integrations.2clics.autoAssign.help':
    'Usa el contacto del vendedor para asociar usuarios de Comos cuando haya una coincidencia automática.',
  'settings.integrations.2clics.syncMissingPolicy.label':
    'Si una propiedad deja de llegar',
  'settings.integrations.2clics.syncMissingPolicy.help':
    'Elige si conservarla o desactivarla cuando deje de llegar desde la integración.',
  'settings.integrations.2clics.syncMissingPolicy.option.upsert': 'Conservarla',
  'settings.integrations.2clics.syncMissingPolicy.option.replace':
    'Desactivarla',
  'settings.integrations.2clics.propertyScope.label':
    'Qué propiedades sincronizar',
  'settings.integrations.2clics.propertyScope.help':
    'Elige si la sincronización debe considerar todas las propiedades del vendedor o solo las activas.',
  'settings.integrations.2clics.propertyScope.option.all': 'Todas',
  'settings.integrations.2clics.propertyScope.option.active': 'Sólo activas',
  'settings.integrations.2clics.autoSync.label.enabled':
    'Sincronización activa',
  'settings.integrations.2clics.autoSync.label.paused':
    'Sincronización pausada',
  'settings.integrations.2clics.syncFrequency.label': 'Frecuencia (minutos)',
  'settings.integrations.2clics.syncFrequency.help':
    'Cada cuánto se ejecuta la sincronización automática. Mínimo {min} minutos.',
  'settings.integrations.2clics.actions.connect': 'Conectar',
  'settings.integrations.2clics.actions.connect.tooltip':
    'Conectar usando esta API key',
  'settings.integrations.2clics.actions.saveChanges': 'Guardar cambios',
  'settings.integrations.2clics.actions.saveChanges.tooltip':
    'Guarda los cambios de esta conexión',
  'settings.integrations.2clics.actions.disconnect': 'Desconectar',
  'settings.integrations.2clics.actions.disconnect.tooltip':
    'Desconecta y detiene la sincronización automática',
  'settings.integrations.2clics.actions.syncNow': 'Sincronizar ahora',
  'settings.integrations.2clics.actions.syncNow.tooltip':
    'Inicia una sincronización ahora',
  'settings.integrations.2clics.sync.lastSuccess':
    'Última sincronización exitosa:',
  'settings.integrations.2clics.sync.lastAttempt':
    'Último intento de sincronización:',
  'settings.integrations.2clics.sync.next': 'Próxima sincronización:',
  'settings.integrations.2clics.sync.pausedUntil': 'Pausado hasta:',
  'settings.integrations.2clics.sync.lastError': 'Último error:',
  'settings.integrations.2clics.health.error.message':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios.',
  'settings.integrations.2clics.health.error.messageWithDetails':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios. El detalle del error es: {message}.',
  'settings.integrations.2clics.health.error.cta': 'Corregir conexión',
  'settings.integrations.2clics.health.paused.message':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente.',
  'settings.integrations.2clics.health.paused.messageWithDetails':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente. El detalle del error es: {message}.',
  'settings.integrations.2clics.disconnectDialog.title': 'Desconectar 2clics',
  'settings.integrations.2clics.disconnectDialog.description':
    'Esto desconectará 2clics y detendrá las futuras sincronizaciones automáticas. Puedes volver a conectarlo cuando quieras.',
  'settings.integrations.2clics.disconnectDialog.cancel': 'Cancelar',
  'settings.integrations.2clics.disconnectDialog.confirm': 'Desconectar',
  'settings.integrations.2clics.disconnect.success': '2clics desconectado.',
  'settings.integrations.2clics.disconnect.error':
    'No se pudo desconectar 2clics. Intenta nuevamente.',
  'settings.integrations.toppropiedades.title': 'Top Propiedades',
  'settings.integrations.toppropiedades.subtitle':
    'Importa tus propiedades desde TopPropiedades (API)',
  'settings.integrations.toppropiedades.noCredentials':
    'No hay credenciales de TopPropiedades disponibles. Crea un bearer token en Configuración → Credenciales y vuelve aquí para conectarlo.',
  'settings.integrations.toppropiedades.credential.label':
    'Credencial (bearer token)',
  'settings.integrations.toppropiedades.credential.select':
    'Selecciona una credencial',
  'settings.integrations.toppropiedades.credential.actions.create.tooltip':
    'Agrega una nueva credencial',
  'settings.integrations.toppropiedades.credential.help':
    'Selecciona la credencial que contiene tu bearer token de TopPropiedades.',
  'settings.integrations.toppropiedades.autoAssign.label':
    'Asignación automática',
  'settings.integrations.toppropiedades.autoAssign.help':
    'Usa el contacto del vendedor para asociar usuarios de Comos cuando haya una coincidencia automática.',
  'settings.integrations.toppropiedades.syncMissingPolicy.label':
    'Si una propiedad deja de llegar',
  'settings.integrations.toppropiedades.syncMissingPolicy.help':
    'Elige si conservarla o desactivarla cuando deje de llegar desde la integración.',
  'settings.integrations.toppropiedades.syncMissingPolicy.option.upsert':
    'Conservarla',
  'settings.integrations.toppropiedades.syncMissingPolicy.option.replace':
    'Desactivarla',
  'settings.integrations.toppropiedades.propertyScope.label':
    'Qué propiedades sincronizar',
  'settings.integrations.toppropiedades.propertyScope.help':
    'Elige si la sincronización debe considerar todas las propiedades del vendedor o solo las activas.',
  'settings.integrations.toppropiedades.propertyScope.option.all': 'Todas',
  'settings.integrations.toppropiedades.propertyScope.option.active':
    'Sólo activas',
  'settings.integrations.toppropiedades.autoSync.label.enabled':
    'Sincronización activa',
  'settings.integrations.toppropiedades.autoSync.label.paused':
    'Sincronización pausada',
  'settings.integrations.toppropiedades.syncFrequency.label':
    'Frecuencia (minutos)',
  'settings.integrations.toppropiedades.syncFrequency.help':
    'Cada cuánto se ejecuta la sincronización automática. Mínimo {min} minutos.',
  'settings.integrations.toppropiedades.actions.connect': 'Conectar',
  'settings.integrations.toppropiedades.actions.connect.tooltip':
    'Conectar usando este bearer token',
  'settings.integrations.toppropiedades.actions.saveChanges': 'Guardar cambios',
  'settings.integrations.toppropiedades.actions.saveChanges.tooltip':
    'Guarda los cambios de esta conexión',
  'settings.integrations.toppropiedades.actions.disconnect': 'Desconectar',
  'settings.integrations.toppropiedades.actions.disconnect.tooltip':
    'Desconecta y detiene la sincronización automática',
  'settings.integrations.toppropiedades.actions.syncNow': 'Sincronizar ahora',
  'settings.integrations.toppropiedades.actions.syncNow.tooltip':
    'Inicia una sincronización ahora',
  'settings.integrations.toppropiedades.sync.lastSuccess':
    'Última sincronización exitosa:',
  'settings.integrations.toppropiedades.sync.lastAttempt':
    'Último intento de sincronización:',
  'settings.integrations.toppropiedades.sync.next': 'Próxima sincronización:',
  'settings.integrations.toppropiedades.sync.pausedUntil': 'Pausado hasta:',
  'settings.integrations.toppropiedades.sync.lastError': 'Último error:',
  'settings.integrations.toppropiedades.health.error.message':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios.',
  'settings.integrations.toppropiedades.health.error.messageWithDetails':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios. El detalle del error es: {message}.',
  'settings.integrations.toppropiedades.health.error.cta': 'Corregir conexión',
  'settings.integrations.toppropiedades.health.paused.message':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente.',
  'settings.integrations.toppropiedades.health.paused.messageWithDetails':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente. El detalle del error es: {message}.',
  'settings.integrations.toppropiedades.disconnectDialog.title':
    'Desconectar TopPropiedades',
  'settings.integrations.toppropiedades.disconnectDialog.description':
    'Esto desconectará TopPropiedades y detendrá las futuras sincronizaciones automáticas. Puedes volver a conectarlo cuando quieras.',
  'settings.integrations.toppropiedades.disconnectDialog.cancel': 'Cancelar',
  'settings.integrations.toppropiedades.disconnectDialog.confirm':
    'Desconectar',
  'settings.integrations.toppropiedades.disconnect.success':
    'TopPropiedades desconectado.',
  'settings.integrations.toppropiedades.disconnect.error':
    'No se pudo desconectar TopPropiedades. Intenta nuevamente.',
  'settings.integrations.kiteprop.title': 'KiteProp',
  'settings.integrations.kiteprop.subtitle':
    'Importa tus propiedades desde KiteProp (API)',
  'settings.integrations.kiteprop.noCredentials':
    'No hay credenciales de KiteProp disponibles. Crea una API key en Configuración → Credenciales y vuelve aquí para conectarla.',
  'settings.integrations.kiteprop.credential.label': 'Credencial (API key)',
  'settings.integrations.kiteprop.credential.select':
    'Selecciona una credencial',
  'settings.integrations.kiteprop.credential.actions.create.tooltip':
    'Agrega una nueva credencial',
  'settings.integrations.kiteprop.credential.help':
    'Selecciona la credencial que contiene tu API key de KiteProp.',
  'settings.integrations.kiteprop.autoAssign.label': 'Asignación automática',
  'settings.integrations.kiteprop.autoAssign.help':
    'Usa el agente de la propiedad para asociar usuarios de Comos cuando haya una coincidencia automática.',
  'settings.integrations.kiteprop.syncMissingPolicy.label':
    'Si una propiedad deja de llegar',
  'settings.integrations.kiteprop.syncMissingPolicy.help':
    'Elige si conservarla o desactivarla cuando deje de llegar desde la integración.',
  'settings.integrations.kiteprop.syncMissingPolicy.option.upsert':
    'Conservarla',
  'settings.integrations.kiteprop.syncMissingPolicy.option.replace':
    'Desactivarla',
  'settings.integrations.kiteprop.propertyScope.label':
    'Qué propiedades sincronizar',
  'settings.integrations.kiteprop.propertyScope.help':
    'Elige si la sincronización debe considerar todas las propiedades de KiteProp o solo las activas.',
  'settings.integrations.kiteprop.propertyScope.option.all': 'Todas',
  'settings.integrations.kiteprop.propertyScope.option.active': 'Sólo activas',
  'settings.integrations.kiteprop.autoSync.label.enabled':
    'Sincronización activa',
  'settings.integrations.kiteprop.autoSync.label.paused':
    'Sincronización pausada',
  'settings.integrations.kiteprop.syncFrequency.label': 'Frecuencia (minutos)',
  'settings.integrations.kiteprop.syncFrequency.help':
    'Cada cuánto se ejecuta la sincronización automática. Mínimo {min} minutos.',
  'settings.integrations.kiteprop.actions.connect': 'Conectar',
  'settings.integrations.kiteprop.actions.connect.tooltip':
    'Conectar usando esta API key',
  'settings.integrations.kiteprop.actions.saveChanges': 'Guardar cambios',
  'settings.integrations.kiteprop.actions.saveChanges.tooltip':
    'Guarda los cambios de esta conexión',
  'settings.integrations.kiteprop.actions.disconnect': 'Desconectar',
  'settings.integrations.kiteprop.actions.disconnect.tooltip':
    'Desconecta y detiene la sincronización automática',
  'settings.integrations.kiteprop.actions.syncNow': 'Sincronizar ahora',
  'settings.integrations.kiteprop.actions.syncNow.tooltip':
    'Inicia una sincronización ahora',
  'settings.integrations.kiteprop.sync.lastSuccess':
    'Última sincronización exitosa:',
  'settings.integrations.kiteprop.sync.lastAttempt':
    'Último intento de sincronización:',
  'settings.integrations.kiteprop.sync.next': 'Próxima sincronización:',
  'settings.integrations.kiteprop.sync.pausedUntil': 'Pausado hasta:',
  'settings.integrations.kiteprop.sync.lastError': 'Último error:',
  'settings.integrations.kiteprop.health.error.message':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios.',
  'settings.integrations.kiteprop.health.error.messageWithDetails':
    'Ocurrió un problema durante la sincronización. Revisa tus credenciales y configuración, luego guarda los cambios. El detalle del error es: {message}.',
  'settings.integrations.kiteprop.health.error.cta': 'Corregir conexión',
  'settings.integrations.kiteprop.health.paused.message':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente.',
  'settings.integrations.kiteprop.health.paused.messageWithDetails':
    'Ocurrió un problema temporal durante la sincronización, se reintentará automáticamente. El detalle del error es: {message}.',
  'settings.integrations.kiteprop.disconnectDialog.title':
    'Desconectar KiteProp',
  'settings.integrations.kiteprop.disconnectDialog.description':
    'Esto desconectará KiteProp y detendrá las futuras sincronizaciones automáticas. Puedes volver a conectarlo cuando quieras.',
  'settings.integrations.kiteprop.disconnectDialog.cancel': 'Cancelar',
  'settings.integrations.kiteprop.disconnectDialog.confirm': 'Desconectar',
  'settings.integrations.kiteprop.disconnect.success': 'KiteProp desconectado.',
  'settings.integrations.kiteprop.disconnect.error':
    'No se pudo desconectar KiteProp. Intenta nuevamente.',

  // Tools
  'tools.toolConfig.aliasPlaceholder.listProperties': 'Ej: Listar propiedades',

  // Settings - Funnels
  'settings.funnels.statusDelete.confirm.title': 'Confirmar eliminación',
  'settings.funnels.statusDelete.confirm.body':
    '¿Deseas eliminar este estado del embudo?',
  'settings.funnels.statusDelete.error.linkedConversations':
    'No puedes eliminar este estado porque tiene conversaciones asociadas. Reasigna esas conversaciones a otro estado antes de eliminarlo.',
  'settings.funnels.statusDescription.example.main':
    '\n1. Saluda y confirma motivo\n\t- Si menciona una propiedad, entonces agenda visita y procede al paso 2\n\t- Si no la menciona, entonces solicita zona, presupuesto, nombre y teléfono\n2. Revisa requisitos\n\t- Si cumple, entonces mueve la conversación al estado "Gestión"\n\t- Si no cumple, entonces mueve la conversación al estado "No calificado"',

  // Settings - Credentials
  'settings.credentials.title': 'Credenciales',
  'settings.credentials.create.button': 'Nueva credencial',
  'settings.credentials.all': 'Todos los tipos',
  'settings.credentials.yes': 'Sí',
  'settings.credentials.no': 'No',
  'settings.credentials.loading': 'Cargando…',
  'settings.credentials.loadingMore': 'Cargando más…',
  'settings.credentials.empty': 'No hay credenciales.',
  'settings.credentials.forbidden.title': 'Sin acceso',
  'settings.credentials.forbidden.description':
    'No tienes permisos para ver credenciales.',
  'settings.credentials.error.title': 'Algo salió mal',
  'settings.credentials.error.description':
    'No pudimos cargar tus credenciales.',
  'settings.credentials.error.retry': 'Reintentar',
  'settings.credentials.alerts.created': 'Credencial creada.',
  'settings.credentials.alerts.updated': 'Credencial actualizada.',
  'settings.credentials.alerts.rotated': 'Se actualizó el secreto.',
  'settings.credentials.alerts.deleted': 'Credencial eliminada.',
  'settings.credentials.alerts.error': 'Algo salió mal.',
  'settings.credentials.filters.kind': 'Tipo',
  'settings.credentials.filters.clear': 'Limpiar',
  'settings.credentials.provider.select': 'Selecciona un proveedor',
  'settings.credentials.provider.other': 'Otro',
  'settings.credentials.provider.prop360': 'Prop360',
  'settings.credentials.provider.kutt': 'Kutt',
  'settings.credentials.provider.2clics': '2clics',
  'settings.credentials.provider.toppropiedades': 'TopPropiedades',
  'settings.credentials.provider.kiteprop': 'KiteProp',
  'settings.credentials.provider.wasi': 'Wasi',
  'settings.credentials.provider.mercadolibre': 'Mercado Libre',
  'settings.credentials.kind.apiKey': 'API key',
  'settings.credentials.kind.bearer': 'Bearer token',
  'settings.credentials.kind.basic': 'Básico (usuario/contraseña)',
  'settings.credentials.kind.custom': 'Personalizado (JSON)',
  'settings.credentials.kind.oauth': 'OAuth',
  'settings.credentials.status.active': 'Activa',
  'settings.credentials.status.disabled': 'Deshabilitada',
  'settings.credentials.table.name': 'Nombre',
  'settings.credentials.table.provider': 'Proveedor',
  'settings.credentials.table.kind': 'Tipo',
  'settings.credentials.table.status': 'Estado',
  'settings.credentials.table.shared': 'Compartida',
  'settings.credentials.table.actions': 'Acciones',
  'settings.credentials.table.emptyState.title':
    'No se encontraron credenciales',
  'settings.credentials.table.emptyState.description':
    'Crea una credencial para comenzar a usar integraciones.',
  'settings.credentials.actions.edit': 'Editar',
  'settings.credentials.actions.rotate': 'Actualizar secreto',
  'settings.credentials.actions.delete': 'Eliminar',
  'settings.credentials.actions.revealSecret': 'Ver secreto',
  'settings.credentials.actions.cancel': 'Cancelar',
  'settings.credentials.actions.create': 'Crear',
  'settings.credentials.actions.save': 'Guardar',
  'settings.credentials.actions.close': 'Cerrar',
  'settings.credentials.create.title': 'Nueva credencial',
  'settings.credentials.edit.title': 'Editar credencial',
  'settings.credentials.rotate.title': 'Actualizar secreto',
  'settings.credentials.reveal.title': 'Ver secreto',
  'settings.credentials.provider.all': 'Todos los proveedores',
  'settings.credentials.delete.title': 'Eliminar credencial',
  'settings.credentials.delete.warning': 'Esta acción no se puede deshacer.',
  'settings.credentials.form.provider': 'Proveedor',
  'settings.credentials.form.name': 'Nombre',
  'settings.credentials.form.kind': 'Tipo',
  'settings.credentials.form.status': 'Estado',
  'settings.credentials.form.sharedWithTenant': 'Compartida con el tenant',
  'settings.credentials.form.sharedWithUsers': 'Compartida con otros usuarios',
  'settings.credentials.form.sharedInfo':
    'Otros usuarios pueden usar esta credencial, pero no podrán ver el secreto.',
  'settings.credentials.form.encryptionInfo':
    'Las credenciales se almacenan cifradas y de forma segura. Por tu seguridad, los secretos no se muestran después de guardarlos — puedes actualizar el secreto cuando quieras.',
  'settings.credentials.reveal.warning':
    'Esta información es sensible. No la compartas. Los secretos se almacenan cifrados y el acceso está restringido a super admins.',
  'settings.credentials.form.otherProvider': 'ID del proveedor',
  'settings.credentials.form.otherProviderPlaceholder':
    "Ej: 'hubspot', 'pipedrive'",
  'settings.credentials.form.apiKey': 'API key',
  'settings.credentials.form.bearerToken': 'Bearer token',
  'settings.credentials.form.username': 'Usuario',
  'settings.credentials.form.password': 'Contraseña',
  'settings.credentials.form.secretJson': 'Secreto (objeto JSON)',
  'settings.credentials.validation.required': 'Requerido',
  'settings.credentials.validation.jsonObject': 'Debe ser un objeto JSON',
  'settings.notifications.title': 'Notificaciones',
  'settings.notifications.inApp.title': 'Preferencias en el sitio web',
  'settings.notifications.inApp.alert': 'Tipo de alerta',
  'settings.notifications.inApp.alert.helper':
    'Elige entre alerta o solo contador.',
  'settings.notifications.inApp.alert.option.alert': 'Alerta en pantalla',
  'settings.notifications.inApp.alert.option.badge': 'Solo contador',
  'settings.notifications.inApp.sound': 'Sonido',
  'settings.notifications.inApp.sound.helper':
    'Elige si deseas sonido al recibir notificaciones.',
  'settings.notifications.inApp.sound.option.on': 'Con sonido',
  'settings.notifications.inApp.sound.option.off': 'Sin sonido',
  'settings.notifications.alerts.updated':
    'Preferencias de notificaciones actualizadas.',
  'settings.notifications.alerts.error': 'Algo salio mal.',
  'settings.notifications.error.title': 'Algo salio mal',
  'settings.notifications.error.description':
    'No se pudieron cargar las preferencias de notificaciones.',
  'settings.notifications.error.retry': 'Reintentar',
  'settings.notifications.description':
    'Controla alertas, ruteo de dispositivos y horarios de silencio.',
  'settings.notifications.actions.save': 'Guardar cambios',
  'settings.notifications.actions.reset': 'Restablecer',
  'settings.notifications.sections.inApp.description':
    'Elige si el sitio web muestra alertas o reproduce un sonido.',
  'settings.notifications.sections.app.title': 'Notificaciones del sitio web',
  'settings.notifications.sections.app.description':
    'Valores por defecto para alertas, sonidos y actividad en el sitio web.',
  'settings.notifications.sections.app.toggle':
    'Activar notificaciones del sitio web',
  'settings.notifications.sections.app.advanced.toggle':
    'Mostrar configuración avanzada',
  'settings.preferences.messaging.writing.title': 'Enter ↵ para enviar',
  'settings.preferences.messaging.writing.description':
    'Desactívalo para insertar una nueva línea al presionar Enter.',
  'settings.preferences.messaging.writing.helper':
    'Esta preferencia se guarda al instante en este navegador. Automático usa nueva línea en dispositivos táctiles.',
  'settings.preferences.messaging.writing.options.auto': 'Automático',
  'settings.preferences.messaging.writing.options.send': 'Enviar mensaje',
  'settings.preferences.messaging.writing.options.newline': 'Nueva línea',
  'settings.notifications.sections.marketing.title':
    'Notificaciones de marketing',
  'settings.notifications.sections.marketing.description':
    'Activa anuncios y novedades de producto.',
  'settings.notifications.sections.marketing.toggle': 'Activar marketing',
  'settings.notifications.sections.marketing.advanced.toggle':
    'Mostrar configuración avanzada',
  'settings.notifications.sections.advanced.title': 'Configuración avanzada',
  'settings.notifications.sections.advanced.description':
    'Ajusta reglas por evento y horarios.',
  'settings.notifications.sections.channels.title': 'Preferencias por canal',
  'settings.notifications.sections.channels.description':
    'Define que canales pueden notificarte.',
  'settings.notifications.sections.routing.title':
    'Dispositivos de notificación',
  'settings.notifications.sections.routing.description':
    'Elige qué dispositivo recibe las notificaciones.',
  'settings.notifications.sections.dnd.title': 'No molestar',
  'settings.notifications.sections.dnd.description': 'Horarios y excepciones.',
  'settings.notifications.eventRules.title': 'Reglas por evento',
  'settings.notifications.eventRules.description':
    'Sobrescribe los valores por defecto por evento.',
  'settings.notifications.eventRules.loading': 'Cargando catálogo de eventos…',
  'settings.notifications.eventRules.error':
    'No se pudieron cargar los eventos.',
  'settings.notifications.eventRules.empty': 'Aún no hay eventos disponibles.',
  'settings.notifications.eventRules.group.app': 'Eventos del sitio web',
  'settings.notifications.eventRules.group.marketing': 'Eventos de marketing',
  'settings.notifications.eventRules.enabled': 'Activo',
  'settings.notifications.eventRules.alert.label': 'Alerta por evento',
  'settings.notifications.eventRules.alert.inherit': 'Usar por defecto',
  'settings.notifications.eventRules.alert.alert': 'Mostrar alerta',
  'settings.notifications.eventRules.alert.badge': 'Solo contador',
  'settings.notifications.eventRules.sound.label': 'Sonido por evento',
  'settings.notifications.eventRules.sound.inherit': 'Usar por defecto',
  'settings.notifications.eventRules.sound.on': 'Con sonido',
  'settings.notifications.eventRules.sound.off': 'Sin sonido',
  'settings.notifications.eventRules.deliveryChannels.label':
    'Canales de entrega',
  'settings.notifications.eventRules.deliveryChannels.phoneRequired':
    'Debes configurar un teléfono para habilitar WhatsApp o SMS.',
  'settings.notifications.deliveryChannels.inApp': 'Sitio web (in-app)',
  'settings.notifications.deliveryChannels.push': 'Notificación push',
  'settings.notifications.deliveryChannels.email': 'Correo electrónico',
  'settings.notifications.deliveryChannels.sms': 'SMS',
  'settings.notifications.deliveryChannels.whatsapp': 'WhatsApp',
  'settings.notifications.eventRules.deviceRouting.title':
    'Dispositivos por evento',
  'settings.notifications.eventRules.deviceRouting.description':
    'Sobrescribe qué dispositivo recibe este evento.',
  'settings.notifications.eventRules.deviceRouting.mode.label':
    'Selección de dispositivo',
  'settings.notifications.eventRules.deviceRouting.mode.inherit':
    'Usar configuración general',
  'settings.notifications.eventRules.deviceRouting.primaryEndpoint.helper':
    'Solo se usa cuando el modo es Solo dispositivo primario.',
  'notifications.events.messaging.message.received.label': 'Nuevo mensaje',
  'notifications.events.messaging.message.received.description':
    'Mensaje entrante asignado a ti.',
  'notifications.events.conversation.escalated.label': 'Conversacion escalada',
  'notifications.events.conversation.escalated.description':
    'Un empleado necesita ayuda humana con un contacto.',
  'notifications.events.conversation.marked-ready-to-visit.label':
    'Contacto listo para coordinar visita',
  'notifications.events.conversation.marked-ready-to-visit.description':
    'Un empleado derivo un contacto listo para coordinar visita.',
  'notifications.events.conversation.table-export.ready.label':
    'Exportación de conversaciones lista',
  'notifications.events.conversation.table-export.ready.description':
    'Tu exportación de conversaciones está lista para descargar.',
  'notifications.events.marketing.campaign.dispatch.label':
    'Campaña de marketing',
  'notifications.events.marketing.campaign.dispatch.description':
    'Anuncios y novedades de producto.',
  'settings.notifications.channels.messaging': 'Mensajeria',
  'settings.notifications.channels.marketing': 'Marketing',
  'settings.notifications.channels.calls': 'Llamadas',
  'settings.notifications.routing.mode.label': 'Selección de dispositivo',
  'settings.notifications.routing.advanced.toggle':
    'Mostrar configuración avanzada',
  'settings.notifications.routing.advanced.title': 'Dispositivo por evento',
  'settings.notifications.routing.advanced.description':
    'Personaliza qué dispositivo recibe eventos específicos.',
  'settings.notifications.routing.primaryEndpoint': 'Dispositivo primario',
  'settings.notifications.routing.primaryEndpoint.placeholder':
    'Selecciona un dispositivo',
  'settings.notifications.routing.primaryEndpoint.none':
    'Sin dispositivo primario',
  'settings.notifications.routing.primaryEndpoint.empty':
    'Aún no hay dispositivos registrados.',
  'settings.notifications.routing.primaryEndpoint.error':
    'No se pudieron cargar los dispositivos.',
  'settings.notifications.routing.primaryEndpoint.helper':
    'Solo se usa cuando el modo es Solo dispositivo primario.',
  'settings.notifications.routing.mode.lastActive': 'Último dispositivo activo',
  'settings.notifications.routing.mode.ringAll':
    'Notificar en todos los dispositivos',
  'settings.notifications.routing.mode.primaryOnly':
    'Solo dispositivo primario',
  'settings.notifications.dnd.enabled': 'Activar DND',
  'settings.notifications.dnd.timezone': 'Zona horaria',
  'settings.notifications.dnd.timezone.placeholder': 'America/Mexico_City',
  'settings.notifications.dnd.snoozeUntil': 'Silenciar hasta',
  'settings.notifications.dnd.behavior.default': 'Comportamiento por defecto',
  'settings.notifications.dnd.behavior.messaging': 'Override de mensajeria',
  'settings.notifications.dnd.behavior.marketing': 'Override de marketing',
  'settings.notifications.dnd.behavior.calls': 'Override de llamadas',
  'settings.notifications.dnd.behavior.createInboxItem':
    'Siempre crear item en inbox',
  'settings.notifications.dnd.behavior.inherit': 'Heredar por defecto',
  'settings.notifications.dnd.behavior.suppressPush': 'Silenciar solo push',
  'settings.notifications.dnd.behavior.suppressAll': 'Silenciar todo',
  'settings.notifications.dnd.behavior.allowBadgeOnly': 'Solo badge',
  'settings.notifications.dnd.behavior.allowCallRing': 'Permitir llamada',
  'settings.notifications.dnd.behavior.allowAll': 'Permitir todo',
  'settings.notifications.dnd.schedules.title': 'Horarios semanales',
  'settings.notifications.dnd.schedules.add': 'Agregar horario',
  'settings.notifications.dnd.schedules.empty': 'Aún no hay horarios creados.',
  'settings.notifications.dnd.schedules.range': 'Horas en silencio',
  'settings.notifications.dnd.schedules.item': 'Horario {index}',
  'settings.notifications.dnd.schedules.untitled': 'Horario sin nombre',
  'settings.notifications.dnd.schedules.name': 'Nombre del horario',
  'settings.notifications.dnd.schedules.enabled': 'Horario activo',
  'settings.notifications.dnd.schedules.days': 'Dias de la semana',
  'settings.notifications.dnd.schedules.start': 'Hora inicio',
  'settings.notifications.dnd.schedules.end': 'Hora fin',
  'settings.notifications.dnd.schedules.dateRange.title':
    'Rango de fechas (opcional)',
  'settings.notifications.dnd.schedules.dateRange.start': 'Fecha inicio',
  'settings.notifications.dnd.schedules.dateRange.end': 'Fecha fin',
  'settings.notifications.dnd.schedules.channels': 'Canales',
  'settings.notifications.dnd.schedules.behavior': 'Override de comportamiento',
  'settings.notifications.dnd.schedules.priority': 'Prioridad',
  'settings.notifications.dnd.deviceOverrides.title':
    'Overrides por dispositivo',
  'settings.notifications.dnd.deviceOverrides.add': 'Agregar override',
  'settings.notifications.dnd.deviceOverrides.untitled': 'Nuevo override',
  'settings.notifications.dnd.deviceOverrides.endpointId': 'Endpoint ID',
  'settings.notifications.dnd.deviceOverrides.channels': 'Canales',
  'settings.notifications.dnd.deviceOverrides.behavior':
    'Override de comportamiento',
  'settings.notifications.dnd.days.mon': 'Lun',
  'settings.notifications.dnd.days.tue': 'Mar',
  'settings.notifications.dnd.days.wed': 'Mie',
  'settings.notifications.dnd.days.thu': 'Jue',
  'settings.notifications.dnd.days.fri': 'Vie',
  'settings.notifications.dnd.days.sat': 'Sab',
  'settings.notifications.dnd.days.sun': 'Dom',
  'settings.notifications.alerts.missingTimezone':
    'La zona horaria es requerida cuando DND esta activo.',
  'notifications.alerts.new': 'Tienes una nueva notificacion{title}',
  'notifications.prompt.title': '¡Bienvenido!',
  'notifications.prompt.description':
    'Activa las notificaciones para no perderte ningun mensaje importante.',
  'notifications.prompt.actions.enable': 'Activar notificaciones',
  'notifications.prompt.actions.notNow': 'Ahora no',
  'notifications.prompt.actions.dismiss': 'No volver a mostrar',
  'notifications.prompt.actions.close': 'Cerrar',
  'notifications.prompt.alerts.enabled':
    'Notificaciones activadas correctamente.',
  'notifications.prompt.alerts.permissionDenied':
    'Activa las notificaciones desde la configuracion del navegador y vuelve a intentarlo.',
  'notifications.prompt.alerts.unsupported':
    'Este navegador no permite activar notificaciones push.',
  'notifications.prompt.alerts.unavailable':
    'Las notificaciones no estan disponibles en este momento.',
  'notifications.prompt.alerts.subscriptionFailed':
    'No se pudo preparar la suscripcion del navegador. Intentalo nuevamente.',
  'notifications.prompt.alerts.endpointRegistrationFailed':
    'No se pudo registrar este dispositivo para recibir notificaciones. Intentalo nuevamente.',
  'notifications.prompt.alerts.timeout':
    'La activacion esta tardando demasiado. Intentalo nuevamente en unos segundos.',
  'communications.table.export.button': 'Exportar archivo',
  'communications.table.export.alert.inProgress':
    'La exportación está en progreso. Recibirás una notificación cuando esté lista.',
  'communications.table.export.alert.error':
    'No se pudo iniciar la exportación. Por favor, inténtalo de nuevo.',
  'communications.table.export.dialog.title': 'Exportar conversaciones',
  'communications.table.export.dialog.description':
    'Selecciona el formato del archivo para exportar la tabla actual.',
  'communications.table.export.dialog.confirm': 'Exportar',
  'communications.table.export.dialog.cancel': 'Cancelar',
  'communications.table.export.format.xlsx': 'Excel (.xlsx)',
  'communications.table.export.format.csv': 'CSV (.csv)',
  'communications.dropdown.status.mobileTitle': 'Cambiar estado',
  'communications.dropdown.assignee.mobileTitle': 'Asignar conversación',
  'communications.dropdown.savedViews.mobileTitle': 'Vistas guardadas',
  'communications.dropdown.bulkActions.mobileTitle': 'Acciones masivas',
  'communications.dropdown.bulkActions.assign.mobileTitle':
    'Asignar conversaciones',
  'communications.dropdown.bulkActions.move.mobileTitle':
    'Mover conversaciones',
  'communications.dropdown.funnel.mobileTitle': 'Selecciona un embudo',

  // Websites - Settings
  'websites.settings.title': 'Sitios web',
  'websites.settings.error.title':
    'No pudimos cargar la configuración del sitio',
  'websites.settings.error.description':
    'Reintenta en unos segundos o revisa la configuración de plantillas.',
  'websites.settings.actions.previewDraft': 'Vista previa',
  'websites.settings.actions.saveDraft': 'Guardar borrador',
  'websites.settings.actions.saveAndDeploy': 'Publicar cambios',
  'websites.settings.alerts.deploySuccess': 'Sitio publicado correctamente.',
  'websites.settings.alerts.deployFailed': 'La publicación del sitio falló.',
  'websites.settings.alerts.deployFailedWithError':
    'La publicación falló: {errorMessage}',
  'websites.settings.alerts.saveDraftSuccess': 'Borrador del sitio guardado.',
  'websites.settings.alerts.saveDraftError': 'No se pudo guardar el sitio.',
  'websites.settings.alerts.provisionalSlugUnavailable':
    'Ese slug provisional ya está en uso. Elige otro.',
  'websites.settings.alerts.previewBlocked':
    'La previsualización se creó, pero el navegador bloqueó la nueva pestaña.',
  'websites.settings.alerts.previewError':
    'No se pudo abrir la previsualización del borrador.',
  'websites.settings.alerts.deployStarted':
    'Publicación iniciada. Estamos publicando el sitio.',
  'websites.settings.alerts.deployStartError':
    'No se pudo iniciar la publicación del sitio.',
  'websites.settings.alerts.logoDurabilityPending':
    'El borrador se guardó, pero el logo aún se está preparando. Intenta publicar nuevamente en unos instantes.',
  'websites.settings.template.private': 'Privada',
  'websites.settings.template.public': 'Pública',
  'websites.settings.template.technicalConfigDescription':
    'Se completa automáticamente al elegir una plantilla. Edítalo solo para pruebas o soporte.',
  'websites.settings.template.keyLabel': 'Clave de plantilla',
  'websites.settings.template.versionLabel': 'Versión',
  'websites.settings.provisionalSlug.label':
    'Nombre en la dirección provisional',
  'websites.settings.logo.label': 'Logo del sitio web',
  'websites.settings.logo.help':
    'Sube un archivo PNG, JPEG, WebP o SVG de hasta 5 MB.',
  'websites.settings.logo.inactive':
    'Esta plantilla no admite logos. El logo guardado se conserva y volverá a activarse al elegir una plantilla compatible.',
  'websites.settings.logo.remove': 'Quitar logo',
  'websites.settings.logo.upload': 'Subir logo',
  'websites.settings.logo.change': 'Cambiar',
  'websites.settings.logo.changeLabel': 'Cambiar logo',
  'websites.settings.logo.empty': 'Sin logo',
  'websites.settings.logo.dimensions': '{width} × {height} px',
  'websites.settings.logo.check.ideal':
    'Buen tamaño y forma para el encabezado de todos los diseños.',
  'websites.settings.logo.check.square':
    'Es casi cuadrado: lo mostramos más pequeño, junto al nombre de tu corredora.',
  'websites.settings.logo.check.small':
    'Mide {width} × {height} px y puede verse borroso en pantallas de alta resolución. Súbelo de al menos {minWidth} × {minHeight} px.',
  'websites.settings.logo.specs.title':
    'Para que se vea bien en todos los diseños',
  'websites.settings.logo.specs.shape':
    'Horizontal, cerca de 4:1, por ejemplo 800 × 200 px. Los diseños lo muestran a unos 45 px de alto y hasta 200 px de ancho.',
  'websites.settings.logo.specs.background':
    'Con fondo transparente (SVG o PNG) y sin márgenes vacíos alrededor, porque lo achican.',
  'websites.settings.logo.specs.colors':
    'Pensado para fondo blanco: así funciona en todos los diseños. En Ónix va sobre una placa clara.',
  'websites.settings.logo.specs.square':
    'Si es cuadrado o redondo, lo mostramos junto al nombre de tu corredora.',
  'websites.settings.logo.previewAlt':
    'Vista previa del logo actual del sitio web',
  'websites.settings.logo.progressLabel':
    'Progreso de subida del logo del sitio web',
  'websites.settings.logo.saveBeforeTemplateChange':
    'Guarda o quita el logo subido antes de cambiar de plantilla.',
  'websites.settings.logo.deferredCleanup':
    'El logo publicado seguirá disponible hasta la próxima publicación exitosa; después se ejecutará la limpieza del archivo.',
  'websites.settings.logo.status.preparing': 'Preparando y validando el logo…',
  'websites.settings.logo.status.uploading': 'Subiendo el logo…',
  'websites.settings.logo.status.finalizing': 'Validando el logo subido…',
  'websites.settings.logo.status.waitingForDurability':
    'Borrador guardado. Terminando de preparar el logo antes de publicar…',
  'websites.settings.logo.status.durabilityPending':
    'Borrador guardado. El logo aún se está preparando; intenta publicar nuevamente en unos instantes.',
  'websites.settings.logo.status.ready':
    'Logo subido. Guarda el borrador para conservar este cambio.',
  'websites.settings.logo.status.removed':
    'Logo quitado del borrador. Guarda para conservar este cambio.',
  'websites.settings.logo.errors.empty':
    'Selecciona un archivo de logo que no esté vacío.',
  'websites.settings.logo.errors.tooLarge':
    'El logo supera los 5 MB. Selecciona un archivo más pequeño.',
  'websites.settings.logo.errors.unsupportedType':
    'Selecciona un logo PNG, JPEG, WebP o SVG.',
  'websites.settings.logo.errors.extensionMismatch':
    'La extensión del archivo no coincide con el formato del logo.',
  'websites.settings.logo.errors.uploadFailed':
    'No se pudo subir o validar el logo. El logo anterior sigue seleccionado.',
  'websites.settings.status.title': 'Estado actual',
  'websites.settings.status.labels.status': 'Estado',
  'websites.settings.status.labels.liveUrl': 'Dirección en vivo',
  'websites.settings.status.labels.provisionalUrl': 'Dirección provisional',
  'websites.settings.status.labels.primaryDomain': 'Dominio principal',
  'websites.settings.status.labels.latestDeployment': 'Última publicación',
  'websites.settings.status.labels.deploymentError': 'Error de publicación',
  'websites.settings.status.deploymentSummary': 'v{version} · {status}',
  'websites.settings.status.pendingFirstDeploy':
    'Pendiente de primera publicación',
  'websites.settings.status.pending': 'Pendiente',
  'websites.settings.websiteStatus.draft': 'Borrador',
  'websites.settings.websiteStatus.publishing': 'Publicando',
  'websites.settings.websiteStatus.published': 'Publicado',
  'websites.settings.websiteStatus.failed': 'Fallido',
  'websites.settings.deploymentStatus.queued': 'En cola',
  'websites.settings.deploymentStatus.running': 'En ejecución',
  'websites.settings.deploymentStatus.succeeded': 'Completado',
  'websites.settings.deploymentStatus.failed': 'Fallido',
  'websites.settings.navigation.home': 'Inicio',
  'websites.settings.navigation.properties': 'Propiedades',
  'websites.settings.navigation.contact': 'Contacto',
  'websites.settings.analytics.title': 'Analytics de WhatsApp',
  'websites.settings.analytics.description':
    'Últimos 30 días de clicks registrados en el sitio público.',
  'websites.settings.analytics.clicksCount': '{count} clicks',
  'websites.settings.analytics.alerts.noRecentClicks.title':
    'Sin clicks recientes',
  'websites.settings.analytics.alerts.noRecentClicks.message':
    'Tu sitio no registra clicks de WhatsApp en los últimos 7 días. Revisa el tráfico, el seguimiento y la visibilidad del sitio.',
  'websites.settings.analytics.alerts.clickVolumeDrop.title':
    'Caída de actividad',
  'websites.settings.analytics.alerts.clickVolumeDrop.message':
    'Los clicks de WhatsApp bajaron con fuerza frente a la semana anterior. Revisa si hubo cambios en el tráfico, las campañas o los CTAs.',
  'websites.settings.analytics.error.title': 'No pudimos cargar los analytics',
  'websites.settings.analytics.error.description':
    'Reintenta en unos segundos.',
  'websites.settings.analytics.empty.description':
    'Guarda y publica un sitio para empezar a consolidar analytics.',
  'websites.settings.analytics.emptyValue': 'Sin datos',
  'websites.settings.analytics.totalClicks': 'Clicks totales',
  'websites.settings.analytics.bestCta': 'Mejor CTA',
  'websites.settings.analytics.propertiesConsulted': 'Propiedades consultadas',
  'websites.settings.analytics.ctaBySlot': 'CTA por slot',
  'websites.settings.analytics.dailyActivity': 'Actividad diaria',
  'websites.settings.analytics.dailyActivity.empty':
    'Sin actividad en el rango actual.',
  'websites.settings.analytics.topProperties': 'Propiedades más consultadas',
  'websites.settings.analytics.topProperties.empty':
    'Aún no hay clicks asociados a propiedades.',
  'websites.settings.analytics.propertyFallback': 'Propiedad {id}',
  'websites.settings.analytics.recentClicks': 'Clicks recientes',
  'websites.settings.analytics.recentClicks.empty':
    'Todavía no hay eventos recientes.',
  'websites.settings.analytics.recentClicks.noProperty':
    'Click sin propiedad asociada',
  'websites.settings.brochure.faqs.placeholder':
    'Cómo agendo una visita? | Escríbenos por WhatsApp y coordinamos contigo.\nPublican propiedades en portales? | Sí, según el plan comercial de cada propiedad.',
  'websites.settings.brochure.externalLinks.placeholder':
    'Portal de propiedades | https://portal.example.com\nSitio asociado | https://partner.example.com',
  'websites.settings.contact.title': 'Información de contacto',
  'websites.settings.contact.description':
    'Datos públicos opcionales que las plantillas de sitio compatibles pueden mostrar.',
  'websites.settings.contact.address.label': 'Dirección',
  'websites.settings.contact.email.label': 'Correo electrónico',
  'websites.settings.contact.phone.label': 'Teléfono visible',
  'websites.settings.contact.businessHours.label': 'Horario de atención',
  'websites.settings.contact.instagramUrl.label': 'URL de Instagram',
  'websites.settings.contact.facebookUrl.label': 'URL de Facebook',
  'websites.settings.contact.tiktokUrl.label': 'URL de TikTok',
  'websites.settings.contact.validation.email':
    'Ingresa una dirección de correo válida.',
  'websites.settings.contact.validation.socialUrl':
    'Ingresa una URL completa que comience con http:// o https://.',
  'websites.settings.whatsApp.title': 'WhatsApp',
  'websites.settings.whatsApp.description':
    'El número que recibe los mensajes del sitio y el texto inicial de cada botón.',
  'websites.settings.whatsApp.phoneNumber.label': 'Número WhatsApp',
  'websites.settings.whatsApp.availableTokens':
    'Tokens disponibles: {tenantName}, {propertyTitle}, {propertyCode}, {propertyUrl}, {siteUrl}.',
  'websites.settings.whatsApp.cta.generalContact.label': 'Contacto general',
  'websites.settings.whatsApp.cta.generalContact.defaultMessage':
    'Hola, vengo desde {siteUrl} y quiero más información sobre {tenantName}.',
  'websites.settings.whatsApp.cta.propertyCard.label': 'Tarjeta de propiedad',
  'websites.settings.whatsApp.cta.propertyCard.defaultMessage':
    'Hola, me interesa la propiedad {propertyTitle} ({propertyCode}) que vi en {siteUrl}.',
  'websites.settings.whatsApp.cta.propertyDetail.label': 'Detalle de propiedad',
  'websites.settings.whatsApp.cta.propertyDetail.defaultMessage':
    'Hola, quiero consultar por {propertyTitle} ({propertyCode}) en {propertyUrl}.',
  'websites.settings.whatsApp.cta.scheduleVisit.label': 'Agendar visita',
  'websites.settings.whatsApp.cta.scheduleVisit.defaultMessage':
    'Hola, quiero coordinar una visita para {propertyTitle} ({propertyCode}).',
  'websites.settings.whatsApp.cta.aiHandoff.label': 'Handoff AI',
  'websites.settings.defaultContent.headline':
    'Encuentra tu próxima propiedad con {siteName}',
  'websites.settings.defaultContent.description':
    'Corredora de propiedades. Venta y arriendo de casas, departamentos, parcelas y oficinas.',
  'websites.settings.defaultContent.services.appraisal':
    'Tasación comercial con datos de tu comuna',
  'websites.settings.defaultContent.services.listing':
    'Fotos y publicación en este sitio y en los principales portales',
  'websites.settings.defaultContent.services.visits':
    'Visitas coordinadas y acompañadas',
  'websites.settings.defaultContent.services.closing':
    'Revisión legal y acompañamiento hasta la firma',
  'websites.settings.defaultContent.legalText':
    'Los valores, superficies, disponibilidad y características publicadas son referenciales y deben confirmarse con la corredora antes de cualquier operación.',
  'websites.settings.defaultContent.privacyText':
    'Cuando nos escribes por WhatsApp desde este sitio, recibimos tu número, tu nombre y tu mensaje. Los usamos solo para responder tu consulta y coordinar visitas, y nunca los vendemos.\n\nEste sitio funciona con Comos, que trata estos datos por encargo nuestro y registra los clics en los botones de WhatsApp para saber qué propiedades generan consultas. Puedes revisar la política de privacidad de Comos en comos.ai.\n\nPara pedir acceso a tus datos, corregirlos o eliminarlos, escríbenos por WhatsApp o por los medios de contacto de este sitio.',
  'websites.templatePreview.title': 'Vista previa con tus datos',
  'websites.templatePreview.iframeTitle': 'Vista previa de {templateName}',
  'websites.templatePreview.fallbackNotice':
    'Esta plantilla aún no expone una previsualización de paquete. Se muestra una vista alternativa con los metadatos del registro.',
  'websites.settings.page.notPublishedYet': 'Aún no está publicado',
  'websites.settings.page.unpublishedChanges': 'Tienes cambios sin publicar',
  'websites.settings.page.publishingChanges':
    'Publicando tus cambios: tu sitio se actualiza en unos minutos',
  'websites.settings.actions.openPreviewSheet': 'Vista previa',
  'websites.settings.actions.publishShort': 'Publicar',
  'websites.settings.actions.publishing': 'Publicando…',
  'websites.settings.actions.saveDraftShort': 'Guardar',
  'websites.settings.steps.label': 'Secciones',
  'websites.settings.steps.design': 'Diseño',
  'websites.settings.steps.brand': 'Marca',
  'websites.settings.steps.contact': 'Contacto y WhatsApp',
  'websites.settings.steps.content': 'Contenido',
  'websites.settings.steps.address': 'Dirección web',
  'websites.settings.design.title': 'Elige un diseño',
  'websites.settings.design.description':
    'Todos usan tus propiedades, tu logo y tu color. Prueba los que quieras: nada cambia en tu sitio hasta que presionas Publicar cambios.',
  'websites.settings.design.empty':
    'Aún no hay diseños disponibles para tu cuenta.',
  'websites.settings.design.badge.recommended': 'Recomendado',
  'websites.settings.design.badge.new': 'Nuevo',
  'websites.settings.design.badge.inUse': 'En uso',
  'websites.settings.design.actions.try': 'Probar este diseño',
  'websites.settings.design.actions.tryNamed': 'Probar {templateName}',
  'websites.settings.design.actions.viewExample': 'Ver ejemplo',
  'websites.settings.design.selected': 'En la vista previa',
  'websites.settings.design.thumbnailTitle': 'Miniatura de {templateName}',
  'websites.settings.design.technical.title':
    'Opciones técnicas · solo equipo Comos',
  'websites.settings.design.technical.renderer': 'Renderizador: {renderer}',
  'websites.settings.design.technical.registry':
    'Registro: {visibility} · {registryTemplateId}',
  'websites.settings.brand.title': 'Tu marca',
  'websites.settings.brand.description':
    'Con tu logo y un color basta: el diseño se ajusta solo.',
  'websites.settings.brand.color.title': 'Color de tu marca',
  'websites.settings.brand.color.description':
    'Lo usamos en botones, enlaces y detalles del sitio. Un solo color basta.',
  'websites.settings.brand.color.swatch.green': 'Verde',
  'websites.settings.brand.color.swatch.blue': 'Azul',
  'websites.settings.brand.color.swatch.terracotta': 'Rojo teja',
  'websites.settings.brand.color.swatch.yellow': 'Amarillo',
  'websites.settings.brand.color.swatch.violet': 'Violeta',
  'websites.settings.brand.color.swatch.black': 'Negro',
  'websites.settings.brand.color.sample': 'Así se ven tus botones',
  'websites.settings.brand.color.contrastLight':
    'Texto blanco: se lee bien sobre tu color.',
  'websites.settings.brand.color.contrastDark':
    'Tu color es claro: el texto oscuro se lee mejor sobre él.',
  'websites.settings.brand.color.invalid':
    'Ingresa un color HEX válido, por ejemplo #1E6B52.',
  'websites.settings.brand.secondaryColors.title':
    'Colores secundarios (opcional)',
  'websites.settings.brand.secondaryColors.description':
    'Algunos diseños usan un color secundario y uno de acento. Si no los necesitas, déjalos como están.',
  'websites.settings.brand.secondaryColor.label': 'Color secundario',
  'websites.settings.brand.accentColor.label': 'Color de acento',
  'websites.settings.brand.siteName.label': 'Nombre en el sitio',
  'websites.settings.brand.headline.label': 'Frase principal',
  'websites.settings.brand.headline.help':
    'Aparece grande en la portada. Di qué haces y dónde.',
  'websites.settings.brand.headline.tooLong':
    'Más de {max} caracteres puede verse largo en la portada.',
  'websites.settings.brand.headline.count': '{count} / {max}',
  'websites.settings.brand.description.label': 'Descripción corta',
  'websites.settings.brand.texts.title': 'Textos de la portada',
  'websites.settings.brand.texts.description':
    'El nombre, la frase principal y la descripción que ven tus clientes al entrar.',
  'websites.settings.brand.heroImage.title': 'Imagen de portada',
  'websites.settings.brand.heroImage.optional': '(opcional)',
  'websites.settings.brand.heroImage.help':
    'Pega el enlace de una imagen horizontal. Si lo dejas vacío, el diseño elige la imagen por ti.',
  'websites.settings.brand.heroImage.label': 'Enlace de la imagen',
  'websites.settings.contactStep.title': 'Contacto y WhatsApp',
  'websites.settings.contactStep.description':
    'Cómo te escriben tus clientes desde el sitio y qué datos de contacto ven.',
  'websites.settings.content.title': 'Contenido',
  'websites.settings.content.description':
    'Secciones opcionales de tu sitio. Las que dejes vacías no aparecen.',
  'websites.settings.content.sections.title': 'Secciones del sitio',
  'websites.settings.content.neighborhoods.label': 'Zonas destacadas',
  'websites.settings.content.neighborhoods.placeholder':
    'Santiago\nPuerto Varas\nValdivia',
  'websites.settings.content.services.label': 'Servicios',
  'websites.settings.content.services.placeholder':
    'Tasación comercial\nGestión de visitas\nAcompañamiento legal',
  'websites.settings.content.faqs.label': 'Preguntas frecuentes',
  'websites.settings.content.externalLinks.label': 'Enlaces externos',
  'websites.settings.content.legal.label': 'Texto legal',
  'websites.settings.content.legal.placeholder':
    'La información publicada es referencial y puede cambiar sin previo aviso.',
  'websites.settings.content.legalPage.title': 'Legal y privacidad',
  'websites.settings.content.legalPage.description':
    'Textos de la página Legal y privacidad de tu sitio.',
  'websites.settings.content.privacy.label': 'Texto de privacidad',
  'websites.settings.content.privacy.help':
    'Explica qué datos recibes de tus visitas, para qué los usas, quién más los recibe y cómo pueden pedir acceso, corrección o eliminación.',
  'websites.settings.content.formatHint':
    'Usa una línea por elemento. Para preguntas y enlaces usa el formato Título | Contenido.',
  'websites.settings.address.title': 'Dirección web',
  'websites.settings.address.provisional.title': 'Dirección provisional',
  'websites.settings.address.description':
    'Dónde encuentran tu sitio, tus dominios y el estado de la publicación.',
  'websites.settings.address.provisionalUrl': 'Tu sitio queda en {url}',
  'websites.settings.address.provisionalNotConfigured':
    'Dirección provisional no configurada',
  'websites.settings.noAccess.title': 'No tienes acceso a sitios web',
  'websites.settings.noAccess.description':
    'Necesitas el permiso de sitios web para ver esta configuración.',
  'websites.settings.previewSheet.title': 'Vista previa · {templateName}',
  'websites.settings.previewSheet.close': 'Cerrar vista previa',
  'websites.settings.previewSheet.hint':
    'Navega como lo haría un cliente: busca, abre fichas y prueba WhatsApp.',
  'websites.settings.previewSheet.realPreview': 'Ver con tus propiedades',
  'websites.settings.previewSheet.keepEditing': 'Seguir editando',
  'websites.settings.previewSheet.publish': 'Publicar',
  'websites.templatePreview.caption':
    'Así se verá {templateName} con tu logo y tu color, usando propiedades de ejemplo. Navega la vista previa para revisar el catálogo y las fichas.',
  'websites.templatePreview.captionLive':
    'Así se verá {templateName} al publicar, con tus textos, tu logo, tu color y tus propiedades. Navega la vista previa para revisar el catálogo y las fichas.',
  'websites.templatePreview.pendingPublish':
    'Estos cambios se publican cuando presionas Publicar cambios.',
  'websites.templatePreview.publishing':
    'Estamos publicando estos cambios. Tu sitio se actualiza en unos minutos.',
  'websites.templatePreview.device.desktop': 'Escritorio',
  'websites.templatePreview.device.mobile': 'Celular',
  'websites.templatePreview.noDesign':
    'Elige un diseño para ver cómo queda con tus datos.',
  'websites.templatePreview.openInNewTab': 'Abrir en pestaña nueva',

  // Websites - Domain setup
  'websites.settings.domains.title': 'Dominios',
  'websites.settings.domains.instructions.title':
    'Cómo conectar tu propio dominio',
  'websites.settings.domains.instructions.description':
    'Necesitas acceso a la configuración DNS de tu dominio, en el sitio donde lo compraste o lo administras. Por ahora se pueden conectar subdominios, como www.tudominio.com.',
  'websites.settings.domains.instructions.publish':
    'Publica tu sitio. El dominio solo se puede conectar a un sitio publicado.',
  'websites.settings.domains.instructions.addSubdomain':
    'Escribe el subdominio que quieres usar, por ejemplo www.tudominio.com, y presiona Agregar dominio. Escribe solo la dirección, sin https:// ni barras. El dominio sin www (tudominio.com) todavía no se puede conectar.',
  'websites.settings.domains.instructions.certificateRecord':
    'En unos minutos aparece abajo el registro del certificado de seguridad; si no lo ves, presiona Revisar estado. Créalo en tu DNS como registro CNAME, copiando el nombre y el valor tal como se muestran.',
  'websites.settings.domains.instructions.siteRecord':
    'Cuando el certificado esté aprobado, aparece el registro de tu sitio. Créalo también como CNAME: es el que hace que tu subdominio abra tu sitio.',
  'websites.settings.domains.instructions.automaticCheck':
    'Revisamos tu dominio automáticamente cada 15 minutos durante 6 horas, así que no necesitas quedarte en esta página. Cuando el estado diga Activo, tu sitio se abre con tu dominio. Si ya corregiste algo y no quieres esperar, presiona Revisar estado.',
  'websites.settings.domains.instructions.tip':
    'Si tu proveedor agrega tu dominio al final del nombre por su cuenta, escribe solo la primera parte. Por ejemplo, www en vez de www.tudominio.com.',
  'websites.settings.domains.newDomain.label': 'Nuevo dominio personalizado',
  'websites.settings.domains.newDomain.placeholder': 'www.tudominio.com',
  'websites.settings.domains.publishFirst':
    'Publica tu sitio para conectar un dominio.',
  'websites.settings.domains.errors.hostnameOnly':
    'Escribe solo la dirección, sin https:// ni barras.',
  'websites.settings.domains.errors.wildcard':
    'No se puede usar * en el dominio. Escribe el subdominio exacto, por ejemplo www.',
  'websites.settings.domains.errors.subdomainRequired':
    'Agrega un subdominio delante de tu dominio, por ejemplo www. El dominio sin www todavía no se puede conectar.',
  'websites.settings.domains.errors.invalidCharacters':
    'Usa solo letras sin tildes ni ñ, números, guiones y puntos.',
  'websites.settings.domains.actions.add': 'Agregar dominio',
  'websites.settings.domains.actions.reviewStatus': 'Revisar estado',
  'websites.settings.domains.type.provisional': 'Provisional',
  'websites.settings.domains.type.custom': 'Personalizado',
  'websites.settings.domains.status.provisional': 'Provisional',
  'websites.settings.domains.status.pendingDns': 'Esperando el certificado',
  'websites.settings.domains.status.pendingValidation': 'Conectando',
  'websites.settings.domains.status.active': 'Activo',
  'websites.settings.domains.status.error': 'Error',
  'websites.settings.domains.domainStatus': '{type} · {status}',
  'websites.settings.domains.provisionalManaged':
    'Dirección provisional. Nosotros la configuramos: no necesitas crear registros DNS.',
  'websites.settings.domains.records.certificate':
    'Registro del certificado de seguridad',
  'websites.settings.domains.records.site': 'Registro de tu sitio',
  'websites.settings.domains.records.type': 'Tipo',
  'websites.settings.domains.records.name': 'Nombre',
  'websites.settings.domains.records.value': 'Valor',
  'websites.settings.domains.hints.preparingCertificate':
    'Estamos pidiendo el certificado de seguridad. Su registro aparece aquí en unos minutos; si no lo ves, presiona Revisar estado.',
  'websites.settings.domains.hints.waitingCertificate':
    'Esperando que se apruebe el certificado. Revisa que el registro del certificado esté creado en tu DNS tal como se muestra. Los cambios de DNS pueden tardar en verse.',
  'websites.settings.domains.hints.siteRecordReady':
    'El certificado ya está aprobado. Crea el registro de tu sitio mientras terminamos de preparar tu dominio.',
  'websites.settings.domains.hints.waitingSiteRecord':
    'Tu subdominio todavía no abre tu sitio. Revisa que el registro de tu sitio esté creado en tu DNS tal como se muestra. Los cambios de DNS pueden tardar en verse.',
  'websites.settings.domains.hints.finishingHttps':
    'El registro de tu sitio ya funciona. Estamos terminando de activar la conexión segura (HTTPS).',
  'websites.settings.domains.hints.active':
    'Tu dominio está activo. No borres estos registros de tu DNS: mantienen tu dominio y su certificado funcionando.',
  'websites.settings.domains.hints.timedOut':
    'Dejamos de revisar después de 6 horas. Revisa que los registros estén creados tal como se muestran y presiona Revisar estado para intentarlo de nuevo.',
  'websites.settings.domains.hints.certificateFailed':
    'No se pudo aprobar el certificado de seguridad. Escríbenos y lo reiniciamos.',
  'websites.settings.domains.hints.unknownError':
    'No pudimos terminar de verificar tu dominio. Presiona Revisar estado para intentarlo de nuevo; si el problema sigue, escríbenos.',
  'websites.settings.domains.hints.detail': 'Detalle técnico: {detail}',
  'websites.settings.domains.alerts.createSuccess':
    'Dominio agregado. En unos minutos aparece el registro del certificado de seguridad.',
  'websites.settings.domains.alerts.createError':
    'No se pudo agregar el dominio.',
  'websites.settings.domains.alerts.verifySuccess':
    'Estamos revisando tu dominio de nuevo.',
  'websites.settings.domains.alerts.verifyError':
    'No se pudo verificar el dominio.',

  // Sidebar - Support & Navigation
  'support.shortLabel': 'Ayuda',
  'support.unreadLabel': '{label}, {count} mensajes sin leer',
  'support.loading': 'Estamos conectando con soporte…',
  'support.unavailable':
    'No pudimos abrir el chat. Puedes reintentar o escribirnos por WhatsApp.',
  'support.whatsapp': 'Contactar por WhatsApp',
  'support.retry': 'Recargar página',
  'sidebar.support.tooltip': 'Abrir ayuda',
  'sidebar.support.label': 'Necesito ayuda',
  'sidebar.pinToggle.pin': 'Fijar barra lateral',
  'sidebar.pinToggle.unpin': 'Contraer navegación',
  'sidebar.openNavigation': 'Abrir navegación',
  'sidebar.closeNavigation': 'Cerrar navegación',
  'sidebar.collapseMenu': 'Contraer menú',
  'sidebar.expandMenu': 'Expandir menú',
  'sidebar.loading': 'Cargando menú',
  'sidebar.support.message':
    'Hola, soy {userName} (ID: {userId}). Necesito ayuda con la plataforma',
  'sidebar.support.message.default': 'Hola, necesito ayuda con la plataforma',
  'sidebar.logout': 'Salir',
};
